{
  "accessibility": {
    "closeModal": "Fechar modal",
    "useSetting": "Utilize a definição",
    "srOnly": {
      "close": "Fechar",
      "loading": "A carregar…"
    }
  },
  "account": {
    "salesResources": {
      "title": "Recursos de Vendas",
      "searchDocuments": "Pesquisar documentos",
      "minimalRating": "Classificação Mínima",
      "maxRating": "Classificação máxima"
    },
    "saasRebilling": {
      "enableRebillingMessage": "Ative a faturação recorrente para este cliente para aumentar os lucros até 10 vezes com o uso de telefone, e-mails, automatizações, etc.",
      "enableRebilling": "Ativar faturação recorrente",
      "servicesActivateAfterPayment": "Os serviços de faturação recorrente ficarão ativos depois de o cliente adicionar um método de pagamento. Até lá, o acesso à conta do cliente será restrito.",
      "cannotModifyOnHold": "Não pode modificar as configurações de faturação recorrente porque esta conta já tem um plano SaaS em espera. As marcações da faturação recorrente serão configuradas de acordo com o plano quando o cliente adicionar um método de pagamento.",
      "rebillingSettings": "Definições de faturação recorrente"
    }
  },
  "affiliates": {
    "aboutMe": "Sobre mim",
    "error": {
      "unableToSend": "Não é possível enviar e-mail"
    },
    "industriesServed": "Indústrias servidas",
    "sendAMessage": "Enviar uma mensagem",
    "sendMessageIntro": "Envie uma mensagem para se apresentar a este consultor. Inclua detalhes acerca de si e os serviços que procura.",
    "socialSites": "Redes sociais",
    "success": {
      "emailSent": "E-mail enviado com sucesso"
    },
    "validationErrors": {
      "validEmail": "Indique um e-mail válido.",
      "validMessage": "Indique uma mensagem válida.",
      "validName": "Indique um nome válido."
    },
    "yearsInBusiness": "Anos de atividade",
    "yourEmail": "O seu e-mail",
    "yourName": "O seu nome",
    "paymentDetailsAccessMessage": " Esta secção de detalhes de pagamento só é acessível e editável pelo <strong>proprietário da agência</strong>. Se precisar de assistência, contacte o <strong>proprietário da agência ({ agencyOwnerEmail })</strong>.",
    "partnerBadgeAlt": "Distintivo de parceiro",
    "photoAlt": "Fotografia do parceiro",
    "defaultCompany": "Nenhuma empresa",
    "moreServices": "+ {count} mais serviços"
  },
  "agency": {
    "saas": {
      "saasMode": "Modo SaaS",
      "pendingPaymentInformation": "Informações sobre pagamentos pendentes",
      "customerId": "ID do cliente",
      "noPaymentMethods": "Não foram adicionados métodos de pagamento! Adicione um método de pagamento para ativar o modo SaaS",
      "enableSaasDescription": "Ative o SaaS nesta localização para criar subscrições, faturar de forma recorrente o uso de telefone e e-mail",
      "missingEmailAddress": "O endereço de e-mail da conta está em falta; adicione os detalhes primeiro.",
      "toConvertToSaaS": "Para converter esta conta para SaaS, primeiro tem de adicionar um administrador de localização e tentar novamente",
      "newUser": "Criar Novo Utilizador",
      "stripeCustomerConnected": "Cliente do Stripe ligado com sucesso!",
      "requestClientPaymentDetails": "Solicitar detalhes de pagamento do cliente",
      "saasLocationDescription": "As localizações em modo SaaS precisam do cartão de crédito do seu cliente para funcionar. Pode enviar um pedido por e-mail, mensagem de texto ou partilhando um URL",
      "selectSpace": "Selecione o espaço para continuar",
      "spaceDescription": "O espaço que selecionar aqui será utilizado para armazenar as informações deste cliente, processar os respetivos pagamentos e gerir as respetivas subscrições.",
      "stripe": "Stripe",
      "freeCreditsDescription": "Quando um utilizador se inscreve, pode oferecer-lhe créditos gratuitos para usar serviços de e-mail ou de telefonia.",
      "thatAboutMinsInCalls": "Isso é cerca de {count} mensagens ou {count1} minutos em chamadas",
      "subscriptionSettings": "Definições de subscrição",
      "toUpgradeOrCancelPlan": "Para fazer upgrade ou cancelar o plano",
      "allowClientUpgrade": "Permitir que o cliente (subconta) faça upgrade para um plano superior.",
      "addNewPlanFeatures": "Adicione novas características do plano ao fazer upgrade",
      "upgradeFeatureDescription": "Após fazer upgrade para um plano superior, as subcontas terão acesso às características adicionais do novo plano. acesso às funcionalidades adicionais no novo plano.",
      "allowClientCancel": "Permita que o cliente (subconta) cancele a respetiva subscrição.",
      "snapshotDescription": "O instantâneo selecionado será automaticamente adicionado à nova localização SaaS criada",
      "ownSnapshots": "Instantâneos próprios",
      "selectAndContinue": "Selecionar e continuar"
    },
    "advancedSettings": {
      "controlLocationSettings": "Controlar as definições de localização",
      "disableAddSmtp": "Desative o botão Adicionar serviço de e-mail nas definições de serviços de e-mail da subconta",
      "disableAddSmtpDescription": "Restrinja os utilizadores de subconta para adicionar o respetivo fornecedor de serviço de e-mail",
      "enableReVerification": "Ativar reverificação por 90 dias",
      "lcEmailNotEnabled": "A localização não tem o LeadConnector como fornecedor de e-mail predefinido",
      "onlyVisibleForAgency": "Só pode ver estas definições ativadas para a agência",
      "reVerificationDescription": "Todos os estados de verificação de e-mail serão revogados após 90 dias (proteja a reputação do remetente e garanta uma maior capacidade de entrega na caixa de entrada)",
      "account": {
        "accountDetails": "Detalhes da conta",
        "advancedEmailSettings": "Definições de e-mail avançadas",
        "hipaa": "HIPAA",
        "hipaaCompliant": "Em conformidade com a HIPAA",
        "smsEmailLimits": "Limites de SMS/e-mail",
        "socialProfiles": "Perfis em redes sociais",
        "subscribed": "Subscrita"
      },
      "activityTracking": {
        "history": "Histórico"
      },
      "addAccount": {
        "accountInfo": "Informações da conta",
        "accountSnapshots": "Instantâneos da conta",
        "businessNiche": "Nicho de negócios",
        "chooseBusinessNiche": "Escolher nicho de negócios...",
        "pickSnapshot": "Escolha um instantâneo",
        "selectSnapshot": "Selecionar instantâneo",
        "title": "Adicionar subconta",
        "accountInfo1": "Informações da conta"
      },
      "addBalance": {
        "addBalanceToWallet": "Adicionar saldo à carteira",
        "addMoneyToWallet": "Adicionar Dinheiro à Carteira",
        "balanceAddedSuccessfully": "Saldo adicionado com sucesso",
        "cardWillBeCharged": "Será cobrado o valor correspondente ao cartão que termina em {cardNumber}",
        "complimentaryCredits": "Créditos gratuitos ({credits})",
        "creditsRemovedByAgency": "Créditos removidos pela agência",
        "currentBalance": "Saldo atual",
        "customerCCWillNotBeCharged": "O cartão de crédito do cliente não será cobrado",
        "moneyWillBeAddedToWallet": "O dinheiro será adicionado à carteira",
        "pleaseProvideAmountBetween": "Introduza um valor entre {min} e {max}",
        "processing": "Em processamento",
        "removeBalance": "Remover saldo",
        "transactionSuccessful": "Transação bem-sucedida",
        "walletBalance": "Saldo da carteira ({balance})"
      },
      "addPaymentMethod": {
        "adding": "A adicionar...",
        "cardDetails": "Detalhes do cartão",
        "cardSuccessfullyAdded": "Cartão adicionado com sucesso",
        "errorWhileAddingCard": "Erro ao adicionar um novo cartão!",
        "maximumCardUpdateLimitReached": "Limite máximo de atualizações do cartão atingido",
        "rateLimitMessage": "Parece que atingiu o número máximo de tentativas permitidas para adicionar cartões hoje. Tente novamente após 24 horas."
      },
      "aiProductRebilling": {
        "funnel": " funil",
        "images": " Imagens,",
        "per1000Words": " /1000 palavras, ",
        "perFunnel": " /funil",
        "perImage": " /imagem,",
        "pleaseCheckSupport": "consulte o nosso",
        "ratesMayDiffer": "As taxas podem variar de acordo com a região. Os cálculos apresentados são de acordo com as taxas do Reino Unido,",
        "ratesMayDifferUS": "As taxas podem variar consoante a região. Os cálculos apresentados são baseados nas taxas do Twilio para os EUA. Por favor, consulte o Twilio para obter mais detalhes.",
        "pleaseCheckTwilioRates": "Os SMS para EUA/Canadá serão cobrados a 0,0079 $/segmento. Os SMS recebidos serão cobrados a 0,0075 $/segmento.",
        "words": " palavras, "
      },
      "api": {
        "advancedFunctionalityNote": "Nota de funcionalidade avançada",
        "agencyApiKeys": "API Keys de agência",
        "apiAccess": {
          "partOfAdvancedApi": "Isto faz parte da API avançada disponível no plano Pro.",
          "toUpgrade": "para fazer upgrade."
        },
        "createNew": "Criar nova",
        "developerCouncilInfo": "Informações do Conselho de Programadores",
        "noAccess": "Não tem acesso a esta secção.",
        "securityAlert": "Mensagem de alerta de segurança",
        "table": {
          "fetchingKeys": "A obter as chaves da empresa...",
          "noKeysYet": "Ainda não tem nenhuma chave de API.",
          "toCreateFirstKeys": "para criar as suas primeiras chaves de API."
        },
        "zapierNote": "Nota do Zapier"
      },
      "calendarBeta": {
        "abilityChooseGoogleCalendars": "Capacidade de escolher calendários Google para \"Adicionar a\" + calendários de \"Conflito\" para verificar e calcular a disponibilidade de todos os utilizadores",
        "abilityToAllocateRoundRobin": "Capacidade de alocar compromissos em distribuição sequencial",
        "abilityToChooseSpecificUser": "Capacidade de selecionar um utilizador específico com quem o compromisso deve ser marcado",
        "adminAbilitySeeEveryUser": "Administrador - Capacidade de ver os compromissos de calendário de todos os utilizadores",
        "adminAbilityViewAllCalendar": "Administrador - Capacidade de ver todos os compromissos de calendário do utilizador",
        "adminsCanDeleteIntegrations": "Os administradores podem eliminar quaisquer integrações que desejem, mas os utilizadores só podem remover as suas próprias",
        "adminsCanSeeAllIntegrations": "Os administradores podem ver todas as integrações independentemente de quem as criou, mas os utilizadores podem ver as integrações que criaram para si próprios",
        "contactDetailAppointments": "Detalhes do contacto > Compromissos (novo)",
        "conversationsScheduleAppointment": "Conversas > Agendar compromisso (novo)",
        "essentialConsiderations": "Considerações essenciais",
        "funnelsWebsitesCalendar": "Funis/Sítios Web > Calendário (Novo)",
        "helpReorientTriggers": "Durante a chamada, ajudaremos a reorientar os acionadores para se adaptarem à nova configuração do calendário",
        "iAgreeMessage": "Se estiver confortável com as alterações anteriormente mencionadas, clique em \"Concordo\" e comece a utilizar o Calendário (Beta) nesta localização",
        "integrationNew": "Integração (nova)",
        "loseAbilityToViewEdit": "Os utilizadores na nova versão vão perder a capacidade de \"ver/editar\" compromissos (criados na versão anterior) através do modal Detalhes da oportunidade, mas poderem continuar a realizar todas essas ações na página Compromissos",
        "newOldTriggersCoexist": "Os acionadores novos e antigos vão coexistir",
        "nonAdminAbilityViewPersonal": "Utilizador não administrador - Capacidade de ver apenas os seus compromissos pessoais (Dados atribuídos/Mapeamento de calendário em GESTÃO DA EQUIPA não têm impacto)",
        "nonAdminViewPersonalOnly": "Utilizador não administrador - Capacidade de ver apenas os seus compromissos pessoais",
        "notAtMoment": "De momento, não. Mas estamos a esforçar-nos ao máximo para o disponibilizar para telemóvel o mais rapidamente possível.",
        "oldAppointmentsCanBeViewed": "Os compromissos antigos podem ser visualizados na página de compromissos através de um botão de alternância.",
        "oldAppointmentsDisplayed": "Os compromissos antigos serão apresentados juntamente com os novos compromissos na mesma lista de compromissos",
        "oldCalendarVersionAppointments": "Versão antiga do calendário + Compromissos antigos",
        "onlyNewCalendarWidget": "Só pode ser adicionado um widget de novo calendário",
        "opportunityAddAppointment": "Oportunidade > Adicionar Compromisso (Novo)",
        "profilePageAdmin": "Página de perfil para administrador (novo)",
        "profilePageAllUsers": "Página de perfil (todos os utilizadores)",
        "providesAllOptions": "Fornece dados a todas as opções (Grupos + Serviços) necessárias para configurar o novo calendário",
        "reintegratingConnectionsRequired": "Pode ser necessário reintegrar todas as ligações assim que o calendário Beta for ativado para uma localização",
        "roundRobinHighlight": "A capacidade de distribuir compromissos de forma rotativa entre diferentes grupos de agentes é o principal destaque desta atualização.",
        "schedulingCalendarAppointments": "Agendamento > Calendário/Compromissos (Novos filtros + Alternar para mudar entre compromissos novos e antigos)",
        "settingsCalendarBeta": "Definições > Calendário (Beta)",
        "surfacingFirstTime": "Primeira apresentação",
        "teamManagementAdminOnly": "Gestão da equipa (disponível apenas para administradores)",
        "toggleOffNewVersion": "Desativar (nova versão)",
        "toggleOnOldVersion": "Ativar (versão antiga)",
        "whatChangesWithNewVersion": "Quais são as alterações da nova versão do calendário?",
        "whatDoesCalendarEntail": "O que inclui o calendário (versão beta privada)?",
        "whatHappensToOldAppointments": "O que acontece aos nossos compromissos antigos depois da transição?",
        "whatWillWeSeeMobile": "O que iremos ver no telemóvel durante a versão beta?",
        "willOldAppointmentsBeFactored": "Os compromissos antigos são considerados ao calcular a disponibilidade para os novos compromissos?",
        "willOldCalendarUrlsWork": "Os nossos antigos URLs de calendário continuam a funcionar depois da transição?",
        "willWeGetNewVersionMobile": "Vamos poder usar a nova versão no telemóvel durante a versão beta?",
        "yesOldSettingsPageContinues": "Sim. Na verdade, a antiga página de definições continua a existir, assim como a sua capacidade de fazer alterações lá. O widget de calendário antigo e o widget de novo calendário vão funcionar de forma independente, mas estarão em constante sincronização entre si para garantir um cálculo preciso da sua disponibilidade entre os dois sistemas. Para evitar confusões, encorajamos vivamente a utilizar os novos URLs sempre que possível, para que não tenha de monitorizar dois URLs diferentes para os mesmos conjuntos de utilizadores.",
        "yesSyncOnGoogleCalendar": "Sim, como a sincronização unidirecional está ativada, o calendário Google irá garantir que os horários indisponíveis sejam bloqueados."
      },
      "companyPlansModal": {
        "billedAnnually": "Faturado anualmente",
        "billedMonthly": "Faturado mensalmente",
        "changePlanFor": "Alterar plano para {locationName}",
        "notAuthorized": "Não tem autorização para executar esta ação. Apenas os utilizadores/administradores da agência e o administrador do local o podem fazer.",
        "payAnnually": "Pagar Anualmente",
        "payMonthly": "Pagar mensalmente"
      },
      "locationBillingHistory": {
        "billingHistory": "Histórico de faturação",
        "cardNo": "N.º do cartão",
        "errorWhileFetchingInvoices": "Erro ao obter faturas, clique para tentar novamente",
        "invoiceDescription": "Descrição da fatura",
        "invoiceNo": "N.º da fatura",
        "noInvoices": "Sem faturas",
        "refunded": "Reembolsado",
        "succeeded": "com sucesso",
        "view": "VER"
      },
      "locationWallet": {
        "autoRechargeWith": "Recarga automática com",
        "balance": "Saldo:",
        "credits": "Créditos",
        "seeTransactions": "Ver transações",
        "whenBalanceLowerThan": "quando o saldo for inferior a"
      },
      "mailTransactionModal": {
        "checkYourEmail": "Verifique o seu e-mail ({emails}).",
        "csvSentMessage": "Vamos enviar um ficheiro CSV para o seu e-mail. Geralmente, leva de 7 a 10 minutos.",
        "enterEmailAddress": "Introduzir endereço de e-mail",
        "exportAndSendCsv": "Exportar e enviar CSV",
        "exportTransactions": "Exportar transações",
        "itUsuallyArrives": "Geralmente, chega em 10 minutos.",
        "useCommasToSeparate": "Utilize vírgulas para separar vários e-mails."
      },
      "modifySubscription": {
        "cancelClientDescription": "Cancele a assinatura do seu cliente e feche a conta",
        "cancelDescription": "Cancele a sua assinatura e feche a conta",
        "cancelImmediately": "Cancelar imediatamente",
        "cancelNow": "Cancelar agora",
        "cancelSubscription": "Cancelar assinatura",
        "changedYourMind": "Mudou de ideias?",
        "changedYourMindClient": "Pode retomar a assinatura do seu cliente",
        "changedYourMindYou": "Pode retomar a sua assinatura",
        "confirmByTyping": "Confirme escrevendo {text} abaixo",
        "confirmCancellation": "Confirmar cancelamento",
        "modifySubscription": "Modificar assinatura",
        "modifyYourSubscription": "Modifique a sua assinatura",
        "resumeSubscription": "Retomar assinatura",
        "subscriptionWillBeCancelledOn": "Isto irá agendar o cancelamento da sua assinatura para {date}. Pode retomar a assinatura abortando o cancelamento agendado em qualquer altura.",
        "subscriptionWillBeCancelledOnClient": "Isto irá agendar o cancelamento da assinatura do seu cliente para {date}. Pode retomar a assinatura, juntamente com os seus clientes, abortando o cancelamento agendado em qualquer altura.",
        "subscriptionWillBeCancelledOnDate": "A sua assinatura será cancelada a {date}.",
        "subscriptionWillBeCancelledOnDateClient": "A assinatura do seu cliente será cancelada a {date}.",
        "subscriptionWillBeResumed": "A sua assinatura será retomada e começará a ser cobrada normalmente.",
        "subscriptionWillBeResumedClient": "A assinatura do seu cliente será retomada e ele começará a ser faturado normalmente.",
        "upgradeDescription": "Mude para um plano de assinatura superior",
        "weAreGladYouStaying": "Ficamos contentes por saber que vai ficar!",
        "nextBillingDate": "Próxima data de faturação: {date}",
        "cancelImmediatelyTitle": "Tem a certeza de que deseja cancelar a subscrição imediatamente?",
        "cancelNowDescription": "A sua subscrição está agendada para ser cancelada a {date}. Se optar por cancelar agora, a sua conta, incluindo todas as atividades de envio, como mensagens agendadas e e-mails, será interrompida imediatamente.",
        "cancelNowDescriptionClient": "A subscrição do seu cliente está agendada para ser cancelada em {date}. Se optar por cancelar agora, a conta do seu cliente, incluindo toda a atividade de saída, como mensagens agendadas e e-mails, será interrompida imediatamente.",
        "modifyDescription": "Pode {action} a sua subscrição",
        "modifyDescriptionClient": "Pode {action} a subscrição do seu cliente"
      },
      "noPaymentMethodWarning": {
        "addNow": "Adicionar agora",
        "youNeedToEnterCardInfo": "Tem de introduzir as informações do seu cartão.",
        "youNeedToEnterClientCardInfo": "Tem de introduzir as informações do cartão do seu cliente."
      },
      "productRebilling": {
        "chargesBasedOnTokens": "As cobranças são baseadas em tokens. As contagens de palavras apresentadas abaixo são estimativas para ajudar a compreender a utilização. Os custos reais podem variar.",
        "examplePricingGpt4oMini": "Exemplo de preços - GPT-4o Mini",
        "for750kWords": "(para 750 000 palavras) ",
        "gpt4oMini": " GPT-4o-mini ",
        "input": "Entrada",
        "or": "ou ",
        "output": "Saída",
        "perImage": " /Imagem",
        "perResultSelection": " /Seleção de resultados",
        "ratesMayDifferUK": "As taxas podem variar de acordo com a região. Os cálculos apresentados são de acordo com as taxas do Reino Unido, consulte o nosso",
        "ratesMayDifferUS": "As taxas podem variar de acordo com a região e o tipo de número. Cálculos apresentados de acordo com as taxas Twilio para os EUA,",
        "pleaseCheckSupport": "consulte o nosso",
        "resultSelection": " Seleção de resultados",
        "supportDoc": "documento de suporte",
        "forMoreDetails": "para obter mais detalhes",
        "words": " palavras"
      },
      "removePaymentMethod": {
        "endingIn": "Termina em *{cardNo}",
        "no": "Não",
        "removeCard": "Remover cartão?",
        "removing": "A remover...",
        "yesRemove": "Sim, remover"
      },
      "requestSaasModal": {
        "requestClientPaymentDetails": "Solicitar detalhes de pagamento do cliente",
        "saasLocationDescription": "Configure uma assinatura SaaS para esta localização",
        "selectSpace": "Selecionar espaço",
        "spaceDescription": "Escolha onde pretende configurar a faturação para esta localização"
      },
      "saasEnableProducts": {
        "disable": "Desativar",
        "enableDisableProducts": "Ativar/desativar produtos",
        "feature": "Caraterística",
        "unsavedChanges": "Alterações não guardadas"
      },
      "saasSubscriptionPlan": {
        "agencyStripeFailed": "A próxima faturação para este cliente parece estar no passado. Isto acontece quando a conta Stripe da sua agência não funciona corretamente. Inicie sessão na conta Stripe da sua agência para corrigir esta situação.",
        "copiedText": "texto copiado:",
        "couldNotCopy": "Async: Não foi possível copiar o texto: ",
        "multiplier": " X ",
        "nextBillingDatePrefix": " Próxima data de faturação: ",
        "plan": "Plano",
        "pleaseContactAgency": "Contacte a agência para ativar a sua assinatura.",
        "stripeSubscriptionId": "ID da assinatura Stripe:",
        "subscriptionPlans": "Planos de assinatura",
        "subscriptionWillBeCancelledOn": "A sua assinatura será cancelada a {date}",
        "subscriptionWillBeCancelledOnClient": "A assinatura do seu cliente será cancelada a {date}",
        "toModifyClientSubscription": "para modificar a assinatura do seu cliente",
        "toModifyYourSubscription": "para modificar a sua assinatura",
        "whatsappNumberSubscription": "Assinatura do número WhatsApp",
        "yourBillingDatePast": "A sua próxima data de faturação parece estar no passado. Contacte {email} para corrigir esta situação. Entretanto, tudo continuará como habitualmente."
      },
      "salesResources": {
        "certifiedUser": "Utilizador certificado",
        "clearFilter": "Limpar filtro",
        "dateRange": "Intervalo de datas"
      },
      "upgradePlanProcessedModal": {
        "paymentInfo": "Irá pagar {amount} $/mês faturado {interval}",
        "planUpgradeFailed": "Não foi possível fazer um upgrade do seu plano!!",
        "planUpgraded": "Foi feito um upgrade do seu plano!",
        "retryUpgrade": "Repetir atualização",
        "upgradeFailed": "Falha no upgrade do seu plano. Tente novamente",
        "upgradedSuccessfully": "Fez um upgrade bem-sucedido do seu plano {oldPlan} para {newPlan}"
      },
      "upgradePlanSelectionModal": {
        "billedAsMonthlyCharge": "faturado como custo mensal de {amount} /mês",
        "billedAsYearlyCharge": "faturado como custo anual de {amount} /ano",
        "upgradeFrom": "Fazer upgrade de",
        "whatYouWillGet": "O que vai receber:"
      },
      "walletTransactionModal": {
        "balanceAfterTransaction": "Saldo após a transação:",
        "callDuration": "Duração da chamada:",
        "callSid": "SID da chamada:",
        "charge": "Custo:",
        "contact": "Contacto:",
        "contactName": "Nome do contacto:",
        "contactPhone": "Telefone do contacto:",
        "credit": "Crédito:",
        "creditsAfterTransaction": "Créditos após a transação:",
        "dateSent": "Data de envio",
        "deleted": "<Deleted>.",
        "discount": "Desconto:",
        "eventId": "ID do evento:",
        "from": "De:",
        "noContactFound": "Nenhum contacto encontrado",
        "noOfSegments": "N.º de segmentos:",
        "openContactPage": "Abrir página de contacto",
        "openConversation": "Abrir conversa",
        "openEvent": "Abrir evento",
        "originalCharge": "Custo original:",
        "received": "Recebido",
        "smsSid": "SID do SMS:",
        "timeBilled": "Tempo faturado:",
        "timeOfCall": "Hora da chamada",
        "transactionDetails": "Detalhes da transação -",
        "transactionId": "ID da transação:",
        "type": "Tipo:",
        "segments": "Segmentos"
      },
      "calendarSettings": {
        "meetings": "Reuniões",
        "services": "Serviços",
        "hideCalendarWarning": "Se pretender ocultar totalmente o módulo de calendário, pode fazê-lo em Definições da subconta > a minha equipa > funções e permissões",
        "calendarSettingsUpdated": "Definições do calendário foram atualizadas",
        "meetingDescription": "Ative esta opção para permitir que as subcontas utilizem a característica Reuniões, concebida para gerir calendários de vendas, chamadas de integração, agendamento de distribuições sequenciais, colaborações de equipas, marcações de aulas, entrevistas e muito mais. Ideal para empresas que necessitam de ferramentas de agendamento flexíveis e colaborativas.",
        "serviceDescription": "Ative os Serviços para dar às subcontas acesso a uma solução completa de marcações para empresas baseadas em serviços. Isto inclui a criação de páginas de marcações com múltiplos serviços, a gestão de recursos, o tratamento de múltiplas localizações, a definição de preços específicos para as equipas, a adição de variações de serviços ou complementos e muito mais."
      }
    },
    "apiKeys": {
      "apiKey": "ApiKey",
      "copied": "Copiado!",
      "copyApiKey": "Copiar Api Key",
      "createApiKey": "Criar API Key",
      "deleteAllKeys": "Eliminar todos os tokens",
      "nameRequired": "O campo nome é obrigatório.",
      "somethingWentWrong": "Desculpe! Algo correu mal! Tente novamente.",
      "updatedSuccessfully": "Atualizado com sucesso"
    },
    "billing": {
      "accountPaused": "A sua conta {name} foi colocada em pausa.",
      "accountProvisioned": "A sua conta está a ser preparada.",
      "activateSubAccount": "Ativar subconta",
      "activeServices": "Serviços ativos",
      "addNewCard": "Adicionar novo cartão",
      "addNewService": "Adicionar novo serviço",
      "addPaymentMethod": "adicione um método de pagamento",
      "alertIcon": "alertIcon",
      "approve": "Aprovar",
      "authenticateCardMessage": "Para maior segurança, tem de autenticar novamente os detalhes do seu cartão.",
      "badActorWarning": "Se acredita que esta subconta foi criada por um agente malicioso, recomendamos que a elimine e que cancele a assinatura correspondente.",
      "callUs": "Contacte-nos",
      "cancelAndDelete": "Cancelar assinatura e eliminar subconta",
      "completeFormNextStep": "Preencha o formulário no próximo passo",
      "congratulations": "🎉 Parabéns! 🎉",
      "contactAgency": "Contacte a sua agência para resolver este problema",
      "contactThroughEmailOrPhone": "Pode contactar-nos por e-mail ou telefone para resolver isto",
      "dataSafe": "Todos os seus dados estão seguros e todas as automatizações, páginas Web, etc. retomarão o funcionamento após o pagamento bem-sucedido.",
      "declineSubAccount": "Recusar a subconta",
      "deleteRecommendation": "É recomendado eliminar esta subconta. Também pode fazê-lo mais tarde na página Subcontas > Gerir cliente.",
      "emailUsAt": "Envie-nos um e-mail para",
      "moveToDashboard": "Mover para o painel de controlo",
      "noPaymentMethods": "Não foram adicionados métodos de pagamento! Por favor,",
      "paymentMethod": "Método de pagamento",
      "paymentMethodUpdated": "O seu método de pagamento foi atualizado",
      "paymentNotCompleted": "Está a ver esta mensagem porque o pagamento não foi concluído.",
      "proceedToNextStep": "Continuar para o próximo passo",
      "questionMark": "?",
      "reachOutMessage": "não hesite em entrar em contacto connosco em caso de qualquer dúvida.",
      "reactivateBillingFor": "Reativar a faturação para {location}",
      "retryPayment": "Repetir pagamento",
      "secureSystemMessage": "Mudámos para um sistema de faturação mais seguro.",
      "setupMessage": "Alguém entrará em contacto consigo para configurar a conta. Normalmente, demora entre 12 e 24 horas,",
      "signout": "Terminar sessão",
      "subAccountId": "ID da subconta:",
      "successfullyInitiated": "{product} foi iniciado com sucesso",
      "systemError": "Há um erro de sistema",
      "toReactivate": "para reativar a conta",
      "userImage": "userImage",
      "verificationSkipped": "A verificação por e-mail e telefone será ignorada para esta subconta e o cliente poderá aceder à mesma.",
      "verifyAccount": "Verificar conta",
      "verifyAfterAttempt": "Pode verificar esta conta depois de pelo menos uma tentativa de verificação do administrador da subconta",
      "verifySubAccount": "Verificar a subconta",
      "recommendedPlans": "Planos recomendados",
      "buildYourOwnPlan": "CRIE O SEU PRÓPRIO PLANO",
      "resetToDefaults": "Repor como valores predefinidos",
      "paymentMethodChange": "Se precisar de alterar o método de pagamento",
      "approveSubAccount": "Aprovar a subconta",
      "approveSubAccountDescription": "A subconta será retomada e os administradores da subconta poderão aceder à mesma e utilizá-la.",
      "productInitiated": "Produto Iniciado"
    },
    "deleteConfirmation": {
      "actionCannotBeReversed": "Esta ação não pode ser revertida.",
      "cancelKeep": "Cancelar, Manter",
      "confirmDeletionInstructions": "Confirme a eliminação escrevendo {word} abaixo:",
      "enterConfirm": "Introduza {word} para regenerar",
      "message": "Esta api key de localização será eliminada.",
      "title": "Eliminação api key de localização?",
      "yesDelete": "Sim, eliminar"
    },
    "generalDetails": {
      "noPermission": "Não tem permissão para carregar o ficheiro. Verifique as suas permissões junto do administrador da sua agência.",
      "relatedContacts": "Contactos relacionados ({count})"
    },
    "locationApiKeys": {
      "deleteAllConfirmMessage": "Tem a certeza de que pretende eliminar todas as api keys de localização?",
      "deleteAllConfirmTitle": "Eliminar todas as API keys de localização?",
      "deleteConfirmMessage": "Isto irá eliminar a api key da localização: {location}. Deseja continuar?",
      "deleteAgencyApiKeyConfirmMessage": "Isto irá eliminar a api key. Pretende continuar?",
      "fetchingLocations": "A obter localizações...",
      "maxApiKeysMessage": "Pode ter um máximo de 5 API Key.",
      "noLocationsFound": "Nenhuma localização encontrada",
      "old": "Antigo",
      "proPlanRequiredMessage": "Isto faz parte da API avançada disponível no plano Pro.",
      "searchLocation": "Pesquisar localização",
      "title": "API Key de localização"
    },
    "locationCard": {
      "deletionScheduledMessage": "Esta subconta será eliminada em {date}, se tiver mudado de ideias -",
      "emailUsageNotRebilled": "O uso de e-mail não está a ser faturado de forma recorrente",
      "emailUsageRebilled": "A utilização do email está a ser faturada de forma recorrente ao seu cliente",
      "listings": "Listagens",
      "manageClient": "Gerir cliente",
      "paymentPending": "O pagamento está pendente",
      "remainingWalletBalance": "Saldo restante da carteira desta localização SaaS",
      "requestPaymentAgain": "Solicitar pagamento novamente",
      "saasModeActivated": "O modo SaaS está ativado",
      "saasModeNotActivated": "O modo SaaS não está ativado",
      "saasSubscriptionNotEnabled": "O plano de assinatura SaaS não está ativo",
      "saasSubscriptionRunning": "O plano de assinatura SaaS está ativo",
      "social": "Rede social",
      "switchToSaaS": "Mudar para SaaS",
      "switchToSubAccount": "Mudar para subconta",
      "telephoneUsageNotBilled": "A utilização do telefone não está a ser faturada",
      "telephoneUsageRebilled": "A utilização do telefone está a ser faturada de forma recorrente ao seu cliente",
      "wordpressActive": "WordPress ativo",
      "wordpressInactive": "WordPress inativo",
      "wordpressNotSoldYet": "WordPress ainda não vendido",
      "wordpressSaleSuccessful": "Venda do WordPress concluída com sucesso",
      "yextActive": "Yext ativo",
      "yextInactive": "Yext inativo",
      "yextNotSoldYet": "Yext ainda não vendido",
      "yextSaleSuccessful": "Venda da Yext concluída com sucesso",
      "reviews": "Revisões"
    },
    "messageUsage": {
      "acceptTnc": "Aceite os Termos e Condições",
      "cannotPerformAction": "Não é possível realizar esta ação. Por favor, contacte o suporte.",
      "currentLimit": "Limite atual",
      "days": "Dia(s)",
      "failedToUpdate": "Falha ao Atualizar o uso de mensagens",
      "helpCentre": "Centro de ajuda",
      "increaseLimitFurther": "Aumente o Limite Ainda Mais",
      "increaseLimitNow": "Aumentar limite agora",
      "lessThanUsage": "O uso atual é {usage} e o uso selecionado é inferior ao uso atual.",
      "lessThanUsageModal": "O uso atual é {usage}, o limite não pode ser inferior ao uso atual",
      "limitAlreadyUnlocked": "O limite já está desbloqueado",
      "limitReached": "Limite atingido",
      "limitUpdatedFrom": "{type} limite atualizado de {old} para {new}",
      "lookingForSmsLimit": "Procura o limite de SMS?",
      "minLimitShould": "O limite mínimo deve ser {limit}",
      "newLimit": "Novo limite de {type}",
      "perDay": "/ Dia",
      "sameLimit": "O limite selecionado é igual ao limite atual!",
      "smsLimitLocation": "Já pode encontrar o limite de SMS ao nível da localização",
      "smsLimitSettingsInfo": "Agora, pode encontrar estas definições em \"Limite de Mensagens\" em \"Definições Avançadas\"",
      "timesInLast30Days": "Vezes nos últimos 30 dias",
      "todaysUsage": "Uso de hoje",
      "typePerDay": "{type} / Dia",
      "updateLimit": "Atualizar limite",
      "updateLimitFor": "Atualizar o limite de {type} para {name}"
    },
    "prospectDetails": {
      "activeCampaignsWorkflows": "Ativo {type}",
      "contactSource": "Fonte de contacto",
      "customer": "Cliente",
      "noPastCampaignsWorkflows": "Sem {type} anterior",
      "pastCampaignsWorkflows": "Passado {type}"
    },
    "settings": {
      "affiliateSettings": "Definições de afiliado",
      "agencyBilling": "Faturação da agência",
      "agencyTeamManagement": "Gestão da equipa da agência",
      "apiKeys": "API Keys",
      "compliance": "Conformidade",
      "customMenuLink": "Ligação de menu personalizado",
      "launchpadSettings": "Configurações do Launchpad",
      "phoneSystemTwilio": "Sistema telefónico - Twilio",
      "smtpService": "Serviço SMTP",
      "userSettings": "Configurações do Utilizador",
      "agencySettings": "Definições de agência",
      "mailgun": "MailGun"
    },
    "snapshot": {
      "errorCreating": "Erro ao criar instantâneo",
      "pickAnAccount": "Tem de selecionar uma conta.",
      "snapshotName": "Nome do instantâneo",
      "snapshotNameRequired": "Tem de dar um nome ao instantâneo."
    },
    "socialDetails": {
      "blogRss": "RSS do Blogue",
      "foursquare": "Foursquare",
      "foursquareUrl": "URL do Foursquare",
      "googlePlacesId": "ID do Google Places",
      "googlePlus": "Google+",
      "googlePlusUrl": "Google+ URL",
      "instagramUrl": "URL do Instagram",
      "linkedInUrl": "URL do LinkedIn",
      "pinterest": "Pinterest",
      "pinterestUrl": "URL do Pinterest",
      "yelp": "Yelp",
      "yelpUrl": "Yelp URL",
      "youTube": "YouTube"
    },
    "requestSms": "Pedido via SMS",
    "iAlreadyHaveACustomer": "Já tenho um cliente",
    "noAccountFound": "Nenhuma conta encontrada!",
    "thisIs": "Isto é",
    "pleaseEnterValueBetween0To30Days": "Por favor, introduza um valor entre 0 e 30 dias",
    "learnHowToAddOneTimeSetupFeeToThesePlans": "Saiba como adicionar uma taxa de configuração única a estes planos",
    "doNotDeleteStripeProductsWarning": "<span style=\"font-weight: bold;\">Não elimine</span> estes produtos na sua conta Stripe",
    "opportunityStats": "Estatísticas de oportunidades",
    "createNewSnapshot": "Criar novo instantâneo",
    "stripeSettings": {
      "agencyDashboardVisibleTo": "Painel de controlo da agência visível para",
      "onlyMe": "Só eu",
      "allAgencyAdmins": "Todos os administradores da agência",
      "stripeConnect": "Será descontinuado em breve. Mudar para Stripe Connect",
      "recommendStripe": "Recomendamos a utilização do Stripe Connect para uma melhor segurança",
      "switchToStripeConnect": "Mudar para Stripe Connect",
      "highLevelAccess": "A HighLevel terá acesso aos seus dados e poderá criar pagamentos e clientes em seu nome",
      "stripeAccountWarning": "Uma vez ligada, a conta Stripe não pode ser alterada posteriormente. Recomenda-se a utilização de uma nova conta Stripe dedicada aos ganhos do Highlevel.",
      "connectToStripeAccount": "Ligue-se à sua conta Stripe",
      "unverified": "A conta Stripe ligada a esta agência não está verificada e não pode receber pagamentos. Complete a verificação iniciando sessão na sua conta Stripe.",
      "loginToStripe": "Inicie sessão no Stripe",
      "connectedAccount": "Conta ligada",
      "verified": "VERIFICADO",
      "totalPendingBalance": "Saldo total pendente",
      "disconnectStripe": "Desligar Stripe",
      "removeSaasPlanConfigurations": "Remover todas as configurações do plano SaaS?",
      "haveSaasPlans": "Tem planos SaaS criados na conta Stripe!",
      "disconnectWarning": "Se o desligar, todos os planos SaaS serão perdidos e precisará de os criar novamente.",
      "acknowledgeDisconnect": "Reconheço que todos os meus planos SaaS serão perdidos e que terei de os reconstruir",
      "disconnect": "Desligar"
    },
    "zoomSuccess": {
      "title": "Espero que tenha tido uma ótima experiência!",
      "message": "Obrigado por participar na chamada. Estamos ansiosos por voltar a recebê-lo!"
    },
    "supportDashboard": {
      "trialExperienceSpecialist": "O seu especialista em experiência de avaliação",
      "successSpecialist": "O seu especialista em sucesso",
      "supportSpecialist": "O seu especialista de Suporte",
      "jumpOnZoomCall": "Participe numa chamada Zoom comigo para a sua chamada inicial",
      "jumpOnChat": "Converse comigo para obter ajuda",
      "joinVideoCallNow": "Participar na chamada de vídeo agora",
      "whatToExpect": "O que pode esperar?",
      "helpArticles": "Artigos de ajuda",
      "changelog": "Changelog",
      "ideasBoard": "Quadro de ideias"
    },
    "saasDashboard": {
      "title": "Painel de controlo SaaS",
      "plansAndPricing": "Planos e preços"
    },
    "listAccounts": {
      "newInterfaceAvailable": "Uma interface mais simples e rápida está agora disponível para esta página. Experimente!",
      "enableInLabs": "Ativar no Labs",
      "pendingTransferRequests": "Tem pedidos de transferência de subconta pendentes.",
      "otherAgenciesRequested": "Outras agências solicitaram a transferência de subcontas para si.",
      "reviewRequests": "Pedidos de revisão",
      "clientList": "Lista de clientes (subcontas)",
      "subAccountTransfers": "Transferências de subcontas"
    },
    "implementationModal": {
      "title": "A sua experiência de chamada de vídeo HighLevel está prestes a começar!",
      "videoCall": "Chamada de vídeo",
      "whatsNext": "O que acontece a seguir?",
      "enteringLobby": "Entrará no nosso lobby com outros utilizadores da HighLevel como você!",
      "successConcierge": "O nosso Concierge de Sucesso irá recebê-lo e pô-lo em contacto com o próximo consultor disponível para uma sessão individual.",
      "haveReady": "Tenha os seguintes elementos à mão",
      "stableInternet": "Ligação à Internet estável.",
      "videoNameMatches": "O nome do seu vídeo coincide com o seu nome de utilizador HighLevel.",
      "estimatedDuration": "Duração estimada da sessão",
      "firstVisit": "Primeira visita: sessão de integração da HighLevel: (45-60 minutos).",
      "returning": "Visita adicional: continuação da assistência na configuração de Implementação (15-25 minutos).",
      "meetingBegins": "A sua reunião começará automaticamente em  <span class=\"text-[#155EEF]\">{ countdown }</span> segundos.  Ou pode entrar imediatamente clicando no botão abaixo:",
      "joinNow": "Entrar agora"
    },
    "gdpr": {
      "logo": "Logótipo do GDPR",
      "dataProtection": "Proteção de dados e GDPR",
      "introduction": "Introdução",
      "intro1": "A HighLevel está empenhada em proteger a privacidade dos nossos utilizadores e dos respetivos clientes. Mantemo-nos informados sobre os desenvolvimentos nas leis de proteção de dados para garantir que possa ter confiança na sua segurança ao usar a nossa plataforma.",
      "intro2": "Esta página destina-se a explicar quais são as regras, como se aplicam à sua utilização da plataforma HighLevel e os passos que tomámos para garantir a conformidade.",
      "intro3": " Deve rever este documento em conjunto com a nossa Política de Privacidade e contactar um especialista jurídico se necessitar de mais informações ou aconselhamento.",
      "gdprRegulation": "Regulamento Geral de Proteção de Dados (GDPR)",
      "regulation1": "O Regulamento (UE) 2016/679, mais conhecido como Regulamento Geral de Proteção de Dados (GDPR), é um regulamento da UE que visa harmonizar as leis de proteção de dados e privacidade em toda a UE. As disposições do GDPR aplicam-se sempre que estejam envolvidos dados pessoais de um titular de dados da UE.",
      "regulation2": "O GDPR visa dar aos indivíduos mais controlo sobre a forma como os seus dados são usados pelas empresas e tornar a recolha e processamento de dados mais transparentes.",
      "regulation3": "O GDPR foi incorporado diretamente na legislação do Reino Unido após o final do período de transição do Brexit, o que significa que as empresas do Reino Unido ainda têm de cumprir as suas disposições de acordo com o \"GDPR do Reino Unido\".",
      "basicConcepts": "Conceitos básicos do GDPR",
      "controllerAndProcessor": "Responsável pelo tratamento e subcontratante",
      "controllerProcessorObligation": "O GDPR impõe várias obrigações a um indivíduo, dependendo se é um responsável pelo tratamento ou o um subcontratante de dados pessoais.",
      "controllerDefinition": " Um responsável pelo tratamento é uma entidade que decide processar dados pessoais e que toma decisões quanto ao fundamento do processamento e os métodos que serão utilizados. Os responsáveis pelo tratamento têm certas obrigações relativamente aos dados pessoais, com as quais se deve familiarizar antes de recolher dados pessoais dos seus clientes.",
      "processorDefinition": "Um subcontratante é uma entidade que processa dados para e em nome de um responsável pelo tratamento. Não toma decisões independentes em relação aos dados ou ao seu processamento, dado que apenas os processa em nome do responsável pelo tratamento e tem de cumprir todas as instruções fornecidas pelo responsável pelo tratamento.",
      "youAreController": "Quando usa o serviço HighLevel, é um responsável pelo tratamento. Tem controlo dos dados que carregar para o sistema HighLevel, o que faz com esses dados e porquê. Como resultado, é responsável por garantir que tem uma base legal para processar os dados e que não retém os dados por mais tempo do que o necessário.",
      "highlevelIsProcessor": "Deve garantir que compreende as suas obrigações como responsável pelo tratamento e atualizar os seus próprios sistemas e políticas para permitir a transferência legal de dados pessoais para a HighLevel. A HighLevel é um subcontratante de dados. Nós, através da plataforma HighLevel, armazenamos e gerimos os dados que recolheu de acordo com as suas instruções. Nunca utilizaremos quaisquer dados pessoais que tenha carregado no sistema HighLevel para os nossos próprios fins ou sem a sua instrução.",
      "legalBasisForProcessing": "Fundamento jurídico para o processamento",
      "legalBasisRequirement": "Os dados pessoais só podem ser recolhidos e processados se houver um fundamento jurídico para tal. Os fundamentos jurídicos são definidos no GDPR.",
      "processorReliesOnCustomers": "Como subcontratante, a HighLevel depende dos nossos clientes para selecionar o fundamento correto sob o qual irão recolher e processar dados pessoais e para implementar os avisos e consentimentos apropriados. Antes de utilizar o serviço HighLevel, deve dedicar algum tempo a identificar os fundamentos jurídicos que podem estar disponíveis para si, e apenas recolher e conservar dados pessoais na medida necessária para cumprir esse fundamento. Não deve alterar o fundamento sob o qual recolheu dados pessoais sem um motivo muito bom, por isso é importante compreender os requisitos dos diferentes fundamentos e certificar-se de que seleciona o correto desde o início.",
      "dataSubjectAccessRights": "Direitos de acesso dos titulares dos dados",
      "dataSubjectRights": "O GDPR concede aos titulares dos dados (ou seja, os seus clientes) certos direitos relativos aos respetivos dados pessoais, incluindo o direito de acesso, corrigir e/ou eliminar quaisquer dados relativos aos mesmos.",
      "highlevelEasySystems": "A HighLevel implementou sistemas simples para que o utilizador nos possa informar se receber tal pedido de um titular de dados, e para que o possamos informar se recebermos tal pedido. Garantiremos que, no seguimento das suas instruções, estes pedidos serão atendidos imediatamente. Deve familiarizar-se com as obrigações que lhe serão impostas, incluindo as relativas a quaisquer dados pessoais que mantenha nos seus próprios sistemas ou noutros serviços que não sejam da HighLevel.",
      "transfersToUSA": "Transferências de dados para os EUA",
      "transfersRestrictions": "Os dados pessoais não podem ser transferidos para fora do Espaço Económico Europeu (EEE), exceto em circunstâncias específicas. Utilizamos as Cláusulas Contratuais Padrão como parte do nosso Acordo de Processamento de Dados que celebramos com todos os nossos clientes.",
      "dataSecurity": "Segurança de dados",
      "securitySafeguards": "Implementámos salvaguardas e medidas de segurança rigorosas para garantir que quaisquer dados pessoais que detivermos sejam armazenados de forma segura. Testamos regularmente os nossos produtos para identificar erros e vulnerabilidades.",
      "backupSystems": "Garantimos que temos sistemas de backup padrão implementados e asseguramos que temos sistemas e processos de recuperação e integridade de dados para minimizar o risco de corrupção ou perda de dados pessoais.",
      "stepsForCompliance": "Medidas que tomámos para garantir a conformidade com o GDPR",
      "dutyAsProcessor": "Levamos muito a sério as nossas funções como subcontratante. Implementámos vários procedimentos e tomámos várias medidas para garantir a conformidade com o GDPR e que pode legalmente enviar-nos dados pessoais recolhidos por si, por exemplo:",
      "standardContractualClauses": "O nosso acordo de processamento de dados utiliza as cláusulas contratuais padrão para garantir que nos pode enviar legalmente dados pessoais para os EUA.",
      "detectBreaches": "Somos capazes de detetar violações pessoais e de informar os nossos clientes o mais rapidamente possível.",
      "dealWithAccessRequests": "Somos capazes de lidar com pedidos de acesso do titular dos dados e pedidos de direitos de apagamento, e de garantir que o informamos quando um titular dos dados nos fizer tal pedido.",
      "assessedDocumented": "Avaliámos e documentámos os dados pessoais processados por nós em seu nome.",
      "assessedSecurity": "Avaliámos a nossa segurança e atualizámo-la sempre que necessário para garantir que é adequada ao nível de risco que enfrentamos em relação a uma violação de dados.",
      "dataProcessingAgreement": "Acordo de processamento de dados",
      "dateUpdated": "Data de atualização: 1 de abril de 2023",
      "downloadAgreement": "Descarregar Acordo",
      "supportEmail": "support{'@'}gohighlevel.com",
      "anyQuestions": "Alguma dúvida?"
    },
    "sendGridSettings": {
      "title": "Definições do SendGrid",
      "settingsForLocations": "Definições do SendGrid para localizações",
      "sendGrid": "SendGrid",
      "last12Months": "Últimos 12 meses",
      "totalSent": "Total enviado",
      "opens": "Abre",
      "clicks": "Cliques",
      "bounces": "Devoluções"
    },
    "launchpadSettings": {
      "disableLaunchpad": "Desativar o Launchpad para todas as minhas localizações.",
      "description1": "A Launchpad é uma página de destino bem concebida que comprovadamente aumenta a satisfação e a retenção dos clientes, ao aumentar a utilização do produto. ",
      "description2": "A ligação do plug-in do GMB, FB, Webchat e a utilização da aplicação móvel, entre outros, provaram ser excelentes características que retêm os clientes durante mais tempo.",
      "confirmDisable": "Tem a certeza de que pretende desativar o Launchpad?"
    },
    "affiliateSettings": {
      "affiliateLinkDescription": "Esta é a sua ligação de afiliado, utilize esta ligação para permitir que as pessoas que conhece se inscrevam numa conta e receberá 40% das respetivas receitas mensais recorrentes para sempre.",
      "appendToUrls": "Adicione isto ao final dos seus URLs:",
      "needToSignUp": "Precisa de se registar?",
      "goToUrl": "Aceda ao URL:",
      "andSignUpUsing": "e inscreva-se usando o endereço de e-mail",
      "asYourEmailAddress": "como o seu endereço de e-mail para o FirstPromoter.",
      "pageSettings": "Definições da página",
      "facebookPixelId": "Facebook Pixel ID",
      "pixelId": "Pixel ID"
    },
    "agencyAPIKeySettings": {
      "enhancedAccountSecurity": "A partir de 17 de junho de 2024, a Segurança de conta avançada será ativada automaticamente na sua conta por predefinição. As melhorias de segurança incluem:",
      "discontinuationOfAutoGeneration": "Descontinuação da geração automática de API Keys de localização",
      "exclusionOfApiKeysInLocationCrudApis": "Exclusão de API Keys nas APIs CRUD de localização",
      "optOutLink": "Para optar por não participar nesta alteração, desative a Segurança de conta avançada em <a href=\"/settings/company\">Definições &gt; Empresa</a>",
      "advancedFunctionalityNote": "Esta API destina-se a funcionalidades avançadas. A nossa equipa de Suporte não está disponível para prestar assistência direta relativamente à configuração da API.",
      "developerCouncilInfo": "Oferecemos um Conselho de Programadores que se reúne mensalmente para horas de atendimento (<a href=\"https://gohighlevel.com/events\">https://gohighlevel.com/events</a>) e um canal Slack da Comunidade de Programadores, onde poderá encontrar assistência da comunidade e da nossa equipa de API. (<a href=\"https://www.gohighlevel.com/dev-slack\">https://www.gohighlevel.com/dev-slack</a>)",
      "zapierNote": "Para usar o Zapier, precisa de utilizar a API key de localização para a localização específica. Pode obtê-la na lista abaixo ou alternando para a conta usando o botão no menu à esquerda.",
      "partOfAdvancedApi": "Isto faz parte da API avançada disponível no plano Pro.",
      "upgradeMessage": "Isto faz parte da API avançada disponível no plano Pro. <a>Clique aqui</a> para fazer upgrade."
    },
    "accountMap": {
      "addAccountManually": "Adicionar Conta Manualmente"
    },
    "accountTeamsManagement": {
      "settingsAsGroups": "Definições como Grupos."
    },
    "accountDetails": {
      "basicDetails": "Detalhes básicos",
      "saas": "SaaS",
      "rebilling": "Faturação recorrente",
      "marketplaceApps": "Aplicações do Marketplace",
      "advancedEmailSettings": "Definições avançadas",
      "calendarSettings": "Definições de calendário"
    },
    "advancedEmailSettings": {
      "controlLocationSettings": "Controlar as definições de localização",
      "disableAddEmailService": "Desative o botão Adicionar serviço de e-mail nas definições de serviços de e-mail da subconta",
      "disableAddSmtp": "Desative o botão Adicionar serviço de e-mail nas definições de serviços de e-mail da subconta",
      "restrictSubAccountEmailProvider": "Restrinja os utilizadores de subcontas para que não possam adicionar os seus próprios fornecedores de serviços de e-mail",
      "disableAddSmtpDescription": "Restrinja os utilizadores de subcontas para que não possam adicionar os seus próprios fornecedores de serviços de e-mail",
      "enableReVerification": "Ativar nova verificação por 90 dias",
      "locationNoLeadConnector": "A localização não tem o LeadConnector como fornecedor de e-mail predefinido",
      "lcEmailNotEnabled": "A localização não tem o LeadConnector como fornecedor de e-mail predefinido",
      "onlyForAgency": "Só pode ver estas definições ativadas para a agência",
      "onlyVisibleForAgency": "Só pode ver estas definições ativadas para a agência",
      "reVerificationDescription": "Todos os estados de verificação de e-mail serão revogados após 90 dias (proteja a reputação do remetente e garanta a maior capacidade de entrega na caixa de entrada)"
    }
  },
  "attributes": {
    "addAttribute": "Adicionar atributo",
    "attributeName": "Nome do atributo",
    "enterAttributeName": "Introduza o nome do atributo",
    "number": "Número",
    "selectAttributeType": "Selecionar tipo de atributo"
  },
  "audit": {
    "changeModal": {
      "additionalMetaData": "Metadados adicionais",
      "title": "Campos adicionados/atualizados"
    }
  },
  "bulkActions": {
    "additionalDetails": "Detalhes adicionais",
    "allOnGivenDate": "Tudo numa determinada data",
    "attempted": "Tentativa",
    "batchQuantity": "Quantidade do lote",
    "bulkActionProcessing": "Processamento de ações em massa",
    "bulkActionTitle": "Ação em massa",
    "campaignRequired": "A campanha é obrigatória",
    "currentStatus": "Estado Atual",
    "delayBetweenBatches": "Tempo limite entre lotes",
    "dispatchMode": "Modo de envio: {mode}",
    "editBatchQuantity": "Editar quantidade do lote",
    "emailStats": "Estatísticas de e-mail",
    "enterBatchSprintLimit": "Introduza um limite de batch sprint",
    "hideStats": "Ocultar Estatísticas",
    "mode": "Modo",
    "nextProcessingOn": "Próximo processamento ativo",
    "noStatsFound": "Não foram encontradas estatísticas",
    "parentBulkActionID": "ID da ação em massa principal",
    "pleaseEnterQuantity": "Insira uma quantidade",
    "processAllAsSoonAsPossible": "Execute tudo o mais rapidamente possível",
    "processAllOnGivenDate": "Processar tudo na data fornecida",
    "processDuring": "Pipeline Durante",
    "processGraduallyDrip": "Processar gradualmente (apresentar incrementalmente)",
    "processingAllowedOn": "Processamento permitido ativo",
    "restoredBulkActionId": "ID da ação em massa restaurada:",
    "revert": "Reverter",
    "revertedBulkActionId": "ID da ação em massa revertida:",
    "saveChanges": "Guardar alterações",
    "scheduledStart": "Início agendado",
    "showErrorLog": "Mostrar log de erros",
    "showImported": "Mostrar importado",
    "showStats": "Mostrar estatísticas",
    "skipped": "Ignorado",
    "statistics": "Estatísticas",
    "statuses": {
      "complete": "Concluir",
      "next-drip": "Próxima apresentação incremental",
      "notStarted": "Não iniciado",
      "processing": "A processar",
      "queueing": "Fila de espera",
      "reading": "Leitura",
      "resumed": "Retomado",
      "reverted": "revertido",
      "waiting": "À espera"
    },
    "successful": "Bem-sucedido",
    "tagsAdded": "Etiquetas adicionadas",
    "tagsRemoved": "Etiquetas removidas",
    "tagsRestored": "Etiquetas restauradas",
    "timeElapsed": "Tempo decorrido",
    "totalExported": "Total Exportado",
    "totalMerge": "Total misturado",
    "unknownError": "Erro desconhecido",
    "updateBatchQuantity": "Atualizar quantidade de lote",
    "updated": "Atualizado",
    "usesDynamicList": "** Usa lista dinâmica",
    "workflowRequired": "O fluxo de trabalho é obrigatório"
  },
  "business": {
    "addedToCompany": "Contacto(s) adicionado(s) à empresa com sucesso",
    "cantAddMoreContacts": "Não é possível adicionar mais de 50 contactos de cada vez",
    "cleanerUi": "IU mais simples",
    "common": {
      "addContact": "Adicionar contacto",
      "internalServerError": "Erro interno do servidor",
      "to": "para"
    },
    "companiesNowHave": "As empresas agora têm",
    "companyNoteLabsText": "Notas da empresa é um recurso labs",
    "contactRemoveCompany": "Tem a certeza de que pretende remover este contacto da empresa?",
    "moreFunctionalUx": "UX Mais Funcional",
    "newCompanyUpdate": "Nova atualização de empresa!",
    "tabs": "Separadores",
    "tasks": {
      "assignTask": "Atribuir tarefa",
      "assignee": "Detentor",
      "deleteTask": "Eliminar tarefa",
      "editTask": "Editar tarefa",
      "markAsComplete": "Marcar como concluído",
      "markAsPending": "Marcar como pendente",
      "nameAndDescription": "Nome e descrição",
      "noTasksAvailable": "Nenhuma tarefa disponível"
    },
    "visitLabs": "Visitar Labs"
  },
  "calendar": {
    "googleCalendar": "Calendário Google",
    "noSync": "Sem Sincronização",
    "outlookCalendar": "Calendário do Outlook"
  },
  "common": {
    "topBar": {
      "toggleFrontendDebugger": "Alternar depurador de front-end"
    },
    "icons": {
      "star": ""
    },
    "errorOccurred": "Ocorreu um erro; tente novamente",
    "tabs": "Separadores",
    "showPassword": "Mostrar palavra-passe",
    "hidePassword": "Ocultar palavra-passe",
    "goToHomepage": "Ir para a página inicial",
    "leadConnectorHqLogo": "Logótipo Lead Connector HQ",
    "companyLogo": "Logótipo da empresa",
    "countries": {
      "australia": "Austrália",
      "austria": "Áustria",
      "czechRepublic": "República Checa",
      "belgium": "Bélgica",
      "brazil": "Brasil",
      "canada": "Canadá",
      "chile": "Chile",
      "denmark": "Dinamarca",
      "switzerland": "Suíça",
      "germany": "Alemanha",
      "estonia": "Estónia",
      "spain": "Espanha",
      "finland": "Finlândia",
      "france": "França",
      "uk": "Reino Unido",
      "hongKong": "Hong Kong",
      "hungary": "Hungria",
      "ireland": "Irlanda",
      "italy": "Itália",
      "japan": "Japão",
      "kenya": "Quénia",
      "lithuania": "Lituânia",
      "mexico": "México",
      "netherlands": "Países Baixos",
      "newZealand": "Nova Zelândia",
      "norway": "Noruega",
      "philippines": "Filipinas",
      "puertoRico": "Porto Rico",
      "poland": "Polónia",
      "portugal": "Portugal",
      "sweden": "Suécia",
      "singapore": "Singapura",
      "unitedStates": "Estados Unidos",
      "vietnam": "Vietname",
      "southAfrica": "África do Sul"
    },
    "countryshortcodes": {
      "ca": "CA",
      "eu": "UE",
      "in": "IN",
      "na": "NA",
      "us": "US"
    },
    "misc": {
      "0": "0",
      "1": "1",
      "10": "10",
      "10x": "10x",
      "1 (555) 987-6543": "+1 (555) 987-6543",
      "1x": "1x",
      "3x": "3x",
      "720_x_720_px": " 720 x 720 px",
      "x": "x",
      "g": "G",
      "m": "/M",
      "s": "s",
      "k": " K",
      "esc": "ESC",
      "fb": "fb",
      "ghl": "GHL",
      "mrr": "MRR",
      "dnd": "DND",
      "gbp": "GBP",
      "sms": "SMS",
      "api": "API",
      "otp": "OTP",
      "tcr": "TCR",
      "ein": "EIN",
      "acn": "ACN",
      "cbn": "CBN",
      "vat": "IVA",
      "cvv": "CVV",
      "amex": "AMEX",
      "visa": "VISA",
      "mastercard": "MasterCard",
      "dinersClub": "Diners Club",
      "2fa": "2FA",
      "ivr": "IVR",
      "ppc": "PPC",
      "cpaas": "CPaaS",
      "lc": "LC",
      "a2p": "A2P",
      "sha": "SHA",
      "_frameborder0_scrollingauto_width100_height500ifra": "&quot; frameborder=&quot;0&quot; scrolling=&quot;auto&quot; width=&quot;100%&quot; height=&quot;500&quot;&gt;</iframe>",
      "iframe_src": "<iframe src=\"",
      "editNumberPoolStrongnamestrong": "Editar conjunto de números - <strong>{name}</strong>",
      "displayphonenumber": "PhoneNumber",
      "js_heap_memory": "Memória JS",
      "vuex_store_modules": "Módulos de loja Vuex",
      "vuex_store_size": "Tamanho da loja Vuex",
      "admanagerlogo": "ad-manager-logo",
      "seosearchatlaslogo": "seo-search-atlas-logo",
      "modelimage": "model-image",
      "tipaltiiframe": "tipalti-iframe",
      "fileimage": "file-image",
      "urlimage": "url-image",
      "msgsndr8": "msgsndr8",
      "testmaindomaincom": "testmain{'@'}domain.com",
      "webdevexamplecom": "web-dev{'@'}example.com",
      "httpexamplecom": "http://exemplo.pt",
      "smtpgmailcom": "smtp.gmail.com",
      "xyzcomOrUtmcampaignxyz": "xyz.com ou utm_campaign=xyz",
      "websitecom": "website.com",
      "strongshakenstirstrongVerifica": "A verificação <strong>SHAKEN/STIR</strong> está concluída para a sua subconta. Crie confiança com os seus clientes através de chamadas verificadas.",
      "mp3wavfile": "ficheiro mp3/wav",
      "usd": "$",
      "1_555_9876543": "+351 219 876 543"
    },
    "stepProgress": "Passo {currentStep} de {totalSteps}",
    "loadMore": "Carregar mais",
    "1_segment_is_equal_to_a_sms_of_160_characters_clic": "1 segmento é igual a um SMS de 160 carateres. Clique no ícone para saber mais detalhes sobre os preços.",
    "1_segment_is_equal_to_an_sms_of_160_characters_cli": "1 segmento é igual a um SMS de 160 carateres. Clique no ícone para saber mais detalhes sobre os preços.",
    "_email": "/ email",
    "_ip": "/IP",
    "_min": " / min",
    "_of_total": "% do Total",
    "_please_add_a_payment_method_for": "! Por favor, adicione um método de pagamento para ",
    "_segment": " / segmento",
    "_used": "% utilizado",
    "a_new_twilio_account_needs_to_be_created_before_we": "É necessário criar uma nova conta Twilio antes de podermos iniciar a faturação recorrente",
    "a_sub_account_can_have_up_to_10_custom_objects_if_": "Uma subconta pode ter até 10 objetos personalizados. Se o limite for excedido, não serão criados objetos personalizados a partir deste instantâneo.",
    "a_twilio_account_is_already_setup_for_this_location": "Uma conta Twilio já está configurada para esta localização",
    "accountName": "Nome da conta",
    "account_sid": "SID da conta:",
    "action": "Ação",
    "actions": "Ações",
    "activate": "Ativar",
    "active": "Ativo",
    "active_listeners": "Ouvintes ativos",
    "active_subscriptions": "Assinaturas Ativas",
    "ad_manager": " Gestor de anúncios",
    "add": "Adicionar",
    "addAction": "Adicionar ação",
    "add_eliza": "Adicione Eliza",
    "add_image": "Adicionar imagem",
    "add_payment_method": "Adicionar método de pagamento",
    "add_to_account": "Adicionar à Conta",
    "add_user_icon": "Adicionar Ícone de Utilizador",
    "add_your_first_email": "Adicione o seu primeiro e-mail.",
    "address": "Endereço",
    "adwords_reporting": "Relatórios do Adwords",
    "affiliate_manager": "Gestor de afiliados",
    "agency": "Vista de agência",
    "agency_logo": "logótipo da agência",
    "agency_settings": "Definições de agência",
    "agent_reporting": "Relatórios de agentes",
    "ai_employee": " Funcionário AI ",
    "all": "Todos",
    "allow_subaccounts_to_cancel_their_subscription": "Permitir que as subcontas cancelem a respetiva assinatura",
    "allow_subaccounts_to_upgrade_to_a_higher_plan": "Permitir que as subcontas façam upgrade para um plano superior",
    "allowed_format": "Formato permitido:",
    "am": "Manhã",
    "announcements_click_to_open_in_new_tab": "Anúncios - clique para abrir num novo separador",
    "answers": "Respostas",
    "app_name": "Nome da aplicação",
    "appointments": "Compromissos",
    "apps": " aplicações",
    "ask_ai": "Ask AI",
    "ask_anything": "Pergunte qualquer coisa...",
    "assigned_to_another_user": "(Atribuído a outro utilizador)",
    "at_least_one_location_is_required": "Pelo menos uma localização é obrigatória",
    "attach_snapshot": "Anexar instantâneo",
    "attribution_reporting": "Relatórios de atribuição",
    "authorized_representative": "Representante autorizado",
    "automation_type": "Tipo de automatização",
    "available_hours": "Horas disponíveis",
    "avg_memoryinstance": "Memória Média/Instância",
    "back": "Voltar",
    "base_url": "URL base",
    "between_10_kb_and_5_mb": " Entre 10 KB e 5 MB",
    "birthday_sms": "SMS de Aniversário",
    "birthday_sms_with_image": "SMS de aniversário com imagem",
    "blogging": "Blogues",
    "bounced": "Rejeitado",
    "bulk_requests": "Pedidos em massa",
    "business_email": "E-mail da empresa",
    "business_hours_configurations": "Configurações de horário de funcionamento",
    "business_industry": "Indústria da empresa",
    "business_information": "Informações da empresa",
    "business_logo": "Logótipo da empresa",
    "business_niche": "Nicho de negócios",
    "business_phone": "Telefone da empresa",
    "business_physical_address": "Endereço físico da empresa",
    "business_regions_of_operations": "Regiões de operações da empresa",
    "business_registration_id_type": "Tipo de ID de registo comercial",
    "business_registration_number": "Número de registo comercial",
    "business_type": "Tipo de empresa",
    "business_website": "Sítio Web da empresa",
    "busy": "Ocupado",
    "buttons": {
      "cancel": "Cancelar",
      "confirm": "Confirmar",
      "deleteAll": "Eliminar tudo",
      "view": "Ver",
      "close": "Fechar",
      "previous": "Anterior",
      "next": "Seguinte",
      "clear": "Limpar",
      "save": "Guardar",
      "edit": "Editar",
      "delete": "Eliminar",
      "reset": "Repor",
      "refresh": "Atualizar",
      "nextLoading": "Seguinte...",
      "copied": "Copiado",
      "notNow": "Agora não",
      "send": "Enviar",
      "send1": "Enviar",
      "download": "Descarregar",
      "sendNow": "Enviar agora",
      "saved": "Guardado",
      "back": "Voltar",
      "update": "Atualizar",
      "add": "Adicionar",
      "submit": "Enviar",
      "submitting": "A enviar",
      "done": "Concluído",
      "manageUsers": "Gerir utilizadores",
      "no": "Não",
      "yes": "Sim"
    },
    "calendar": "Calendário",
    "calendar_groups": "Grupos de calendário",
    "call": "Chamada",
    "call_reporting": "Relatório de Chamadas",
    "call_tracking_is_disabled": "O rastreio de chamadas está desativado",
    "call_voicemail_settings": "Definições de chamadas e correio de voz",
    "calls": " chamadas",
    "campaign": "Campanha",
    "campaigns": "Campanhas",
    "cancel": " Cancelar ",
    "cancel_subscription": "Cancelar assinatura",
    "cancelled": "Cancelado",
    "certificates": "Certificados",
    "change": "Alterar",
    "changed_data": "Dados alterados",
    "charge": " Custo",
    "charged_to_customer": "Cobrado ao cliente",
    "chat": "Conversar",
    "chat_user": "Utilizador do Chat",
    "chat_widget_icon": "Ícone do widget de chat",
    "chats_will_be_saved_for_2_days": "As conversas serão guardadas durante 2 dias",
    "check": "verificação",
    "check_number_validity_before_first_sms_block_incom": "Verifique a validade do número antes de enviar o primeiro SMS, bloqueie chamadas de spam recebidas e pesquise os nomes dos autores de chamadas desconhecidos antes de atender o telefone. Aplicam-se custos adicionais",
    "cinque_terre": "Cinque Terre",
    "city": "Cidade",
    "clear_history": "Limpar Histórico",
    "click_here": "Clicar aqui",
    "click_on_create_new_snapshot_to_add_one": " Clique em Criar novo instantâneo para adicionar um.",
    "click_to_access_the_highlevel_welcome_course": "Clique para aceder ao curso de boas-vindas HighLevel",
    "click_to_upgrade": "Clicar para fazer upgrade",
    "clicked": "Clicado",
    "clio": "Clio",
    "cloning": "Clonagem",
    "close_debugger": "Fechar o depurador",
    "close_whatsapp_template_creator": "Fechar criador de modelos do WhatsApp",
    "collection": "Coleção",
    "columns": "Colunas",
    "coming_soon": "Brevemente",
    "company_email_": "E-mail da empresa (",
    "complete_component_data": "Dados Completos do Componente",
    "complete_event_data": "Dados Completos do Evento",
    "complete_query_data": "Dados Completos da Consulta",
    "completed": "Concluído",
    "complimentary_credits": "Créditos gratuitos",
    "component": "Componente",
    "component_name": "Nome do Componente",
    "component_type": "Tipo de Componente",
    "components": " componentes",
    "condition": "Condição",
    "confirm": "CONFIRMAR",
    "confirmation_message": "Mensagem de confirmação",
    "confirmed": "Confirmado",
    "connect_with_a_certified_admin_click_to_open_in_ne": "Conecte-se com um Administrador Certificado - clique para abrir num novo separador",
    "connect_with_us_start_live_chat": "Ligue-se a nós - inicie um chat em direto",
    "connect_your_stripe_account": "ligue a sua conta Stripe ",
    "connect_zoom": "Ligar Zoom",
    "consider_leaving_it_blank_should_you_choose_to_use": "Pondere deixá-la em branco, caso opte por utilizar a localização da reunião pré-configurada",
    "contact": "Contacto",
    "contact_support": "contactar Suporte",
    "contact_us_call_highlevel_at_18887324197": "Contacte-nos - ligue para a HighLevel através do número +1(888)732-4197",
    "contacts": "Contactos",
    "content_ai": "Content AI",
    "controls": "Controlos",
    "conversations": "Conversas",
    "copied": "Copiado",
    "cost_borne_by_you": " custo a seu cargo",
    "count": "Contagem",
    "country": "País",
    "createNewFolder": "Criar nova pasta",
    "credit_balance": "SALDO DE CRÉDITO",
    "current_location_id": "ID da localização atual",
    "custom": "Personalizado",
    "custom_email": "E-mail personalizado",
    "custom_niche": "Nicho personalizado",
    "customer_notifications": "Notificações de clientes",
    "customize": "Personalizar",
    "customize_chat_widget": "Personalizar widget de chat",
    "dashboard_stats": "Estatísticas do painel de controlo",
    "data_keys": "Chaves de dados",
    "date": "Data",
    "days": "Dias",
    "dedicated_ip": "IP dedicado ",
    "default": "Predefinição",
    "default_snapshots": "Instantâneos predefinidos",
    "delete": "Eliminar",
    "deleted": "eliminado",
    "delivered": "Entregue",
    "description": "descrição",
    "details": "Informações",
    "disable_gbp_messaging_not_recommended": "desativar mensagens GBP (não recomendado)",
    "disable_tracking": "Desativar rastreio",
    "disabled": "Desativado(a)",
    "dismiss": "Dispensar",
    "display_name": "Nome de apresentação",
    "do_not_delete": "não eliminar",
    "do_something": "REALIZE UMA AÇÃO",
    "do_you_want_to_keep_the_same_or_create_a_new_one": "Pretende manter o mesmo ou criar um novo?",
    "download_application_icon": "Descarregar ícone da aplicação",
    "draft": "Rascunho",
    "dropdown_icon": "ícone de menu suspenso",
    "duplicate": "Duplicar",
    "duration": "Duração",
    "eliza": "Eliza",
    "eliza_bypass_tag_optional": "Etiqueta Eliza Bypass (Opcional)",
    "eliza_is_required": "Eliza é necessária.",
    "eliza_service": "Serviço Eliza",
    "email": "E-mail",
    "email_resell_settings": "Definições de revenda de e-mail",
    "email_sending": "Envio de e-mail",
    "email_signature": "Assinatura de Email",
    "enable": "Ativar",
    "enable_beta": " Ativar Beta",
    "enable_company_automation": "Ative a automação da empresa",
    "enable_disable_deprecated_features": "Ativar/desativar caraterísticas descontinuadas",
    "enable_gbp_call_tracking": " Ativar o rastreio de chamadas do GBP ",
    "enable_gbp_messaging": "ativar mensagens GBP",
    "enable_signature_on_all_outgoing_messages": "Ativar assinatura em todas as mensagens de saída",
    "enabled": "Ativado(a)",
    "notEnabled": "Não ativado",
    "enter_a_logical_name": "Introduza um nome lógico",
    "enter_the_exact_business_address_as_it_appears_in_": "Introduza o endereço comercial exato, como aparece nas listas do EIN.",
    "enter_the_exact_legal_business_name_as_registered_": "Introduza o nome legal exato da empresa, conforme registado no EIN.",
    "enter_the_full_street_address_as_it_appears_in_the": "Introduza o nome completo da rua, como aparece nas listas do EIN.",
    "enter_user_email": "Introduzir e-mail do utilizador",
    "enter_user_phone_number": "Introduza o Número de Telefone do Utilizador",
    "enter_your_business_registration_id_type": "Introduza o tipo de ID de registo comercial",
    "enter_your_business_vertical_eg_travel": "Introduza o seu vertical de negócio (por exemplo: Viagens)",
    "error_code": "Código de erro",
    "error_code_chart": "Gráfico do código de erro",
    "error_while_copying_api_key": "Erro ao copiar a API Key!",
    "event": "Evento",
    "event_bus_listeners": "Ouvintes do barramento de eventos",
    "events": " eventos",
    "everything_in": "Tudo em ",
    "exact": "Exato",
    "execute_this_action_if_the_current_time_falls_in_t": "Execute esta ação se a hora atual se situar neste período; caso contrário, aguarde até ao período seguinte para executar esta ação.",
    "extension": "Extensão",
    "facebook": "Facebook",
    "facebook_ads": "Anúncios do Facebook",
    "facebook_ads_reporting": "Relatórios de anúncios do Facebook",
    "facebook_adsets": "Conjuntos de anúncios do Facebook",
    "facebook_campaigns": "Campanhas do Facebook",
    "facebook_icon": "Ícone do Facebook",
    "facebook_page": "Página do Facebook",
    "feature_image": "imagem de destaque",
    "features": "Caraterísticas:",
    "feedback": "Comentários: ",
    "file_path": "Caminho do ficheiro",
    "firestore_listeners": "Ouvintes do Firestore",
    "forms": "Formulários",
    "free": "Grátis",
    "fri": "Sex",
    "friendly_business_name": "Nome amigável da empresa",
    "from": " de ",
    "funnels": "Funis",
    "gbp_call_tracking": "Rastreio de chamadas GBP",
    "gbp_configuration": "Configuração GBP",
    "general": "Geral",
    "general_information": "Informações gerais",
    "generating_link_please_wait": "A gerar a ligação, aguarde...",
    "google_ads_adgroups": "Grupos de anúncios do Google Ads",
    "google_ads_ads": "Anúncios do Google Ads",
    "google_ads_campaigns": "Campanhas do Google Ads",
    "google_ads_keywords": "Palavras-chave do Google Ads",
    "google_business_messaging": "Mensagens do Google Business",
    "google_business_profile": "Perfil do Google Business",
    "google_my_business_icon": "Ícone do Google My Business",
    "hello": "Olá ",
    "here": "aqui",
    "hhmm_a": "hh:mm A",
    "hi": "Olá ",
    "hide": "Ocultar",
    "highlevel_events_click_to_open_in_new_tab": "Eventos de Alto Nível - clique para abrir num novo separador",
    "how_can_i_help_you_today": "Como posso ajudar hoje?",
    "how_did_the_call_go": "Como correu a chamada?",
    "how_do_i_calculate_my_email_cost_click_on_the_icon": "Como calculo o custo do meu e-mail? Clique no ícone para saber mais",
    "how_does_it_work": "Como funciona",
    "htmlElement": "Elemento HTML (TODO):",
    "html_element_todo": "Elemento HTML (TODO): ",
    "id": "ID: ",
    "if": "Se",
    "if_activated_the_sender_information_will_be_automa": "Se ativadas, as informações do remetente serão adicionadas automaticamente à primeira mensagem SMS de quaisquer mensagens em massa para garantir a conformidade e aumentar as taxas de entrega.",
    "if_activated_we_will_insert_unsubscribe_links_in_y": "Se ativadas, vamos introduzir ligações de anulação da subscrição nos rodapés dos seus e-mails, para que os destinatários possam anular a subscrição sem marcar o e-mail como Reclamação/Spam.",
    "ignore_this_update": "Ignore esta atualização",
    "image": "imagem",
    "image_turned_on": "Imagem ativada",
    "imported_date": "Data de importação",
    "imported_snapshots": "Instantâneos Importados",
    "inbound": "Recebida",
    "inbound_number": "Número de entrada",
    "incoming_call_timeout": "Tempo limite da chamada recebida",
    "instance_id": "ID de instância",
    "instances": "Instâncias: ",
    "instructions_mentioned_in_this_page": "instruções mencionadas nesta página",
    "internal": "Interno",
    "intro_message": "Mensagem de introdução",
    "intro_question": "Pergunta de introdução",
    "invalid": "Inválido",
    "invoicing": "Faturação",
    "is_scheduled_for_deletion_on": " está agendado para eliminação em ",
    "job_position": "Função",
    "job_title": "Cargo",
    "join_our_facebook_group_click_to_open_in_new_tab": "Junte-se ao nosso grupo no Facebook - clique para abrir num novo separador",
    "jpg_or_png": " JPG ou PNG ",
    "just_one_sec": "Só um momento...",
    "key_sizes": "Tamanhos de chave",
    "label": "etiqueta",
    "labels": {
      "sortDirection": "Direção de ordenação",
      "tableStyling": "Estilo de tabela",
      "loadingMore": "A carregar mais…",
      "loading": "A carregar…",
      "filter": "Filtrar",
      "search": "A pesquisar...",
      "sortBy": "Ordenar por",
      "perPage": "Por página",
      "date": "Data",
      "time": "Tempo",
      "readMore": "Ler mais",
      "day": "Dia",
      "slot": "Período",
      "template": "Modelo",
      "city": "Cidade",
      "country": "País",
      "state": "Distrito",
      "customerName": "Nome do cliente",
      "friendlyName": "Nome amigável",
      "required": "* obrigatório",
      "addressLine1": "Linha de endereço 1",
      "addressLine2": "Linha de endereço 2",
      "postalCode": "Código postal",
      "searchUsers": "Pesquisar utilizadores",
      "unknown": "Desconhecido",
      "businessName": "Nome da empresa"
    },
    "last_updated": "Última atualização a",
    "launchpad_icon": "ícone do launchpad",
    "lead": "Oportunidade potencial",
    "leadconnector": "LeadConnector",
    "learn_how": "(Saiba como)",
    "legal_business_name": "Nome legal da empresa",
    "limit_updated_from": " limite atualizado de ",
    "listeners": " ouvintes",
    "loading_your_conversation_history": "A carregar o seu histórico de conversas...",
    "location": "Localização",
    "locations": " localizações",
    "logical_name": "Nome Lógico",
    "logical_name_is_required": "O nome lógico é obrigatório.",
    "logo": "Logótipo",
    "mailgun": "MailGun",
    "making_calls": "Realizar chamadas",
    "manage_custom_email": "Gerir E-mail Personalizado",
    "marketing": "Marketing",
    "maximize": "Maximizar",
    "me_": "Eu (",
    "member_since": "Membro desde",
    "membership": "Associação",
    "memory_analysis": "Análise de Memória",
    "memory_api_not_available": "API de memória não disponível",
    "message": "Mensagem",
    "minimize": "Minimizar",
    "minimum_must_be": " O mínimo deve ser ",
    "miscellaneous_charges": "Encargos diversos",
    "missed_call_text_back": "Texto de retorno da chamada não atendida",
    "missed_text_back_call_message": "Mensagem de texto de retorno da chamada não atendida",
    "model": "Modelo",
    "module": "Módulo",
    "modules": " módulos",
    "mon": "Seg",
    "month": "/mês",
    "monthly": "mensalmente",
    "more_emails_in_thread": " mais e-mails no tópico",
    "mount_count": "Contagem de Montagens",
    "mount_time": "Tempo de Montagem",
    "moved_to_calendar_settings": "Movido para as definições do calendário",
    "multiple_locations_using_same_twilio_account": "Várias localizações a usar a mesma conta Twilio",
    "must_be_in_range_of_0": " Deve estar no intervalo de 0 -",
    "must_be_less_than_monthly_plan_12": " Deve ser inferior ao Plano Mensal * 12 ",
    "my_business_is": "A minha empresa está ",
    "my_snapshots": "Os meus instantâneos",
    "name": "Nome",
    "name_of_other_registration_id_type": "Nome de outro tipo de ID de registo",
    "newFolder": "Nova pasta",
    "new_task_update": "Nova Atualização de Tarefa!",
    "next": "Seguinte",
    "no_answer": "Sem resposta",
    "no_bigger_than_25mb": "não superior a 2,5 MB",
    "no_customer_selected": "Nenhum cliente selecionado",
    "no_error_data_found": "Não foram encontrados dados do erro",
    "no_payment_method_available": "Nenhum método de pagamento disponível",
    "no_provider_found": "Nenhum fornecedor encontrado",
    "no_snapshots_found": "Nenhum instantâneo encontrado!",
    "noshow": "Não comparência",
    "not": "Não",
    "not_now": "Agora não",
    "not_saved": "Não guardado",
    "notes": "Notas",
    "notifications": "Notificações",
    "now": "Agora",
    "numbers_and": " número(s) e ",
    "objective": "Objetivo:",
    "of": "de",
    "onboarding_video_tutorials_click_to_open_in_new_ta": "Tutoriais em Vídeo de Onboarding - clique para abrir num novo separador",
    "online_listings": "Listagens online",
    "only_assigned_data": "Apenas dados atribuídos",
    "open_performance_debugger": "Abrir depurador de desempenho",
    "opened": "Aberto",
    "opportunities": "Oportunidades",
    "options": {
      "ascending": "Ascendente",
      "descending": "Descendente",
      "none": "-- Nenhum --"
    },
    "or_drag_and_drop": "ou arrastar e largar",
    "outbound": "De saída",
    "pagination": "Paginação",
    "pass_body_content_here": " Insira aqui o conteúdo do corpo ",
    "password": "Palavra-passe",
    "paused": "Em pausa",
    "payment_links": "Ligações de pagamento",
    "payment_methods": "Métodos de pagamento",
    "payment_refund": "Reembolso de Pagamento",
    "payment_settings_navigation": "Navegação das definições de pagamento",
    "payments": "Pagamentos",
    "payments_integration": "Integração de Pagamentos",
    "pending": "Pendente",
    "per_page": "Por página",
    "percentage": "Percentagem",
    "permanently_delete_this_email": "Elimine este e-mail permanentemente",
    "personal_logo": "Logótipo pessoal",
    "phone": "Telefone",
    "phone_number_with_country_code": "Número de telefone (com indicativo do país)",
    "pick_a_niche": "Escolher um nicho",
    "pick_a_snapshot": "Escolher um instantâneo",
    "pick_business_industry": "Escolher indústria da empresa",
    "pick_business_registration_id_type": "Escolher tipo de ID de registo comercial",
    "pick_business_type": "Escolher tipo de empresa",
    "pick_job_position": "Escolher função",
    "plans_pricing": "Planos e preços",
    "please_enter_a_value_greater_than_20": "Introduza um valor maior que 20.",
    "pm": "Tarde/noite",
    "points": "Pontos",
    "postalzip_code": "Código postal",
    "previous": "Anterior",
    "privacy_policy_url": "URL da Política de Privacidade",
    "privacy_policy_url_will_be_shown_on_your_google_ag": "O URL da Política de Privacidade será apresentado nas suas informações de agente Google.",
    "process_your_payment": "Processar o pagamento",
    "profile_picture": "Fotografia de perfil",
    "profit": "Lucro",
    "prospecting": " Prospeção ",
    "provide_prebuild_snapshots_to_the_new_accounts": "Forneça instantâneos de pré-compilação às novas contas.",
    "queries": " consultas",
    "questions": "Perguntas",
    "quick_actions_icon": "Ícone de Ações Rápidas",
    "re_generate_key": "Regenerar chave",
    "read_only": "Só de leitura",
    "receipts_settings": "Definições de recibos",
    "receiving_calls": "Receber chamadas",
    "recent_events": "Eventos recentes",
    "recommended": "Recomendado",
    "recommended_resolution": "Resolução recomendada:",
    "reconnect": "Restabelecer ligação ",
    "record_payment": "Registar pagamento",
    "registered": " registada.",
    "renameFolder": "Mudar o nome da pasta",
    "replied": "Respondido",
    "representative_email": "E-mail do representante",
    "resell_settings": " Definições de revenda",
    "reset": "Repor",
    "resolve_now": "Resolver agora",
    "resource_counts": "Contagens de Recursos",
    "restore": "Restaurar",
    "results": "Resultados",
    "reviews": "Revisões",
    "rollover_unused_credits_to_next_month": "Transferir créditos não utilizados para o mês seguinte",
    "row": " fila",
    "runNow": "Execute agora",
    "sample_data": "(Dados de Amostra)",
    "sat": "Sáb",
    "save": "Guardar",
    "save_missed_call_text_settings": "Guardar definições de texto de chamadas não atendidas",
    "save_staging_url": "Guardar URL de testes",
    "saved": "Guardado",
    "saving": "A guardar...",
    "search": "Pesquisar",
    "search_active_apps": "Pesquisar aplicações ativas...",
    "search_components": "Pesquisar componentes...",
    "search_customer": "Pesquisar cliente",
    "search_email": "Pesquisar Email",
    "search_history": "Histórico de pesquisa...",
    "search_icon": "ícone de pesquisa",
    "search_listeners": "Pesquisar ouvintes...",
    "search_modules": "Pesquisar módulos...",
    "search_queries": "Consultas de pesquisa...",
    "see_this_review_on_gbp": "Ver esta revisão sobre o GBP ",
    "segments": " segmentos",
    "select": "Selecionar",
    "select_a_snapshot": "Selecionar um instantâneo",
    "monetary": "MONETÁRIO",
    "pleaseSelectAValue": "Selecione um valor",
    "select_account": "Selecionar conta",
    "select_an_account": "Selecionar uma conta",
    "select_eliza_bypass_tag": "Selecionar etiqueta de contorno Eliza",
    "select_phone_number": "Selecionar número de telefone",
    "select_send_to_eliza_tag": "Selecionar etiqueta Enviar para Eliza",
    "select_snapshot": " Selecionar instantâneo",
    "select_upto": "Selecione até ",
    "selected": "Selecionado: ",
    "send": "Enviar",
    "send_to_eliza_tag_optional": "Etiqueta Enviar para Eliza (opcional) ",
    "seo": " SEO ",
    "settings": "Definições",
    "setup_pending": "Configuração Pendente",
    "share": "Partilhar",
    "shared_snapshots": "Instantâneos partilhados",
    "shared_type": "Tipo de partilha",
    "shipping_and_delivery": "Expedição e entrega",
    "shipping_origin": "Origem da expedição",
    "show": "Mostrar",
    "showed": "Compareceu",
    "signin_with_single_signon": "Inicie sessão com autenticação única",
    "size": "Tamanho",
    "sms_message_sent_to_customer": "Mensagem SMS enviada ao cliente",
    "snapshot_date": "Data do instantâneo",
    "snapshot_name": "Nome do instantâneo",
    "social_planner": "Planeador de redes sociais",
    "sortBy": "Ordenar por",
    "sortOptions": {
      "createdDate": "Data de criação"
    },
    "source": "Fonte",
    "sources": "Fontes:",
    "spent": "Gasto",
    "staging_url_settings_for_db_event": "Definições do URL de testes (para evento de base de dados)",
    "state": "Distrito",
    "state_prov_region_": "Estado/Província/Região *",
    "states": {
      "alabama": "Alabama",
      "alaska": "Alasca",
      "arizona": "Arizona",
      "arkansas": "Arcansas",
      "california": "Califórnia",
      "colorado": "Colorado",
      "connecticut": "Coneticute",
      "delaware": "Delaware",
      "district_of_columbia": "Distrito de Columbia",
      "florida": "Florida",
      "georgia": "Geórgia",
      "hawaii": "Havai",
      "idaho": "Idaho",
      "illinois": "Ilinóis",
      "indiana": "Indiana",
      "iowa": "Iowa",
      "kansas": "Cansas",
      "kentucky": "Kentucky",
      "louisiana": "Luisiana",
      "maine": "Maine",
      "maryland": "Marilândia",
      "massachusetts": "Massachusetts",
      "michigan": "Michigan",
      "minnesota": "Minesota",
      "mississippi": "Mississípi",
      "missouri": "Missúri",
      "montana": "Montana",
      "nebraska": "Nebrasca",
      "nevada": "Nevada",
      "new_hampshire": "Nova Hampshire",
      "new_jersey": "Nova Jérsia",
      "new_mexico": "Novo México",
      "new_york": "Nova Iorque",
      "north_carolina": "Carolina do Norte",
      "north_dakota": "Dacota do Norte",
      "ohio": "Ohio",
      "oklahoma": "Oklahoma",
      "oregon": "Oregon",
      "pennsylvania": "Pensilvânia",
      "rhode_island": "Rhode Island",
      "south_carolina": "Carolina do Sul",
      "south_dakota": "Dacota do Sul",
      "tennessee": "Tenessi",
      "texas": "Texas",
      "utah": "Utah",
      "vermont": "Vermonte",
      "virginia": "Virgínia",
      "washington": "Washington",
      "west_virginia": "Virgínia Ocidental",
      "wisconsin": "Wisconsin",
      "wyoming": "Wyoming",
      "noRecordsFound": "Não foram encontrados registos",
      "noEntriesToShow": "Não existem entradas para mostrar",
      "unsuccessful": "Sem sucesso",
      "pending": "Pendente",
      "noUsersFound": "Nenhum utilizador encontrado"
    },
    "status": "Estado",
    "stop_delete_operation": "Parar operação de eliminação",
    "street_address": "Rua",
    "street_address_as_it_appears_in_the_ein_listing": "Rua como aparece nas listas do EIN.",
    "stripe_icon": "Ícone Stripe",
    "stripe_integration": "Integração com Stripe",
    "stripe_secret_key": "Chave secreta do Stripe",
    "subscriptions": "Assinaturas",
    "sun": "Dom",
    "surveys": "Inquéritos",
    "suspend_subaccount_when_their_saas_subscription_fa": "Suspenda a subconta quando a assinatura SaaS falhar.",
    "switchAccount": "Mudar de conta",
    "switch_off_sections_below_to_disable": "Desative as secções abaixo para desativar",
    "tags": "Etiquetas",
    "tax_settings": "Definições de imposto",
    "team_management": "Gestão da equipa",
    "team_notifications": "Notificações de equipas",
    "template": "Modelo",
    "terms_and_conditions": "Termos e Condições",
    "test_mobile_no": "N.º de telemóvel de teste",
    "text_messages": "Mensagens de texto",
    "the_proposed_size_is_350px_180px": "O tamanho proposto é 350 px * 180 px",
    "the_proposed_size_is_512512px": "O tamanho proposto é 512 * 512 px",
    "the_selected_language_will_be_used_by_the_system_a": "Por predefinição, o idioma selecionado será utilizado pelo sistema.",
    "the_welcome_message_automatically_appears_after_a_": "A mensagem de boas-vindas aparece automaticamente após um utilizador iniciar uma nova conversa.",
    "these_are_margins_that_are_billed_to_your_clients_": "Estas são as margens que são faturadas aos seus clientes sobre o ",
    "this_data_will_be_used_for_future_compliance_regis": "Estes dados serão utilizados para o registo futuro de conformidade.",
    "this_is_my_twilio_use_same": "Este é o meu Twilio, usar o mesmo",
    "this_is_visible_to_both_agency_and_location": "Isto é visível tanto para a agência como para a localização",
    "this_name_will_be_visible_to_leads_chatting_with_y": "Este nome será visível para os potenciais clientes que conversam com a sua empresa",
    "this_setting_is_applicable_with_only_team_calendar": "Esta definição aplica-se apenas a calendários de equipa.",
    "this_stripe_customer_is_already_connected_to_anoth": "Este cliente da Stripe já está ligado a outra subconta.",
    "thu": "Qui",
    "tiktok": "Tiktok",
    "time_signed": " Hora da assinatura: ",
    "time_zone_": "Fuso Horário *",
    "timestamp": "Carimbo de data/hora",
    "title": "Título",
    "to_resolve_this_problem_follow_the": "Para resolver este problema, siga as ",
    "token": "Token:",
    "total": "Total: ",
    "trigger_link": "Ligação do acionador",
    "triggers": "Acionadores",
    "tue": "Ter",
    "twilio": "Twilio",
    "twilio_setup_pending": "Configuração do Twilio pendente",
    "type": "Tipo",
    "type_campaign_objective": "Escrever objetivo da campanha",
    "type_message": "Escrever mensagem",
    "unsavedChangesWarning": "As suas alterações não serão guardadas. Tem a certeza de que pretende sair?",
    "unsaved_changes": "Alterações não guardadas",
    "unsubscribed": "Com subscrição anulada",
    "unsuccessful": "Sem sucesso",
    "update_business_profile_details": "Atualize os detalhes do perfil da empresa",
    "update_is_inprogress_visit_integrations_page_to_fi": "A atualização está em curso. Visite a página de integrações para saber mais.",
    "update_url": "Atualizar URL",
    "updated_date": "Data de atualização",
    "updates": " atualizações",
    "updating": "A atualizar...",
    "upgrade_to_agency_pro": "atualizar para o plano Agência Pro ",
    "upload": "Carregar",
    "upload_a_file": "Carregar um ficheiro",
    "usd": " USD",
    "use_this_for_zapier_and_api_integration": "Utilize isto para integração com o Zapier e a API.",
    "user_email": "E-mail do utilizador",
    "user_permissions": "Permissões de Utilizador",
    "user_role": "Função de utilizador",
    "user_type": "Tipo de utilizador",
    "valid": "Válido",
    "verification_status": "Estado de verificação",
    "verify": "Verificar",
    "verify_email_using_otp": "Verifique o e-mail com a OTP",
    "view_less": " Ver menos ",
    "visiblehidden": "Visível/oculto",
    "visit_our_help_center_click_to_open_in_new_tab": "Visite o nosso Centro de Ajuda - clique para abrir num novo separador",
    "voicemail": "Correio de voz",
    "wave_integration": "Integração com Wave",
    "we_have_found_some_errors_in_your_contact_fields_c": "Encontrámos alguns erros nos seus campos de contacto. Clique na pasta para visualizar e resolver.",
    "websites": "Sítios Web",
    "wed": "Qua",
    "welcome_message": "Mensagem de boas-vindas",
    "whatsapp": " WhatsApp",
    "whatsapp_icon": "Ícone do WhatsApp",
    "when": "Quando",
    "when_selected_calls_will_be_routed_to_your_mobile_": "Quando determinadas chamadas serão encaminhadas para a sua aplicação móvel. (Suportado tanto no iOS como no Android)",
    "when_selected_calls_will_be_routed_to_your_web_app": "Quando determinadas chamadas serão encaminhadas para a sua aplicação Web.",
    "which_business_do_you_want_to_link_to_this_locatio": "A que empresa pretende vincular a esta localização?",
    "widget_code": "Código do Widget",
    "will_give_you_about": " dá para cerca de",
    "wordpress": "WordPress",
    "wordpress_icon": "Ícone do WordPress",
    "workflows": "Fluxos de trabalho",
    "xero_integration": "Integração Xero",
    "you_need_to_complete_few_easy_steps_to_delete_this": "Tem de completar alguns passos simples para eliminar esta localização",
    "you_are_not_authorized_to_perform_this_action_only": "Não tem autorização para executar esta ação. Apenas os administradores de agência podem eliminar subcontas.",
    "your_email_cost": "O custo do seu e-mail",
    "your_facebook_page_has_been_integrated_however_the": "A sua página do Facebook foi integrada. No entanto, as seguintes funcionalidades não funcionarão, pois o LeadConnector não tem as permissões necessárias: ",
    "your_outlook_connection_has_expired_please_disconn": "A sua ligação ao Outlook expirou. Desligue e depois volte a ligar-se à conta para estabelecer a ligação.",
    "zip_code": "Código postal",
    "zoom_connected_please_close_this_modal": "Zoom ligado, feche este modal",
    "hidden": "Oculto(a)",
    "messageDetails": "Detalhes da mensagem",
    "openOptions": "Abrir opções",
    "progress": "Progresso",
    "close": "Fechar",
    "loading": "A carrregar",
    "fullName": "Nome completo",
    "languages": "Idiomas",
    "phoneNumber": "Número de telefone",
    "phoneNumberWithCountry": "Número de telefone com indicativo de país",
    "sendMessage": "Enviar mensagem",
    "services": "Serviços",
    "servicesProvided": "Serviços fornecidos",
    "pleaseProvideAValid": "Forneça um número de telefone válido.",
    "copy": "Copiar",
    "editApiKey": "Editar API Key",
    "confirmPay": "Confirmar e Pagar",
    "contactUs": "Contacte-nos",
    "decline": "Recusar",
    "deleteSubaccount": "Eliminar subconta",
    "disabled1": "desativado",
    "purchaseSummary": "Resumo da compra",
    "subscriptionPlan": "Plano de assinatura",
    "businessName": "Nome da empresa",
    "chooseOne": "Selecionar um...",
    "stateProvRegion": "Estado/Província/Região",
    "streetAddress": "Rua",
    "timeZone": "Fuso horário",
    "website": "Sítio Web",
    "zipPostalCode": "Código postal",
    "apiKey": "API Key",
    "createdAt": "Criado em",
    "deleteAllLocationApi": "Eliminar todas as api keys de localização",
    "deleteApiKey": "Eliminar api key",
    "generatedBy": "Gerado por",
    "lastUsedAt": "Última utilização à(s)",
    "pageNavigation": "Navegação da página",
    "somethingWentWrong": "Algo correu mal!",
    "clickHere": "Clique aqui",
    "emailRebillingActive": "Faturação recorrente por e-mail ativa",
    "saasSubscriptionActive": "Assinatura SaaS ativa",
    "scheduledForDeletion": "Agendado para exclusão",
    "twilioRebillingActive": "Faturação recorrente da Twilio ativa",
    "iAcknowledgeThisIs": "Confirmo que esta é uma subconta válida e verifiquei o caso de utilização do envio de mais de {limit} {type} /dia",
    "iAcknowledgeThisIs1": "Confirmo que esta é uma subconta válida e verifiquei o caso de utilização do envio, ajustando assim o limite diário de SMS",
    "emailSentByLocation": "E-mail enviado por localização até à data de hoje.",
    "goToSmsLimit": "Ir para as Definições de limite de SMS",
    "toIncreaseTheLimit": "Para aumentar ainda mais o limite, contacte a equipa de suporte.",
    "newLimitOfLimit": "O novo limite de {limit} é inválido. Forneça um valor entre {min} e {max}",
    "typeLimitUpdatedSuccessfully": "Limite de {type} atualizado com sucesso",
    "locationsCurrentLimitIs": "O limite atual da localização é {current}. Só pode atualizar o limite entre {min} e {max} a partir daqui. Para qualquer atualização de limite além de {maxAllowed}, contacte a equipa de suporte.",
    "notNow": "Não agora",
    "smsSentByLocation": "SMS enviado por localização até agora hoje.",
    "youHaveSuccessfullyUpdated": "Atualizou com sucesso o limite",
    "willAutoUnlockIn": "Desbloqueio automático em",
    "contactType": "Tipo de contacto",
    "createdBy": "Criado por:",
    "createdOn": "Criado a:",
    "dateOfBirth": "Data de nascimento",
    "emailAddress": "Endereço de e-mail",
    "firstName": "Nome próprio",
    "lastName": "Apelido",
    "twilioLookupMarkedThis": "O Twilio Lookup marcou este número de telefone como inválido.",
    "twilioLookupStatedThis": "O Twilio Lookup afirmou que este é um número {type}, por isso não receberá SMS.",
    "accountSnapshot": "Instantâneo da conta",
    "auditLogs": "Registos de auditoria",
    "account": "Conta",
    "selectAccount": "Selecionar conta",
    "facebookUrl": "URL do Facebook",
    "instagram": "Instagram",
    "linkedin": "LinkedIn",
    "twitter": "Twitter",
    "twitterUrl": "URL do Twitter",
    "youtubeUrl": "URL do YouTube",
    "text": "Texto",
    "allTagsLinkedTo": "Todas as etiquetas ligadas aos contactos selecionados devem ser removidas",
    "automation": "Automatização",
    "bulkOperation": "Operação em massa",
    "campaign1": "Campanha",
    "created": "Criado(a)",
    "dateTime": "Data e hora",
    "description1": "Descrição",
    "drip": "Apresentar incrementalmente",
    "edit": "Editar",
    "someStatsAreNot": "Algumas estatísticas não estão disponíveis se o fornecedor for SMTP. A precisão das métricas depende do domínio do destinatário.",
    "error": "Erro",
    "from1": "De",
    "immediately": "Imediatamente",
    "pause": "Pausar",
    "processed": "Processado",
    "queued": "Em fila de espera",
    "restored": "Restaurado",
    "resume": "Retomar",
    "sent": "Enviado",
    "scheduled": "Agendado",
    "success": "Sucesso",
    "templateName": "Nome do modelo",
    "total1": "Total",
    "totalAttempted": "Total tentado",
    "user": "Utilizador",
    "viewDetails": "Ver detalhes",
    "workflow": "Fluxo de trabalho",
    "company": "Empresa",
    "note": "Nota",
    "perPage": "por página",
    "showing": "Apresentação",
    "task": "Tarefa",
    "tasks": "Tarefas",
    "customFields": "Campos Personalizados",
    "dueDate": "Data de vencimento",
    "tryNow": "Experimente agora!",
    "archive": "Arquivar",
    "markAsRead": "Marcar como lida",
    "markAsUnread": "Marcar como não lida",
    "youNeedToAdd": "Precisa de adicionar um calendário para começar a agendar compromissos.",
    "additionalNotes": "Notas adicionais",
    "appointmentStatus": "Estado do compromisso",
    "appointmentTitle": "Título do compromisso",
    "contactName": "Nome do Contacto",
    "contactTimezoneUsedFor": "Fuso horário do contacto (utilizado para lembretes)",
    "day": "Dia",
    "editAppointment": "Editar compromisso",
    "nameRequired": "Nome obrigatório",
    "slotRequired": "Período obrigatório",
    "teamMemberIsRequired": "O membro da equipa é obrigatório.",
    "meetingLocation": "Localização da reunião",
    "pickTeamMember": "Escolher membro da equipa",
    "phoneNumbers": "Números de telefone",
    "roundRobin": "Distribuição sequencial",
    "selectCalendar": "Selecionar calendário",
    "selectTeamMember": "Selecionar membro da equipa",
    "actionRequired": "Ação obrigatória",
    "scheduleAppointment": "Agendar compromisso",
    "considerLeavingItBlank": "Pondere deixá-lo em branco, caso opte por utilizar o título do compromisso pré-configurado",
    "assignedTo": "Atribuído a",
    "download": "Descarregar",
    "loadingTranscription": "A carregar transcrição...",
    "mute": "Desativar o som",
    "playpause": "Reproduzir/pausar",
    "playbackSpeed": "Velocidade de reprodução",
    "remove": "Remover",
    "stop": "Parar",
    "timePlayedTotalTime": "Tempo de reprodução: tempo total",
    "viewTranscript": "Ver transcrição",
    "below": "abaixo",
    "calls1": "Chamadas",
    "liveChat": "Chat em direto",
    "whatsapp1": "WhatsApp",
    "chatConversationAssigned": "Conversa de chat atribuída",
    "youAreChoosingNot": "Está a escolher não eliminar e fechar a subconta de Telefone LC, o que significa que continuará a receber cobranças por todo o uso, independentemente de a localização ser cobrada ou não.",
    "thingsAreJustGetting": "As coisas estão apenas a começar, vamos explorar como a GHL pode ajudar a sua empresa a crescer.\nEntretanto, pode continuar a enviar as mensagens que quiser",
    "wohooConversationsAreFlowing": "Uau! As conversas agora estão a fluir",
    "conversationBegan": "A conversa começou a",
    "fetchOlderMessages": "Obter mensagens mais antigas",
    "inboundDndHasBeen": "O DND de entrada foi ativado para este contacto",
    "internalComment": "Comentário interno",
    "confirmByTyping": "Confirme introduzindo",
    "iConfirmToDisconnect": "Confirmo que pretendo desligar e fechar a conta de Telefone LC para esta localização. Compreendo que isto significa que todos os números e campanhas A2P serão eliminados e não poderão ser recuperados.",
    "iConfirmThatI": "Confirmo que discuti este assunto com o meu cliente e que tenho autoridade para realizar esta ação",
    "connect": "Conectar",
    "disputeThisReview": "Contestar esta revisão",
    "dndIsActiveFor": "O DND está ativo para chamadas",
    "off": "DESATIVADO",
    "done": "Concluído",
    "downloadFile": "Descarregar ficheiro",
    "AddAccount": "+ Adicionar conta",
    "attachFile": "Anexar ficheiro",
    "clickHereToAdd": "Clique aqui para adicionar um.",
    "customerName": "Nome do cliente",
    "customerPhone": "Telefone do cliente",
    "orEnterAMessage": "Ou introduza uma mensagem",
    "fromEmail": "E-mail do remetente",
    "fromName": "Nome do remetente",
    "youDontHaveAny": "Ainda não tem nenhum modelo.",
    "requestPayment": "Solicitar pagamento",
    "schedule": "Agendar",
    "selectATemplate": "Selecionar um modelo",
    "sendNow": "Enviar agora",
    "smtpProvidersHasSome": "Os fornecedores SMTP têm algumas limitações. Clique aqui para saber mais.",
    "subject": "Assunto",
    "useATemplateSnippet": "Utilizar um modelo (segmento)",
    "deliveredtotalDelivered": "{delivered}/{total} enviado",
    "countMoreEmailsIn": "Mais {count} e-mails no tópico",
    "primary": "(Primário)",
    "reply": "Responder",
    "respond": "Responder",
    "retry": "Repetir",
    "to": "Para:",
    "fbCommentReplyDm": "Responder ao comentário do FB - DM",
    "fbMessage": "Mensagem do FB",
    "theseAttachmentsMayNot": "Estes anexos podem já não ser suportados.",
    "urlCannotBeFound": "Não é possível encontrar o URL",
    "activity": "Atividade",
    "filters": "Filtros",
    "goToPost": "Ir para publicação",
    "inboundCall": "Chamada recebida",
    "instagramDm": "DM do Instagram",
    "internalChat": "Chat interno",
    "search2": "Pesquisar...",
    "starred": "Marcado",
    "leftAVoicemail": "Deixou uma mensagem de correio de voz",
    "manual": "Manual",
    "mergeFields": "Fundir campos",
    "addToDocuments": "Adicionar aos documentos",
    "failedToAddAttachments": "Falha ao adicionar anexos aos documentos",
    "attachmentsAddedToDocuments": "Anexos adicionados aos documentos com sucesso",
    "newCommentOnPagename": "Novo comentário na publicação {pageName}.",
    "outboundCall": "Chamada de saída",
    "replyAsDm": "Responder como DM",
    "replyingAsAPrivate": "A resposta como DM privada não está disponível para comentários com mais de 7 dias.",
    "reportFeedbackForAi": "Comunicar comentários para AI",
    "storyMention": "Menção à história",
    "storyReply": "Resposta à história",
    "bulkRequest": "Pedido em massa",
    "eventsAreCurrentlyCaptured": "De momento, os eventos são capturados apenas para o endereço de e-mail do contacto.",
    "failed": "Reprovado",
    "gbpMessage": "Mensagem GBP",
    "pageName": "Nome da página",
    "unknown": "Desconhecido(a)",
    "typeAMessage": "Escrever uma mensagem",
    "new": "Novo(a)",
    "newAppointmentBookedBy": "Novo compromisso marcado por",
    "customerNameRequired": "O nome do cliente é obrigatório",
    "messageIsRequired": "A mensagem é obrigatória",
    "pickATemplateTo": "Escolha um modelo a utilizar.",
    "newMessage": "Nova mensagem",
    "newTask": "Nova tarefa",
    "toMakeACall": "Para fazer uma chamada, introduza um número de telefone neste campo.",
    "primary1": "Primário",
    "provider": "Fornecedor",
    "refresh": "Atualizar",
    "resetPassword": "Repor palavra-passe",
    "thisReviewHasAlready": "Esta revisão já foi publicada em {network}. Tem a certeza de que pretende voltar a publicar?",
    "seeThisReviewOn": "Ver esta revisão sobre o GBP",
    "reviewResponse": "Rever resposta",
    "searchUsers": "Pesquisar utilizadores",
    "sendEmail": "Enviar e-mail",
    "sending": "A enviar...",
    "thisSubaccountHasPhonenumberco": "Esta subconta tem {phoneNumberCount} números e {campaignsCount} campanha(s) A2P. Se eliminar esta conta ainda incorrerá em encargos se a conta do sistema de telefone LC não for desligada e fechada.",
    "thisSubaccountDoesNot": "Esta subconta não tem números nem campanhas A2P. Se pausar esta conta não incorrerá em quaisquer encargos, mas recomendamos desligar e fechar a conta de telefone LC.",
    "summary": "Resumo",
    "unassigned": "Não atribuído",
    "viewSubmission": "Ver envio",
    "contactSupport": "Contactar suporte",
    "create": "Criar",
    "illDoThisLater": "Farei isto mais tarde",
    "enterBusinessName": "Introduzir nome da empresa",
    "firstNameOfThe": "Nome próprio do proprietário da empresa",
    "mobileBusinessPhone": "Telemóvel/Telefone da empresa",
    "iDontHaveA": "Não tenho um sítio Web",
    "clientName": "Nome do cliente",
    "letUsSetupYour": "Deixe-nos configurar a sua própria conta ou do seu primeiro cliente",
    "clientNameIsRequired": "O nome do cliente é obrigatório",
    "pleaseEnterAValid": "Introduza um endereço de e-mail válido",
    "emailAddressIsRequired": "O endereço de e-mail é obrigatório",
    "firstNameIsRequired": "O nome próprio é obrigatório",
    "lastNameIsRequired": "O apelido é obrigatório",
    "phoneNumberIsRequired": "O número de telefone é obrigatório",
    "copyOfName": "Cópia de {name}",
    "goToDashboard": "Ir para o Painel de controlo",
    "permissionsNotEnabled": "Permissões não ativadas!",
    "createAndSellCustom": "Crie e venda produtos personalizados com dropshipping de impressões a pedido",
    "viewApp": "Ver aplicação",
    "seamlessFulfillmentRealtimeShi": "Cumprimento sem complicações e taxas de expedição em tempo real para as suas lojas de comércio eletrónico",
    "learnMore": "Saiba mais",
    "activateFormMapping": "Ativar mapeamento de formulário",
    "avatarName": "Nome do avatar",
    "formFields": "Campos de formulário",
    "formName": "Nome do formulário",
    "mapFields": "Mapear campos",
    "update": "Atualizar",
    "pauseSubaccount": "Pausar subconta",
    "pausing": "A pausar...",
    "subaccount": "subconta",
    "howItWorks": "Como funciona",
    "uponCompletingThisAction": "Após a conclusão desta ação, o pedido de transferência será enviado à agência recetora ({relNo}). A subconta será transferida imediatamente depois de ser aceite. Tenha em atenção que esta ação é irreversível.",
    "ejectSubaccount": "Ejetar subconta",
    "newAgencyCreationMail": "E-mail de criação de nova agência enviado para o utilizador selecionado. O utilizador pode criar uma nova agência clicando na ligação enviada no e-mail.",
    "unableToTransferSubaccount": "Não é possível transferir a subconta para esta agência.",
    "nominateAccountOwnerFor": "Nomear proprietário da conta para a nova conta",
    "pleaseConfirmOwnershipWill": "Confirme que a propriedade será transferida para",
    "scheduledDate": "Data agendada",
    "thisDateIsBased": "Esta data baseia-se no fuso horário desta empresa, que é {timezone}",
    "campaignName": "Nome da campanha",
    "copyCampaign": "Copiar campanha",
    "endTime": "Hora de fim",
    "event10xEmail4": "Evento: 10X E-mail 4 (distribuição de listagens) ",
    "10xEmail1Reviews": "10X E-mail 1 (revisões)",
    "fromAddress": "De endereço",
    "leadValue": "Valor de oportunidade potencial",
    "option1": "Opção 1",
    "option2": "Opção 2",
    "option3": "Opção 3",
    "preview": "Pré-visualizar",
    "selectCampaign": "Selecionar campanha",
    "startTime": "Hora de início",
    "time": "Hora",
    "users": "Utilizadores",
    "noRecordsFound": "Não foram encontrados registos",
    "pageDetail": "Detalhe da página",
    "selectAll": "Selecionar tudo",
    "submission": "Envio",
    "addProduct": "Adicionar produto",
    "visitors": "visitantes",
    "By": " por",
    "conversions": "Taxa de conversão ",
    "liveReviews": "Revisões em direto",
    "liveVisitors": "Visitantes em direto",
    "pageVisits": "Visitas à página",
    "stream": "Stream",
    "addOneOrMore": "Adicione um ou mais URLs de página ou copie-os diretamente do seu navegador Web.",
    "WeWillAutomatically": " Iremos rastrear automaticamente os visitantes do seu sítio Web em tempo real. ",
    "connectYourLocationsFacebook": "Ligue a conta do Facebook da sua localização",
    "connected": "Ligada!",
    "Contains": " contém ",
    "expression": "Expressão",
    "facebookAccount": "Conta do Facebook",
    "wowYouDontNeed": "Uau! Não precisa de configurar nada aqui, pode prosseguir.",
    "Regex": " regex ",
    "selectUrlMatchType": "Selecionar tipo de correspondência de URL",
    "Simple": " simples ",
    "LivePreview": " Pré-visualização em direto",
    "seconds": "segundos",
    "launch": "Lançamento ",
    "decorativeVector1": "Vetor decorativo 1",
    "showingFromToTo": "A mostrar {from} até {to} de {total} entradas",
    "cloneProduct": "Clonar produto",
    "connectFacebookInstagram": "Ligar Facebook e Instagram",
    "connectPage": "Ligar página!",
    "everythingIn": "Tudo em",
    "agentChat25": "Chat com agente (aproximadamente 2 a 5 minutos de tempo de espera)",
    "aiSupportChat": "Chat com suporte AI",
    "startChat": "Iniciar chat",
    "locations1": "localizações",
    "phone1": "telefone",
    "slack": "Slack",
    "segments1": "segmentos",
    "areYouSureYou": "Tem a certeza de que pretende eliminar esta pasta?",
    "verified": "Verificado",
    "highlevelPrice": "Preço HighLevel",
    "howDoesItWork": "Como é que funciona?",
    "payNow": "Pague agora",
    "priceMustBeMore": "O preço tem de ser igual ou superior ao preço HighLevel",
    "saving2": "A guardar",
    "yourPrice": "O seu preço",
    "yourProfit": "O seu lucro",
    "youNeedToComplete": "Tem de completar alguns passos simples de conformidade para desativar o modo SaaS para esta localização",
    "youAreNotAuthorized": "Não tem autorização para executar esta ação. Apenas os administradores de agências podem fazê-lo.",
    "disableSaasModeFor": "Desativar modo SaaS para {name}",
    "companyBilling": "Faturação da empresa",
    "bccEmailsCommaDelimited": "E-mails BCC (delimitados por vírgulas)",
    "unableToDeleteMailgun": "Não é possível eliminar a conta Mailgun, contacte a assistência.",
    "forwardingAddress": "Endereço de reencaminhamento",
    "forwardingAddressesCommaDelimi": "Endereços de reencaminhamento (delimitados por vírgulas)",
    "amount": "Montante",
    "billingDate": "Data de faturação",
    "debugWalletTransactionsTotal": "DEPURAR transações da carteira, total: {count}",
    "detailedTransactions": "Transações detalhadas",
    "transactionsOnlyAfter26th": "As transações efetuadas apenas após 26 de abril de 2022 estão listadas e disponíveis para exportação",
    "someRecordsMayTake": "Alguns registos podem demorar 24 horas a atualizar aqui.",
    "totalBalance": "Saldo total",
    "walletTransactions": "Transações da carteira",
    "walletTransactionsAllDate": "Transações da carteira - Todas - {date}",
    "enterMessage": "Introduzir mensagem",
    "applyThisChangeTo": "Aplique esta alteração a todas as subcontas.",
    "characters": "Carateres",
    "iConfirmThatI1": "Confirmo que discuti este assunto com o meu cliente e tenho a sua aprovação.",
    "iConfirmThatI2": "Confirmo que irei garantir que todas as mensagens SMS enviadas desta conta estão em conformidade com a política atual.",
    "theContentsOfThis": "O conteúdo desta mensagem será adicionado automaticamente ao primeiro SMS enviado através de mensagens em massa.",
    "iConfirmThatSms": "Confirmo que as mensagens SMS só serão enviadas aos contactos que optaram por receber SMS.",
    "quickTip": "Dica rápida",
    "messageWillBeAppended": "A mensagem será anexada ao primeiro SMS de uma conversão se não contiver linguagem de exclusão",
    "readMore": "Ler mais",
    "noncompliantActivityMayLead": "A atividade que não estiver em conformidade pode levar à suspensão das funcionalidades relacionadas com SMS e voz da sua conta.",
    "typeConfirmBelowTo": "Escreva Confirmar abaixo para prosseguir",
    "products": "Produtos",
    "chooseCountry": "Escolher país...",
    "email2": "E-mail*",
    "firstName1": "Nome próprio*",
    "lastName1": "Apelido*",
    "brandDetails": "Detalhes da marca",
    "brandName": "Nome da marca*",
    "useEitherLegalName": "Utilize o nome legal da organização que está a enviar as mensagens ou o seu próprio nome, caso esta marca não seja de uma organização.",
    "businessIndustry": "Indústria da empresa*",
    "chooseVertical": "Escolher vertical...",
    "mobileNumberForOtp": "Número de telemóvel para verificação com OTP (com indicativo do país)*",
    "pleaseProvideAMobile": "Indique um número de telemóvel ao qual tenha acesso, para poder confirmar a verificação com OTP. Apenas serão aceites números dos EUA/Canadá. Não pode utilizar um número de telefone CPaaS, como um obtido do LeadConnector. Não pode usar o mesmo número de telemóvel para registar mais de 3 marcas de empresário em nome individual. Este limite é gerido pelo TCR.",
    "increasedDeliveryRate": "Aumento da taxa de entrega",
    "sendUpto3000Segments": "Enviar até 3000 segmentos por dia",
    "businessDetails": "Detalhes da empresa",
    "thereWasSomeIssue": "Houve um problema ao enviar o perfil.",
    "yourProfileSubmissionFailed": "Falha no envio do perfil.",
    "endUserConsent": "Consentimento do utilizador final",
    "minLength40Characters": "Comprimento mínimo: 40 carateres. Comprimento máximo: 2048 carateres.",
    "closeExamples": "Fechar exemplos",
    "sampleMessage1": "Mensagem de amostra n.º 1*",
    "seeExamples": "Ver exemplos",
    "enterCampaignDetails": "Introduzir detalhes da campanha",
    "youWillReceiveAn": "Vai receber uma mensagem OTP no número de telemóvel fornecido para verificar a partir do TCR. Responda Yes no prazo de 24 horas após receber o SMS.",
    "brandNameIsRequired": "O nome da marca é obrigatório.",
    "businessVerticalIsRequired": "O vertical da empresa é obrigatório.",
    "mobileNumberIsRequired": "O número de telemóvel é obrigatório.",
    "hideDetail": "Ocultar detalhe",
    "showDetail": "Mostrar detalhe",
    "people": "pessoas",
    "person": "pessoa",
    "after": "depois de",
    "before": "antes de",
    "hour": "hora",
    "hours": "horas",
    "minute": "minuto",
    "minutes": "minutos",
    "triggerLinksEmbeddedIn": "ligações de acionadores (incorporadas na mensagem) clicadas como % das mensagens enviadas",
    "addNewEvent": "Adicionar novo evento",
    "addTask": "Adicionar tarefa",
    "manualCall": "Chamada manual",
    "manualSms": "SMS Manual",
    "messenger": "Messenger",
    "wait": "Aguardar",
    "webhook": "Webhook",
    "about": "Acerca de",
    "accessRestricted": "Acesso restrito",
    "addPartner": "Adicionar parceiro",
    "addPartnerForm": "Adicionar formulário de parceiro",
    "affiliatePortal": "Portal de afiliados",
    "badges": "Distintivos",
    "aBriefBio": "Uma breve biografia",
    "dashboard": "Painel de controle",
    "experience": "Experiência",
    "industryServed": "Indústria servida",
    "instagramAccount": "Conta do Instagram",
    "invoiceHistory": "Histórico de faturas",
    "englishGermanHindi": "Inglês, alemão, hindi",
    "linkToWebsite": "ligação para o sítio Web",
    "linkedinAccount": "Conta do LinkedIn",
    "locationId": "ID da localização",
    "partnerName": "Nome do parceiro",
    "partnerStatus": "Estado do parceiro",
    "paymentDetails": "Detalhes do pagamento",
    "paymentHistory": "Histórico de pagamentos",
    "profilePhoto": "Fotografia de perfil",
    "profilePhotoUrl": "url da fotografia de perfil",
    "promoterReports": "Relatórios de promotores",
    "searchPartner": "Pesquisar parceiro",
    "twitterAccount": "Conta do Twitter",
    "updatePartner": "Atualizar parceiro",
    "updatePartnerForm": "Atualizar formulário de parceiro",
    "yearOfExperience": "ano de experiência",
    "youtubeAccount": "Conta do YouTube",
    "serviceProvided": "Serviço prestado",
    "controlTheSubaccountSettings": "Controlar as Definições da Subconta",
    "generalInfo": "Informações gerais",
    "okay": "OK",
    "proceed": "Prosseguir",
    "addCard": "Adicionar cartão",
    "makeThisCardPrimary": "Definir este cartão como primário",
    "nameOnCard": "Nome no cartão",
    "chargedToCustomer": "Cobrado ao cliente",
    "clientBillingPage": "Página de faturação do cliente",
    "companyStripeIntegrationPage": "Página de integração com Stripe da empresa",
    "enableRebilling": "Ativar faturação recorrente",
    "enabling": "A ativar...",
    "forMoreDetails": "para obter mais detalhes.",
    "youreOnTheFreelancer": "Está no plano Trabalhador independente, que tem um limite de marcações de 1,05x.",
    "minimumAmountShouldBe": "O montante mínimo deve situar-se entre ${min} e ${max}",
    "beforeEnablingThisFeature1": "Antes de ativar esta caraterística, ligue a sua conta Stripe na",
    "planToSetYour": "planeie aumentar as suas margens.",
    "rebillAmount": "Montante da faturação recorrente",
    "supportDoc": "documento de suporte",
    "10WillGiveYou": "10 $ dá para cerca de",
    "minimumMustBeBetween": "O mínimo deve estar entre 0,0001 e 0,005",
    "sorryYouCannotRebillAtTheMarkup": "Desculpe! Não pode refaturar com a marcação no plano Trabalhador independente",
    "modifyingTheseSettingsWillChange": "A modificação destas definições irá alterar o custo incorrido pelos seus clientes daqui para a frente.",
    "pleaseDoNotModifyThese": "Não as modifique se não tiver a certeza dos seus efeitos.",
    "theseSettingsWillApply": "Estas definições serão aplicadas aos seus novos clientes daqui para a frente",
    "congratulationsYourDedicatedIp": "Parabéns! O seu valor de revenda de IPs dedicados foi guardado com sucesso.",
    "youHaveAgreedToProvide": "Concordou em fornecer IPs dedicados diretamente a uma subconta. A agência cobrirá os encargos em nome da subconta.",
    "youHaveDiscontinuedToProvide": "Deixou de fornecer IPs dedicados diretamente a uma subconta. A agência deixará de cobrir os encargos em nome da subconta.",
    "oopsSomethingWentWrongAndWeCouldnt": "Ups! Algo correu mal e não conseguimos guardar a sua configuração de revenda de IPs dedicados. Tente novamente mais tarde.",
    "pleaseAgreeToTheTerms": "Por favor, aceite os termos",
    "errorWhileFetchingDomains": "Erro ao obter domínios",
    "sameStripeCustomerProfileCantBeMapped": "O mesmo perfil de cliente Stripe não pode ser associado a mais de uma subconta.",
    "pleasePickADifferentStripeCustomer": "Escolha um perfil de cliente Stripe diferente ou utilize a opção \"Partilhar uma ligação\" para que possamos criar um novo perfil de cliente Stripe para esta subconta.",
    "clickNextToChooseAPlan": "Clique em \"Seguinte\" para escolher um plano e criar uma nova assinatura.",
    "youDontHaveAnyActiveSubscriptions": "Não tem nenhuma assinatura ativa",
    "youCanEitherSelectAnExistingSubscription": "Pode selecionar uma subscrição existente ou criar uma nova subscrição no passo seguinte.",
    "useCommasToSeparateMultipleEmails": "Utilize vírgulas para separar vários e-mails.",
    "useCommasToSeparateMultiplePhoneNumbers": "Use vírgulas para separar vários números de telefone.",
    "noUserFoundInThisLocation": "Nenhum utilizador encontrado nesta localização",
    "noPhoneNumberAttached": "Nenhum número de telefone associado",
    "pleaseUseTheFollowingLinkToAttachYourPaymentMethod": "Por favor, utilize a seguinte ligação para anexar o seu método de pagamento.",
    "allowDuplicateContact": "Permitir contacto duplicado",
    "allowDuplicateOpportunity": "Permitir oportunidade duplicada",
    "mergeFacebookContactsByName": "Unir contactos do Facebook por nome",
    "onlyIncomingMessagesFromFacebookWillBeMerged": "Apenas as mensagens recebidas do Facebook serão unidas se corresponderem ao nome de um contacto existente. Os nomes são sensíveis a maiúsculas e minúsculas.",
    "disableContactTimezone": "Desativar fuso horário de contacto",
    "markEmailsAsInvalidDueToHardBounce": "Marcar e-mails como inválidos devido a rejeição permanente",
    "contactsEmailsWillBeMarkedAsInvalid": "Os e-mails dos contactos serão marcados automaticamente como inválidos quando forem rejeitados. As ações de e-mail em Automatizações serão ignoradas para contactos com e-mails inválidos.",
    "gatherIntelligenceOnUnknownPhoneNumbers": "Obter informações sobre números de telefone desconhecidos",
    "makeSmsCompliantByAddingAnOptOutMessage": "Crie SMS compatíveis adicionando uma mensagem de exclusão.",
    "ifActivatedTheOptOutMessageWillBeAutomaticallyAdded": "Se ativada, a mensagem de exclusão será adicionada automaticamente ao primeiro SMS enviado via Mensagens em massa para garantir a conformidade e aumentar as taxas de entrega.",
    "platformLanguage": "Idioma da plataforma",
    "outboundCommunicationLanguageForCustomValues": "Idioma de comunicação de saída para valores personalizados",
    "updateInformation": "Atualizar informações",
    "upgradeToTheAgency": "Faça upgrade para o plano Agência Pro",
    "yourCost": "O seu custo",
    "addACalendarTo": "Adicione um calendário para começar a marcar compromissos.",
    "addselectAContactTo": "Adicionar/selecionar um contacto para agendar compromissos",
    "appointmentSlotIsNot": "O período de compromisso ainda não foi selecionado",
    "loading1": "A carregar...",
    "teamMemberIsRequired1": "O membro da equipa é obrigatório",
    "currentPlan": "Plano atual",
    "features1": "Caraterísticas",
    "upgrade": "Fazer upgrade",
    "viewLess": "Ver menos",
    "viewMoreCount": "Ver mais (+{count})",
    "cardNumber": "Número do cartão",
    "expiryDate": "Data de validade",
    "paymentMethods": "Métodos de pagamento",
    "primaryCard": "Cartão primário",
    "removeCurrentCard": "Remover Cartão Atual",
    "AddBalance": "+ Adicionar saldo",
    "complimentaryCredits": "Créditos gratuitos:",
    "expiringOnDate": "A expirar a {date}",
    "apiVersion": "Versão da API",
    "application": "Aplicação",
    "ipAddress": "Endereço IP",
    "related": "Relacionado",
    "request": "Pedido",
    "yourAccountIncludingAll": "A sua conta, incluindo toda a atividade de saída, como mensagens agendadas e e-mails, será interrompida imediatamente.",
    "yourAccountIncludingAll1": "A sua conta, incluindo toda a atividade de saída, como mensagens agendadas e e-mails, será interrompida imediatamente.",
    "nextBillingDateDate": "Próxima data de faturação: {date}",
    "scheduledForCancellation": "Agendada para cancelamento",
    "abandoned": "Abandonado(a)",
    "add1": "Adicionar",
    "addOpportunity": "Adicionar oportunidade --",
    "addOpportunityName": "Adicionar nome da oportunidade",
    "Task": "+ Tarefa",
    "bookupdateAppointment": "Marcar/atualizar compromisso",
    "companyName": "Nome da empresa",
    "areYouSureYou1": "Tem a certeza de que pretende eliminar esta oportunidade?",
    "contactInfo": "Informações de contacto",
    "editOpportunity": "Editar oportunidade --",
    "enterValue": "Introduzir valor",
    "goToContactDetail": "Ir para a página de detalhes do contacto",
    "leads": "Oportunidades potenciais",
    "lost": "Perdidas",
    "nameIsRequired": "O nome é obrigatório.",
    "youreNotAllowedTo": "Não tem permissão para alterar o nome do cliente! Verifique as suas permissões junto do administrador da agência.",
    "open": "Aberto",
    "opportunity": "Oportunidade",
    "opportunityAlreadyExistsIn": "A oportunidade já existe neste pipeline",
    "opportunityInfo": "Informações da oportunidade",
    "opportunityName": "Nome da oportunidade",
    "opportunitySource": "Fonte da oportunidade",
    "owner": "Proprietário",
    "pipeline": "Pipeline",
    "removeOwner": "Remover proprietário",
    "selectPipeline": "Selecionar pipeline",
    "selectStage": "Selecionar fase",
    "stage": "Fase",
    "countTasks": "{count} tarefas",
    "won": "Ganhas",
    "and": "e ainda ",
    "addASubscription": "Adicionar uma assinatura",
    "noSaasPlanEnabled": "Nenhum plano SaaS ativado",
    "per": "por",
    "assignTo": "Atribuir a",
    "assignedTo1": "Atribuído a:",
    "areYouSureYou2": "Tem a certeza de que pretende eliminar esta tarefa?",
    "due": "Devido:",
    "dueDateIsRequired": "A data de vencimento é obrigatória",
    "dueIn": "Devido em",
    "dueToday": "Devido hoje",
    "late": "Atrasado",
    "notAssigned": "Não atribuído",
    "taskDescription": "Descrição da tarefa",
    "taskTitle": "Título da tarefa",
    "annually": "anualmente",
    "attachments": "Anexo(s)",
    "areYouSureYou3": "Tem a certeza de que pretende eliminar este pedido em massa?",
    "startImmediately": "Comece imediatamente",
    "customers": "Clientes",
    "tag": "Etiqueta",
    "pickType": "Escolher tipo",
    "whoShouldItRun": "Para quem deve ser executado?",
    "addBulkRequest": "Adicionar pedido em massa",
    "editBulkRequest": "Editar Pedido em Massa",
    "scheduledDateIsRequired": "A data de agendamento é obrigatória",
    "newCampaignName": "Nome da nova campanha",
    "areYouSureYou4": "Tem a certeza de que pretende eliminar esta campanha?",
    "moveToFolder": "Mover para pasta",
    "pleaseRename": "mude o nome",
    "removeFromFolder": "Remover da pasta",
    "photoPreview": "pré-visualização da fotografia",
    "pleaseWait": "Aguarde...",
    "customValues": "Valores personalizados",
    "whatActionShouldWe": "Que ação devemos realizar?",
    "entitynameName": "Nome de {entityName}",
    "useLcEmail": "Utilizar LC Email",
    "21Jun2018": "21 de junho de 2018",
    "930Am": "9:30",
    "Via": " via ",
    "createdTrackingNumbers": "Números de rastreio criados",
    "iUnderstandImBuyingadding": "Compreendo que estou a comprar/adicionar {count} novos números de telefone.",
    "forwardCallsTo": "Reencaminhar chamadas para",
    "numberName": "Nome do número",
    "numberPoolName": "Nome do conjunto de números",
    "numberToSwap": "Número a trocar",
    "sameAsForwardingNumber": "Igual ao número de reencaminhamento",
    "callFromSource": "Ligue a partir de [Source].",
    "callRecording": "Gravação de chamadas",
    "84Complete": "84% concluído",
    "thisCallWillBe": "Esta chamada será gravada para fins de controlo de qualidade.",
    "whisperMessage": "Mensagem sussurrada",
    "allExceptDirect": "Todos exceto direto",
    "allExceptDirectOrganic": "Todos exceto Direct & Organic",
    "allSearch": "Todas as pesquisas",
    "allVisitorsRecommended": "Todos os visitantes (recomendado)",
    "bing": "Bing",
    "direct": "Direto",
    "visitorsWithoutAReferring": "Visitantes sem um sítio Web de referência",
    "for": "para",
    "google": "Google",
    "landingPageOrUrl": "Página de destino ou parâmetro de URL",
    "organic": "Orgânico",
    "paid": "Pago",
    "pickOneYouCan": "Escolha um - pode sempre alterar isto mais tarde.",
    "ppcSearch": "Pesquisa PPC",
    "visitorsFromGoogleBing": "Visitantes da pesquisa PPC do Google, Bing e Yahoo",
    "referringPage": "Página de referência",
    "visitorsFrom": "Visitantes de",
    "visitorsFromGoogleAds": "Visitantes do Google Ads",
    "visitorsWhoAreReferred": "Visitantes que são referidos de",
    "visitorsWhoLandOn": "Visitantes que chegam à",
    "whichVisitorsDoYou": "Que visitantes quer rastrear?",
    "yahoo": "Yahoo",
    "17Complete": "17% concluído",
    "callTimeoutS": "Tempo limite da chamada (s)",
    "callWhisper": "Sussurro de chamada",
    "disableVoicemailDetect": "Desativar a deteção de correio de voz",
    "eventName": "Nome do evento",
    "timeoutSeconds": "Tempo limite (segundos)",
    "editCall": "Editar chamada",
    "callWillPatchInstantly": "A chamada será efetuada instantaneamente, não ouviremos para ver se o correio de voz atendeu do lado das oportunidades potenciais. Isto significa que a campanha será marcada como respondida mesmo que o correio de voz atenda.",
    "thisIsTheMessage": "Esta é a mensagem que pretende que a pessoa que atende o telefone ouça; pode usar variáveis personalizadas para personalizar esta mensagem.",
    "pleaseCheckTheLinks": "Verifique as ligações onde tem um valor personalizado. Há um \"%20\" extra entre {{ e custom_values.",
    "anErrorOcurredPlease": "Ocorreu um erro, tente novamente.",
    "pleaseInsertATo": "Insira um endereço de destinatário.",
    "pickEmailTemplate": "Selecionar modelo de e-mail",
    "sendTest": "Enviar teste",
    "composeEmail": "Compor e-mail",
    "composeEmailTemplate": "Compor modelo de e-mail",
    "toAddress": "Endereço do destinatário",
    "addFileThroughUrl": "Adicionar ficheiro através do URL",
    "appCharacters": "Carateres da aplicação:",
    "approximateCost": "Custo aproximado:",
    "estimatedCostForUs": "Custo estimado apenas para SMS dos EUA para os EUA.",
    "mobilePhoneNumber": "Número de telemóvel",
    "numSegments": "Número de segmentos",
    "pickMessageTemplate": "Escolher modelo de mensagem",
    "pleaseProvideAPhone": "Indique um número de telefone para enviar o teste.",
    "composeEventtype": "Compor {eventType}",
    "composeEventtypeTextTemplate": "Compor {eventType} – Modelo de texto",
    "unsupportedSmsContentType": "Tipo de conteúdo SMS não suportado {fileType}",
    "countOfTheProvided": "{count} dos anexos de URL fornecidos {plural} não é uma imagem. Isto pode causar erros no Twilio. Deseja guardar na mesma?",
    "dropFileHereOr": "Arraste o ficheiro aqui ou clique para carregar",
    "ifYouHaveAdditional": "Se tiver mais alguma questão, consulte as FAQ sobre o envio de correio de voz na secção de ajuda.",
    "editVoicemail": "Editar correio de voz",
    "selectAMp3Or": "Selecione um ficheiro mp3 ou wav; não suportamos outros formatos.",
    "voicemailFile": "Ficheiro de correio de voz",
    "warningVoicemailDropsAre": "Aviso: os envios de correio de voz são um sistema de melhor tentativa e funcionam cerca de 70% das vezes.",
    "youNeedToPick": "Tem de selecionar pelo menos 1 dia",
    "editWait": "Editar espera",
    "url": "URL",
    "customTime": "Hora personalizada",
    "executeThisActionIf": "Execute esta ação se a hora atual estiver dentro deste período; se a hora atual estiver fora, ignore este passo e avance para a ação seguinte.",
    "pickDays": "Escolher dias",
    "pickTime": "Escolher hora",
    "noRecordsFound1": "Não foram encontrados registos.",
    "formAnalyze": "Análise de formulário",
    "totalSubmission": "Envio total",
    "forgotPassword": "Esqueceu-se da palavra-passe?",
    "orContinueWith": "Ou continue com",
    "signIn": "Iniciar sessão",
    "signIntoYourAccount": "Inicie sessão na sua conta",
    "thePasswordYouPicked": "A palavra-passe que escolheu",
    "yourEmailAddress": "O seu endereço de e-mail",
    "newEmailFrom": "Novo e-mail de",
    "newMessageFrom": "Nova mensagem de",
    "hasLeftANew": "deixou uma nova revisão.",
    "repliedToTheReview": "respondeu à revisão.",
    "loaded": "Carregado",
    "snapshot": "Instantâneo",
    "appointment": "Compromisso",
    "appointmentDueInMinutes": "Compromisso agendado para daqui a {minutes} minutos para {contactName}",
    "appointmentReminder": "Lembrete de compromisso",
    "completedCount": "Concluído: {count}",
    "conversation": "Conversar",
    "facebookReview": "Revisão do Facebook",
    "failedCount": "Falhou: {count}",
    "googleReview": "Revisão do Google",
    "internalChatMessage": "Mensagem de chat interna",
    "usernameMentionedYouIn": "{userName} mencionou-o numa conversa com {contactName}",
    "newAppointmentAssigned": "Novo compromisso atribuído",
    "aNewAppointmentWith": "Foi-lhe atribuído um novo compromisso com {contactName}.",
    "newAppointmentBooked": "Novo compromisso marcado",
    "youHaveNewAppointment": "Tem um novo compromisso marcado com {contactName}",
    "newCall": "Nova chamada",
    "aNewChatWith": "Foi-lhe atribuído um chat novo com {contactName}.",
    "newEmail": "Novo e-mail",
    "newMention": "Nova menção",
    "newReviewReceivedFrom": "Nova revisão recebida de {contactName}",
    "aNewTypeIs": "Um novo {type} foi recebido de {contactName}",
    "notification": {
      "noRecentActivity": "Nenhuma atividade recente"
    },
    "subAccount": "Subconta",
    "subaccount1": "Subconta:",
    "titleOnDateAt": "{title} a {date} à(s) {time} para {contactName}",
    "titleDueInDuetime": "{title} para concluir em {dueTime} {unitOfTime} para {contactName}",
    "taskReminder": "Lembrete de tarefa",
    "youHaveCountTasks": "Tem {count} atividades para concluir hoje",
    "youHaveCountTasks1": "Tem {count} atividades em atraso até agora",
    "droppedVoicemailTo": "Enviou correio de voz para",
    "errorWhileCloningProduct": "Erro ao clonar o produto!",
    "productName": "Nome do produto",
    "selectLocations": "Selecionar localizações",
    "selectUptoMaxselectablelocatio": "Selecione até {maxSelectableLocations} localizações",
    "highlevelInc": "HighLevel Inc.",
    "CountMore": "+ {count} mais",
    "emails": "E-mails",
    "accountNotification": "Notificação de conta",
    "customerCare": "Apoio ao cliente",
    "deliveryNotification": "Notificação de entrega",
    "fraudAlertMessaging": "Mensagens de alerta de fraude",
    "higherEducation": "Ensino superior",
    "lowVolumeMixedRecommended": "Híbrida de baixo volume (recomendado)",
    "mixed": "Híbrida",
    "pollingAndVoting": "Sondagens e votação",
    "publicServiceAnnouncement": "Anúncio de serviço público",
    "securityAlert": "Alerta de segurança",
    "mixedRecommended": "Híbrida (recomendado)",
    "australiaCompanyNumberFrom": "Austrália: Número de empresa de ASIC (ACN)",
    "canadaCanadianBusinessNumber": "Canadá: Número de empresa canadiano (CBN)",
    "indiaCorporateIdentityNumber": "Índia: Número de Identificação Empresarial",
    "greatBritainCompanyNumber": "Grã-Bretanha: Número de empresa",
    "usaEmployerIdentificationNumbe": "EUA: Número de identificação do empregador (EIN)",
    "other": "Outro",
    "israelRegistrationNumber": "Israel: Número de registo",
    "estoniaVatNumber": "Estónia: Número de IVA",
    "cooperative": "Cooperativa",
    "corporation": "Empresa",
    "limitedLiabilityCompanyOr": "Sociedade de responsabilidade limitada ou Empresa unipessoal",
    "nonprofitCorporation": "Empresa sem fins lucrativos",
    "partnership": "Parceria",
    "ceo": "CEO",
    "cfo": "CFO",
    "director": "Diretor",
    "generalCounsel": "Diretor jurídico",
    "onlineTrainingEducation": "Formação e educação online",
    "financialServices": "Serviços financeiros",
    "fitnessLifestyle": "Fitness e estilo de vida",
    "healthMedical": "Saúde e serviços médicos",
    "homeServices": "Serviços domésticos",
    "legalServices": "Serviços jurídicos",
    "marketingAdvertising": "Marketing e publicidade",
    "others": "Outros",
    "realEstate": "Imobiliário",
    "restaurants": "Restaurantes",
    "retailEcommerce": "Retalho e comércio eletrónico",
    "yourInformationHasBeen": "A sua informação foi enviada com sucesso.",
    "somethingWentWrong1": "Algo correu mal",
    "newPassword": "Nova palavra-passe",
    "proceedToLogin": "Continuar para o início de sessão",
    "anyTime": "em qualquer altura.",
    "callUsHighlevelSupport": "Contacte o Suporte HighLevel através de",
    "troubleLoggingIn": "Está a ter dificuldades em iniciar sessão?",
    "sendSecurityCode": "Enviar código de segurança",
    "sendCodeToEmail": "Enviar código para o e-mail",
    "verifySecurityCode": "Verificar código de segurança",
    "privacyPolicy": "Política de Privacidade",
    "businessProfile": "Perfil de empresa",
    "reserveWithGoogleIntegration": "Reservar com integração do Google",
    "friendlyName": "Nome amigável",
    "updateCallerId": "Atualizar identificador de chamadas",
    "internationalFormat": "Formato internacional",
    "localFormat": "Formato local",
    "poolNumbers": "Números em conjuntos",
    "swappingNumbers": "Troca de números",
    "selectField": "Selecionar campo",
    "surveyAnalyze": "Analisar inquérito",
    "locationIsRequired": "A localização é obrigatória.",
    "newSurveyName": "Nome do novo inquérito",
    "copySurvey": "Copiar inquérito",
    "primaryCalendar": "Calendário principal",
    "cloneEntityname": "Clonar {entityName}",
    "youHaveSuccessfullySubmitted": "Enviou os documentos com sucesso",
    "addCustomValue": "Adicionar valor personalizado",
    "value": "Valor",
    "youHaveSuccessfullyDeleted": "Eliminou o pacote com sucesso.",
    "bundleDeletedSuccessfully": "Pacote eliminado com sucesso",
    "thereIsAnIssue": "Existe um problema com um dos seus documentos comprovativos. Reveja os documentos comprovativos e o(s) motivo(s) de rejeição.",
    "connect1": "Ligar!",
    "itSeemsEitherThe": "Parece que a ligação ao Google está interrompida ou não está a ser estabelecida na localização atual. Verifique as definições de integrações e volte a integrar se a ligação já existir.",
    "selectPage": "Selecionar página",
    "somethingWentWrongPlease": "algo correu mal, tente novamente",
    "accept": "Aceitar",
    "moreThan1Phone": "Mais de 1 número de telefone permitido",
    "byContinuingToUse": "Ao continuar a usar a plataforma HighLevel, concorda com estes novos {termsLink} e {privacyLink}.",
    "byContinuingToUse1": "Ao continuar a usar a plataforma HighLevel, concorda com estes novos",
    "termsOfService": "Termos de Serviço",
    "weHaveUpdatedOur": "Atualizámos os nossos Termos de Serviço e Política de Privacidade, não deixe de os consultar!",
    "newTriggerName": "Nome do novo acionador",
    "triggerName": "Nome do acionador",
    "disableDndForSpecific": "Desativar DND para canais específicos",
    "selectAdAccount": "Selecionar a conta de anúncios",
    "selectAppointmentStatus": "Selecionar estado do compromisso",
    "below1": "abaixo.",
    "Required": "* obrigatório",
    "whenYouGetA": "Quando receber uma nova revisão, iremos publicá-la automaticamente na sua página do Facebook. Lembre-se de que a melhor prática é publicar um máximo de 3 revisões por dia na sua conta.",
    "skip": "Ignorar",
    "copyShareLink": "Copiar ligação de partilha",
    "agencyRelationshipNumbers": "Números de relações com a agência",
    "alteast1AgencyRelationship": "É necessário pelo menos 1 número de relação com a agência.",
    "alteast1SubaccountId": "É necessário pelo menos 1 ID de subconta.",
    "somethingWentWrongWhile": "Algo correu mal enquanto estava a guardar. Tente novamente mais tarde!",
    "5PerPage": "5 por página",
    "10PerPage": "10 por página",
    "amountMustGreaterOr": "O montante deve ser maior ou igual a 1 dólar AUD.",
    "regions": {
      "africa": "África",
      "asia_pacific": "Ásia/Pacífico",
      "europe": "Europa",
      "latin_america": "América Latina",
      "usa_and_canada": "EUA e Canadá",
      "asia": "Ásia",
      "latinAmerica": "América Latina",
      "usaCanada": "EUA e Canadá"
    },
    "expandIcon": "►",
    "noEntriesToShow": "Não existem entradas para mostrar",
    "clear": "Limpar",
    "filter": "Filtrar",
    "test": "Teste",
    "createNewTwilioSubAccountText": "Terá de criar uma nova conta Twilio, atualizar as credenciais dessa conta nas definições do Twilio e mover os números de telefone antes de ativar a faturação recorrente.",
    "viewing": "Visualizar",
    "makeSmsCompliantByAddingASenderInformation": "Crie SMS compatíveis adicionando informações do remetente.",
    "makeEmailCompliantByAddingAnUnsubscribeLinkInYourEmail": "Torne o e-mail compatível adicionando uma ligação de anulação de subscrição no seu e-mail",
    "enableMissedCallTextBack": "Ativar texto de retorno para chamadas não atendidas",
    "productInventory": "Inventário de Produtos",
    "viewProductVariants": "Ver Variantes do Produto",
    "smtpSettings": "Definições SMTP",
    "locationOPMTrafficStatis": "Estatísticas de Tráfego de Localização OPM",
    "locationGPMTrafficStatis": "Estatísticas de tráfego de localização GPM",
    "blacklistMonitorReports": "Relatórios do monitor de lista negra",
    "twoFactorAuthentication": "Autenticação de dois fatores (2FA)",
    "recent": "Recente",
    "noPermission": "Não tem permissão para gerir modelos para este produto. A redirecionar para o painel de controlo.",
    "tasksNowHave": "As tarefas agora têm",
    "option": "Opção",
    "facebookAdsReporting": "Relatórios de anúncios do Facebook",
    "googleAdsReporting": "Relatórios do Google Ads",
    "adsDatePicker": "Selecionador de datas de anúncios",
    "feedbackSubmitBtn": "Botão Enviar comentários",
    "ifYouThinkMistakePleaseContact": "Se acha que isto é um erro, contacte",
    "forResolution": "para resolução.",
    "live": "Em direto",
    "payouts": "Pagamentos",
    "greatChoice": "Ótima escolha!",
    "toNavigate": "navegar",
    "teams": "Equipas",
    "role": "Função",
    "searchAccounts": "Pesquisar Contas",
    "searchByNameEmailPhone": "Pesquisar por nome, e-mail ou telefone",
    "addEmployee": "Adicionar funcionário",
    "removeFromLocation": "Remover da localização",
    "knowMore": "Saiba mais",
    "usingNumberPool": "Utilizar o conjunto de números",
    "numbers": {
      "zero": "0",
      "one": "1"
    },
    "multiplier": "x",
    "reviewer": "Revisor",
    "cancel1": "Cancelar",
    "delete1": "Eliminar",
    "call1": "Chamada",
    "message1": "Mensagem",
    "name1": "Nome",
    "voicemail1": "Correio de voz",
    "title1": "Título",
    "choose_one": "Selecione um",
    "select_page": "Selecione a página",
    "confirm1": "Confirmar",
    "conversations1": "Conversas",
    "copied1": "Copiado",
    "timeOfDay": {
      "am": "Manhã",
      "pm": "Tarde/noite"
    },
    "back1": "Voltar",
    "details1": "Detalhes",
    "month1": "/mês",
    "select1": "Selecionar",
    "share1": "Partilhar",
    "facebook1": "Facebook",
    "sidebar": {
      "blacklistMonitorReports": "Relatórios do monitor de lista negra",
      "domainPurchase": "Aquisição de domínio"
    },
    "confirmDelete": "Tem a certeza de que pretende eliminar {name}?",
    "clicked1": "Clicado",
    "delivered1": "Entregue",
    "invalid1": "Inválido",
    "open_options": "Abrir opções",
    "_add_account": "Adicionar conta",
    "setTimezoneWarning": "Defina o fuso horário da sua localização para obter os períodos grátis adequados.",
    "save1": "Guardar",
    "action1": "Ação",
    "actions1": "Ações",
    "all1": "Tudo",
    "previous1": "Anterior",
    "results1": "Resultados",
    "next1": "Seguinte",
    "payments1": "Pagamentos",
    "settings1": "Definições",
    "total_js_heap": "Total de Heap JS",
    "table": {
      "pagination": {
        "previous": "Anterior",
        "next": "Seguinte"
      },
      "rowsSelected": "{count} linhas selecionadas",
      "cantRearrange": "{type} não pode ser reorganizado"
    },
    "ivrCall": "Chamada IVR",
    "sms": "SMS",
    "username": "Nome de utilizador",
    "stay": "Ficar",
    "placeholders": {
      "selectCountry": "Selecione o seu país",
      "nameOfBusiness": "Nome da Empresa",
      "line1": "Linha 1",
      "line2": "Linha 2",
      "enterState": "Introduzir distrito",
      "enterCity": "Introduzir cidade",
      "enterPostalCode": "Introduzir código postal",
      "chooseCountry": "Selecionar país..."
    },
    "addressLine1": "Linha de endereço 1",
    "addressLine2": "Linha de endereço 2",
    "postalCode": "Código postal",
    "nameOfBusiness": "Nome da empresa",
    "dispute_this_review": "Contestar esta revisão",
    "story_mention": "Menção à história",
    "story_reply": "Resposta à história",
    "no": "Não",
    "yes": "Sim",
    "annual": "anual",
    "plan": "Plano",
    "errors": {
      "somethingWrong": "Algo correu mal"
    },
    "zero": "0",
    "perMonth": "por mês",
    "emailCheckLinks": "Verifique as ligações onde tem um valor personalizado. Há um \"%20\" extra entre {{ e custom_values.",
    "fileSizeTooLarge": "O tamanho do ficheiro é superior a 5 MB",
    "fileSizeTooLargeDescription": "O ficheiro que está a tentar carregar é demasiado grande. Tente com um ficheiro de tamanho inferior",
    "minMaxLength40Characters2048Characters": "Comprimento mínimo: 40 caracteres. Comprimento máximo: 2048 caracteres.",
    "sampleMessage2": "Mensagem de exemplo #2*",
    "pleaseSelectWorkflow": "Selecione um fluxo de trabalho",
    "childrens": "Infantil",
    "brandAndCampaignRegistration": "O registo da marca e da campanha terá uma cobrança única de 20,95 $. Será aplicada uma taxa de campanha adicional de até 2,25 $ por mês, de acordo com as regras do TCR.",
    "einRequiredForRegistration": "EIN obrigatório para o registo",
    "changed_props": "Propriedades alteradas",
    "total_memory": "Memória Total",
    "total_store_size": "Tamanho total da loja",
    "total_watchers": "Total de Observadores",
    "update_count": "Atualizar contagem"
  },
  "contacts": {
    "bulkRequests": {
      "bulkActions": "Ações em massa",
      "clickHere": "Clique aqui para ver a lista de ações em massa.",
      "mergedMessage": "Esta página foi fundida com a lista de ações em massa.",
      "title": "Pedidos de contacto"
    }
  },
  "conversations": {
    "noConversationsFound": "Nenhuma {status} conversa encontrada",
    "create_new": "Criar nova mensagem​",
    "validations": {
      "minCharsRequired": "Mínimo de 3 caracteres necessários",
      "twoMoreCharsRequired": "São necessários mais 2 caracteres",
      "oneMoreCharRequired": "É necessário mais 1 carácter"
    },
    "sortLabels": {
      "latestAllMessages": "Mais recentes - Todas as mensagens",
      "oldestAllMessages": "Mais antigas - Todas as mensagens",
      "latestManualMessages": "Mais recentes - Mensagens manuais",
      "oldestManualMessages": "Mais antigas - Mensagens Manuais",
      "latestAll": "Mais recentes - Todas",
      "oldestAll": "Mais antigas - Todas",
      "latestManual": "Manuais mais recentes",
      "oldestManual": "Manuais mais antigas",
      "highToLow": "{name} (do mais alto para o mais baixo)",
      "manualMessagesTooltip": "A opção de ordenação será aplicável às mensagens após 18 de maio de 2023."
    },
    "deleteConversation": {
      "title": "Confirmação",
      "confirmWithName": "Tem a certeza de que pretende eliminar a conversa com {name} para sempre? Esta ação não pode ser anulada.",
      "confirmWithoutName": "Tem a certeza de que pretende eliminar esta conversa para sempre? Esta ação não pode ser anulada."
    },
    "makeCall": {
      "enterPhoneNumber": "Para fazer uma chamada, introduza um número de telefone neste campo.",
      "invalidPhoneNumber": "O Twilio Lookup marcou este número de telefone como inválido."
    },
    "actions": {
      "markAsStarred": "Marcar como com estrela",
      "unarchive": "Desarquivar",
      "unmarkAsStarred": "Desmarcar como com estrela"
    },
    "send": {
      "perMonthPerIp": "/mês/IP",
      "perIp": "/ IP",
      "replyingTo": "A responder a",
      "requestClientsPaymentDetails": "Solicitar detalhes de pagamento do cliente",
      "saasModeCreditCardRequired": "O modo SaaS requer que o cartão de crédito do cliente esteja em arquivo.",
      "please": "Por favor",
      "firstBeforeEnablingSaaS": "primeiro, antes de ativar o modo SaaS.",
      "shareALink": "Partilhe um link",
      "shareLinkInstructions": "Partilhe uma ligação com o seu cliente para recolher os seus dados de pagamento",
      "requestViaEmail": "Pedido por e-mail",
      "twilioRebillingDescription": "Refature os custos do Twilio ({twilioCopy}) aos seus clientes e inclua uma margem",
      "seeHow": "Veja como",
      "phoneRebillingCardInfoRequired": "A faturação recorrente por telefone requer que as informações do cartão do cliente estejam em arquivo.",
      "clientsCompanyBillingPage": "página de faturação da empresa do cliente",
      "ifYouPayForTwilioKeepUsing": "Se pagar pelo Twilio, continue a usar a mesma conta Twilio",
      "ifClientPaysForTwilioCreateNew": "Se o cliente pagar pelo Twilio, crie uma nova conta Twilio",
      "learnHow": "Saiba como",
      "createNewTwilioAccountInstructions": "Crie uma nova conta Twilio para esta localização",
      "learnHowToMovePhoneNumbers": "Saiba como transferir números de telefone",
      "thisIsMyClientsTwilioCreateNew": "Este é o Twilio do meu cliente, crie uma nova conta",
      "featureUnderDevelopment": "Esta funcionalidade está em desenvolvimento",
      "emailRebillingDescription": "Fature recorrentemente os custos de e-mail aos seus clientes e inclua uma marcação",
      "emailRebillingCardInfoRequired": "A faturação recorrente por e-mail requer que as informações do cartão do cliente estejam em arquivo.",
      "emailRebillingMarginsDescription": "Estas são margens cobradas aos seus clientes além dos custos de e-mail",
      "provider": "Fornecedor",
      "morePlanCustomizationsAvailable": "Mais personalizações de planos disponíveis",
      "plansAndPricing": "Planos e preços",
      "connectYourStripeAccountFirst": "Ligue primeiro a sua conta Stripe",
      "createRecommendedPlansOnStripe": "Crie planos recomendados no Stripe",
      "createdPlanInStripe": "Plano criado no Stripe",
      "customizeYourSaasPlans": "Personalize os seus planos SaaS",
      "youCanOfferRecommendedPlansOrBuildYourOwn": "Pode oferecer planos recomendados ou criar o seu próprio",
      "trialPeriod": "Período de avaliação",
      "enterNumberOfDaysForTrial": "Introduzir número de dias para a avaliação",
      "nameCantBeEmpty": "O nome não pode estar vazio",
      "showStripeProductDetails": "Mostrar Detalhes do Produto Stripe",
      "addEmail": "Adicionar e-mail",
      "resetMountCounts": "Repor contagem de montagens",
      "connectReconnectGoogleForGbp": "Ligue ou volte a ligar o Google para GBP",
      "downloadFile": "Descarregar ficheiro",
      "showOnlySlowQueries": "Mostrar apenas consultas lentas",
      "gmbMessagingAvailable": "A funcionalidade de mensagens GMB está agora disponível",
      "reconnectGbpPageToEnable": "Volte a ligar a sua página GBP para ativar a troca de mensagens",
      "failedPaymentsCheckBilling": "Pagamentos falhados detetados. Verifique a sua faturação.",
      "onlyAgencyAdminsCanSeeWarning": "Apenas os administradores de agência podem ver este aviso.",
      "filter": "Filtrar",
      "stopDeleteOperation": "Parar operação de eliminação",
      "summary": "Resumo",
      "enableTracking": "Ativar rastreio",
      "exportAll": "Exportar tudo",
      "newConversationStarted": "Nova conversa iniciada",
      "startNewConversation": "Iniciar nova conversa",
      "subAccountScheduledForDeletion": "Subconta Agendada para Eliminação",
      "deleteSubAccountOnScheduledTime": "Eliminar subconta na hora agendada",
      "componentUpdatesDebuggerAlpha": "Debugger de Atualizações de Componentes (Alpha)",
      "componentUpdateTrackingDisabled": "O acompanhamento de atualizações de componentes está desativado",
      "deleteSubAccount": "Eliminar Sub-conta",
      "subAccountHasNumbersAndCampaigns": "Esta subconta tem {phoneNumberCount} número(s) de telefone e {campaignsCount} campanha(s).",
      "subAccountNoNumbersOrCampaigns": "Esta subconta não possui números de telefone ou campanhas.",
      "areYouSureDeleteSubAccount": "Tem a certeza de que pretende eliminar esta subconta?",
      "confirmDiscussedWithClient": "Confirmo que discuti este assunto com o meu cliente",
      "understandActionIrreversible": "Compreendo que esta ação é irreversível",
      "confirmDisconnectCloseLcPhone": "Confirmo que pretendo desligar e encerrar a conta LC Phone",
      "choosingNotDeleteLcPhoneWarning": "Aviso: se optar por não eliminar a conta LC Phone, continuará a ser cobrado pelos números de telefone associados a esta subconta.",
      "deleteAccount": "Eliminar conta",
      "send": "Enviar",
      "typeMessage": "Escrever mensagem",
      "requestPayment": "Solicitar pagamento",
      "reply": "Responder",
      "retry": "Repetir",
      "analyzeMemory": "Analisar memória",
      "memoryAnalysisApproximate": "🚧 A análise de memória é aproximada e não é 100% precisa.",
      "subAccountScheduledForDeletionItWillBeDeleted": "Esta subconta foi agendada para eliminação. Será eliminada até",
      "youCanChangeYourMindBeforeThisTime": "Pode mudar de ideias antes deste prazo.",
      "sms": {
        "errors": {
          "skipStayPrompt": "Ignorar",
          "cannotIdentifyContact": "Não é possível identificar o contacto e a sua localização.",
          "contactNotSelected": "O contacto não está selecionado.",
          "messageRequired": "Certifique-se de que introduziu uma mensagem ou um modelo selecionado.",
          "noPhoneNumber": "O contacto não tem um número de telefone.",
          "genericError": "{message}",
          "stayPrompt": "Ficar"
        },
        "scheduledSuccess": "E-mail agendado com êxito",
        "confirmDelete": "Tem a certeza de que pretende eliminar {name}?"
      },
      "clear": "Limpar",
      "edit": "Editar",
      "sendNow": "Enviar agora",
      "schedule": "Agendar",
      "useTemplate": "Utilizar um modelo (curto)",
      "mergeFields": "Fundir campos",
      "customVariablesError": "Existem problemas nas suas variáveis personalizadas; corrija-os antes de enviar.",
      "sendLater": "Carregar mais tarde",
      "scheduledFor": "Agendado para {date}",
      "call": "Chamada",
      "leftVoicemail": "Deixou uma mensagem de correio de voz",
      "pleaseSelectCampaign": "Selecione uma campanha",
      "whatsapp": {
        "no24HourMessage": "Só pode enviar mensagens de modelo fora da janela de 24 horas. Selecione um modelo para enviar."
      },
      "attachFile": "Anexar ficheiro",
      "email": {
        "fromEmail": "E-mail do remetente",
        "fromName": "Nome do remetente",
        "smtpWarning": "Os fornecedores SMTP têm algumas limitações. Clique aqui para saber mais.",
        "subject": "Assunto",
        "errors": {
          "cannotIdentifyContact": "Não é possível identificar o contacto e a sua localização.",
          "contactNotSelected": "O contacto não foi selecionado.",
          "genericError": "{message}",
          "bodyRequired": "O e-mail exige texto no corpo para ser enviado.",
          "noEmailAddress": "O contacto não tem um endereço de e-mail."
        },
        "scheduledSuccess": "E-mail agendado com êxito"
      },
      "addCalendarToSchedule": "Precisa de adicionar um calendário para começar a agendar compromissos.",
      "slotRequired": "Período obrigatório",
      "teamMemberRequired": "O membro da equipa é obrigatório."
    },
    "added": "adicionada",
    "loadMore": "Carregar mais",
    "admin": "Administrador",
    "aiEmployee": {
      "popupBlockedAlert": "Desativou o pop-up. Permita as pop-ups deste site para redirecionamento automático para a chamada Zoom. Clique em \"entrar agora\" para ser redirecionado diretamente para a chamada Zoom."
    },
    "alsoCloseAssociatedSubAccount": "Fechar também associados",
    "analyzeMemory": "Analisar Memória",
    "announcements": "Anúncios",
    "apply": "Aplicar",
    "appointment": {
      "pickDay": "Selecionar um dia",
      "pickSlot": "Selecionar um período de compromisso",
      "selectDate": "Selecionar data",
      "selectSlot": "Selecionar período",
      "slot": "Período",
      "day": "Dia"
    },
    "areYouReallySureDeleteSubAccount": "Tem mesmo a certeza de que pretende eliminar esta subconta?",
    "areYouSureDeleteSubAccount": "Tem a certeza de que pretende eliminar esta subconta?",
    "assignedContactOwner": "Atribuído ({contact} – proprietário)",
    "assignedToMe": "Atribuído a mim",
    "audio": {
      "browserNotSupported": "O seu navegador não suporta o elemento de áudio.",
      "loadingTranscription": "A carregar transcrição...",
      "viewTranscript": "Ver transcrição",
      "stop": "Parar",
      "playPause": "Reproduzir/pausar",
      "timePlayed": "Tempo de reprodução: tempo total",
      "mute": "Desativar o som",
      "playbackSpeed": "Velocidade de reprodução",
      "download": "Descarregar",
      "remove": "Remover"
    },
    "automated": "Automatizada",
    "avatar": {
      "aiGenerated": "Esta mensagem foi gerada pela Conversation AI",
      "messengerAutomation": "Automação do Messenger",
      "workflowGenerated": "Esta mensagem foi gerada pela ação do fluxo de trabalho da Conversation AI",
      "messageByAI": "Esta mensagem foi gerada pela Conversation AI",
      "messageByWorkflow": "Esta mensagem foi gerada pela ação do fluxo de trabalho da Conversation AI",
      "agentPrefix": "E-",
      "unknownFallback": "?"
    },
    "bePartOfFastestGrowingCommunity": "Faça parte da comunidade que está a crescer mais rapidamente.",
    "callHighlevelAt": "Ligue para a HighLevel através do número +1(888)732-4197",
    "callQueueTooltip": "Esta chamada está na fila de chamadas do utilizador à espera de ser acionada.",
    "callTranscript": "Transcrição da Chamada",
    "clearFilters": "Limpar filtros",
    "clientsCompanyBillingPage": "página de faturação da empresa do cliente",
    "closeChat": "Fechar conversa",
    "closeConversation": "Fechar conversa",
    "component": {
      "dismissMessage": "DISPENSAR ESTA MENSAGEM",
      "unblock": "Desbloquear",
      "inboundDndActive": "O DND de entrada foi ativado para este contacto",
      "fetchOlderMessages": "Obter mensagens mais antigas",
      "conversationBegan": "A conversa começou",
      "celebrationTitle": "Uau! As conversas agora estão a fluir",
      "celebrationBody": "As coisas estão apenas a começar, vamos explorar como a GHL pode ajudar a sua empresa a crescer.\nEntretanto, pode continuar a enviar mensagens à sua vontade"
    },
    "componentUpdateTrackingDisabled": "O rastreio de atualizações de componentes está atualmente desativado",
    "componentUpdatesDebuggerAlpha": "🚧 Depurador de atualizações de componentes (Alfa) - Trabalho em curso",
    "confirmDelete": "Eliminar conversa(s)?",
    "confirmDeleteTextLine11": "Tem a certeza de que pretende eliminar esta conversar? Esta ação é irreversível.",
    "confirmDeleteTextLine12": "conversas selecionadas",
    "confirmDeleteTextLine21": "Esta ação é irreversível. Ainda quer continuar?",
    "confirmDisconnectedAllIntegrations": "Confirmo que desliguei todas as integrações como twilio, mailgun, gmb, domínios, facebook, zoom, etc.",
    "confirmStoppedAllAutomations": "Confirmo que parei todas as automatizações nesta subconta",
    "connectReconnectGoogleForGbp": "Ligue/volte a ligar o Google para receber mensagens GBP!",
    "connectWithCertifiedAdmin": "Conecte-se com um Administrador Certificado",
    "connectWithTeamForHelp": "Contacte a nossa equipa para obter ajuda através de uma chamada de vídeo em direto!",
    "connectWithUs": "Entre em contacto connosco",
    "connectZoomAccount": "Ligar conta Zoom",
    "contactEngagementScore": "{contact} – Pontuação de envolvimento",
    "dailyBrainstormingSessions": "Sessões de brainstorming diárias com a HighLevel",
    "deleteAccount": "Eliminar conta",
    "deleteSubAccountOnScheduledTime": "Eliminar subconta na hora agendada",
    "disableSaasMode": "Desativar modo SaaS",
    "dnd": {
      "configure": "CONFIGURAR",
      "status": {
        "on": "Ativado",
        "partial": "Parcial"
      }
    },
    "editAppointment": {
      "updateButton": "Atualizar compromisso",
      "scheduleAppointment": "Agendar compromisso",
      "editAppointment": "Editar compromisso",
      "calendar": "Calendário",
      "selectCalendar": "Selecionar calendário",
      "roundRobin": "Distribuição sequencial",
      "pickTeamMember": "Escolher membro da equipa",
      "selectTeamMember": "Selecionar membro da equipa",
      "teamMemberRequired": "O membro da equipa é obrigatório.",
      "slotRequired": "Período obrigatório",
      "appointmentTitle": "Título do compromisso",
      "appointmentTitleTooltip": "Pondere deixá-lo em branco, caso opte por utilizar o título do compromisso pré-configurado",
      "contactName": "Nome do contacto",
      "name": "Nome",
      "nameRequired": "Nome obrigatório",
      "emailAddress": "Endereço de e-mail",
      "phoneNumber": "Número de telefone",
      "phoneNumbers": "Números de telefone",
      "dateOfBirth": "Data de nascimento",
      "contactTimezone": "Fuso horário de contacto (utilizado para lembretes)",
      "chooseOne": "Selecione um...",
      "meetingLocation": "Localização da reunião",
      "meetingLocationTooltip": "Pondere deixá-la em branco, caso opte por utilizar a localização da reunião pré-configurada",
      "status": "Estado",
      "appointmentStatus": "Estado do compromisso",
      "additionalNotes": "Notas adicionais",
      "notes": "Notas",
      "actionRequired": "Ação obrigatória",
      "confirmed": "Confirmado",
      "invalid": "Inválido",
      "cancelled": "Cancelado",
      "showed": "Compareceu",
      "noShow": "Não comparência",
      "busy": "Ocupado",
      "free": "Livre",
      "noCalendarMessage": "Precisa de adicionar um calendário para começar a agendar compromissos."
    },
    "email": {
      "errors": {
        "bodyRequired": "O e-mail exige texto no corpo para ser enviado.",
        "cannotIdentifyContact": "Não é possível identificar o contacto e a sua localização.",
        "contactNotSelected": "O contacto não foi selecionado.",
        "noEmailAddress": "O contacto não tem um endereço de e-mail."
      },
      "thread": {
        "failedToFetch": "Falha ao obter o conteúdo do e-mail",
        "forward": "Avançar"
      },
      "reply": "Responder",
      "share": "Partilhar",
      "facebook": "Facebook",
      "twitter": "Twitter",
      "addAccount": "+ Adicionar conta",
      "respond": "Responder",
      "retry": "Repetir",
      "moreEmailsInThread": "Mais {count} e-mails no tópico",
      "fromName": "Nome do remetente",
      "fromEmail": "E-mail do remetente",
      "subject": "Assunto",
      "attachFile": "Anexar ficheiro",
      "useTemplate": "Use um modelo (curto)",
      "requestPayment": "Solicitar pagamento",
      "clear": "Limpar",
      "sendNow": "Envie agora",
      "schedule": "Agendar",
      "send": "Enviar",
      "smtpWarning": "Os fornecedores SMTP têm algumas limitações. Clique aqui para saber mais.",
      "chooseOne": "Selecione um...",
      "deliveredCount": "{delivered}/{total} enviado",
      "typeMessage": "Escrever mensagem",
      "sendLater": "Enviar mais tarde",
      "scheduledFor": "Agendado para {date}"
    },
    "emailRebillingCardInfoRequired": "Para ativar a faturação recorrente por e-mail, tem de introduzir as informações do cartão do seu cliente na",
    "emailRebillingDescription": "Isto permite-lhe cobrar novamente os custos de e-mail aos seus clientes e incluir uma marcação.",
    "emailRebillingMarginsDescription": "Estas são margens cobradas aos seus clientes além do custo do e-mail suportado por si",
    "enableTracking": "Ativar rastreio",
    "exploreHighlevelExperts": "Explore especialistas da HighLevel que podem ajudar a configurar o seu sistema, automatizar fluxos de trabalho ou personalizar o seu projeto.",
    "exportAll": "Exportar tudo",
    "facebook": {
      "errors": {
        "generalError": "Ocorreu um erro. Tente novamente ou verifique a integração com o Facebook. Mensagem de erro:",
        "noFacebookId": "O contacto não tem um ID do Facebook."
      }
    },
    "failedPaymentsCheckBilling": "Tem um ou mais pagamentos falhados. Verifique o seu histórico de faturação.",
    "fbMessengerDM": "DM do Messenger do Facebook",
    "filters": {
      "above": "Superior",
      "aiActionLogs": "Registos de Ação de AI",
      "inRange": "Dentro do intervalo",
      "invoice": "Fatura",
      "messageDirectionTooltip": "O filtro será aplicável às mensagens após 9 de maio de 2023",
      "appointments": "Compromissos"
    },
    "followed": "Seguido por",
    "followedByMe": "Seguido por mim",
    "followedBySpecificUser": "Seguido por um utilizador específico",
    "follower": "Seguidor",
    "followerAssignmentContact": "Seguidor ({contact} – tarefa)",
    "gbp": {
      "errors": {
        "generalError": "Ocorreu um erro. Tente novamente ou verifique a integração com o Google Business Profile. Mensagem de erro:",
        "noGBPId": "O contacto não tem um ID GBP."
      }
    },
    "gbpChatNoLongerAvailable": "O chat do Google Business Profile já não está disponível",
    "getAccessToHighlevelWelcomeCourse": "Obtenha acesso ao curso de boas-vindas HighLevel",
    "getPriorityTroubleshooting": "Obtenha resolução de problemas prioritária, orientação especializada e acesso direto à nossa equipa técnica através do Slack.",
    "gmbMessagingAvailable": "O Google Business Messaging está disponível para a sua conta.",
    "googleMeet": "Google Meet",
    "googleReview": {
      "rating": "Classificação:",
      "replyDate": "Data de resposta:",
      "replyFrom": "Responder de:",
      "review": "Revisão",
      "reviewDate": "Data de revisão:",
      "reviewFrom": "Revisão de:"
    },
    "highlevelEvents": "Eventos HighLevel",
    "igMessengerDM": "IG Messenger DM",
    "includeSignatureBeforeQuotedText": "Inclua esta assinatura antes do texto citado nas respostas",
    "instagram": {
      "errors": {
        "generalError": "Ocorreu um erro. Tente novamente ou verifique a integração com o Instagram. Mensagem de erro:",
        "noInstagramId": "O contacto não tem um ID do Instagram."
      }
    },
    "joinOurFacebookGroup": "Registe-se no nosso grupo do Facebook",
    "keepUpToDateWithLatestNews": "Mantenha-se a par das mais recentes notícias e lançamentos!",
    "lastMessageChannel": "Canal da última mensagem",
    "lastMessageDirection": "Direção da última mensagem",
    "lastOutboundMessageType": "Tipo da última mensagem de saída",
    "learnHow": "Saber como?",
    "leftComment": "deixou um comentário",
    "leftPanel": {
      "recents": "Recentes",
      "unread": "Não lido",
      "createNewMessage": "Criar nova mensagem",
      "minCharsRequired": "Mínimo de 3 caracteres necessários",
      "twoMoreCharsRequired": "São necessários mais 2 caracteres",
      "oneMoreCharRequired": "É necessário mais 1 carácter"
    },
    "liveChat": {
      "endLiveChat": "Terminar chat em direto",
      "errors": {
        "generalError": "Ocorreu um erro. Tente novamente ou verifique a integração com o Google My Business. Mensagem de erro:"
      },
      "requestContact": "Pedido de contacto"
    },
    "live_chat_message": "Mensagem do chat em direto",
    "made": "efetuadas",
    "memoryAnalysisApproximate": "🚧 A análise de memória é aproximada e não é 100% precisa.",
    "mentioned": "Mencionado a",
    "mentions": "Menções",
    "mentionsOfMe": "Menções sobre mim",
    "mentionsOfSpecificUser": "Menções de Utilizador Específico",
    "message": {
      "replyAll": "Responder a todos",
      "details": "Informações",
      "reply": "Responder",
      "unsuccessful": "Sem sucesso",
      "pending": "Pendente",
      "inboundCall": "Chamada recebida",
      "outboundCall": "Chamada de saída",
      "ivrCall": "Chamada IVR",
      "leftVoicemail": "Deixou uma mensagem de correio de voz",
      "storyReply": "Responder à história",
      "storyMention": "Menção à história",
      "replyAsDM": "Responder como DM",
      "newCommentOnPost": "Novo comentário na publicação {pageName}.",
      "goToPost": "Ir para publicação",
      "replyNotAvailable": "A resposta como DM privada não está disponível para comentários com mais de 7 dias.",
      "addToDocuments": "Adicionar aos documentos",
      "attachmentsAddedSuccess": "Anexos adicionados aos documentos com sucesso",
      "attachmentsAddedFailed": "Falha ao adicionar anexos aos documentos",
      "reportFeedbackForAI": "Comunicar comentários para AI",
      "sms": "SMS"
    },
    "messageDetails": {
      "bcc": "BCC",
      "cancelScheduleConfirm": "Tem a certeza de que pretende cancelar este agendamento?",
      "cancelScheduledMessage": "Cancelar mensagem agendada?",
      "cancelSend": "Cancelar envio",
      "cancelScheduledSuccess": "Mensagem agendada cancelada com êxito",
      "cancelScheduledError": "Ocorreu um erro ao cancelar a mensagem agendada",
      "cc": "CC",
      "channel": "Canal",
      "createdBy": "Criado por",
      "direction": "Direção",
      "emailCampaign": "Campanha de e-mail",
      "facebookMessage": "Mensagem do Facebook",
      "instagramMessage": "Mensagem do Instagram",
      "messageId": "ID da mensagem",
      "messageIdLabel": "ID da Mensagem: ",
      "trigger": "Acionador",
      "unanswered": "Sem resposta",
      "yes": "Sim",
      "messageDetails": "Detalhes da mensagem",
      "from": "De",
      "fromLabel": "De:",
      "to": "Para",
      "toLabel": "Para:",
      "unknown": "Desconhecido",
      "unknownFrom": "Remetente desconhecido",
      "unknownTo": "Destinatário desconhecido",
      "unknownDirection": "Direção desconhecida",
      "dateUnknown": "Data desconhecida",
      "emailFromUnknown": "E-mail de remetente desconhecido",
      "smsFromUnknown": "SMS de um remetente desconhecido",
      "callFromUnknown": "Chamada de remetente desconhecido",
      "voicemailFromUnknown": "Correio de voz de remetente desconhecido",
      "emailToUnknown": "E-mail para destinatário desconhecido",
      "smsToUnknown": "SMS para destinatário desconhecido",
      "callToUnknown": "Chamada para destinatário desconhecido",
      "voicemailToUnknown": "Correio de voz para destinatário desconhecido",
      "failed": "Falhou",
      "datetime": "Data e hora",
      "manual": "Manual",
      "automation": "Automatização",
      "workflow": "Fluxo de trabalho",
      "campaign": "Campanha",
      "bulkRequest": "Pedido em massa",
      "delivered": "Entregue",
      "bounced": "Rejeitado",
      "opened": "Aberto",
      "sent": "Enviado",
      "scheduled": "Agendado",
      "pageName": "Nome da página",
      "gbpMessage": "Mensagem GBP",
      "no": "Não",
      "eventsTrackedForContactOnly": "De momento, os eventos são capturados apenas para o endereço de e-mail do contacto.",
      "completed": "Concluído",
      "voicemail": "Correio de voz",
      "busy": "Ocupado",
      "pending": "Pendente",
      "read": "Lido",
      "nativeIntegrations": "Integrações nativas",
      "smtp": "SMTP",
      "twilio": "Twilio",
      "leadConnector": "LeadConnector",
      "email": "E-mail",
      "sms": "SMS",
      "phoneCall": "Chamada telefónica",
      "voiceMail": "Correio de voz",
      "facebookMessenger": "Facebook Messenger",
      "instagramMessenger": "Instagram Messenger",
      "gbpMessenger": "Messenger GBP",
      "reviews": "Críticas",
      "others": "Outros",
      "partialDetailsWarning": "Estarão disponíveis detalhes parciais para mensagens anteriores a 15 de julho de 2022.",
      "agencySystem": "Sistema de agência",
      "reply": "Responder"
    },
    "multiplePhone": {
      "chooseNumber": "Selecione um número para iniciar a conversa:",
      "continue": "Continuar",
      "noPhones": "Não há números de telefone disponíveis"
    },
    "myChat": "O meu chat",
    "myInbox": "A minha caixa de entrada",
    "newConversationStarted": "Nova conversa iniciada",
    "newMessage": {
      "title": "Nova mensagem:",
      "errors": {
        "phoneRequired": "O telefone é obrigatório"
      }
    },
    "noConversationSelected": "Nenhuma conversa selecionada",
    "noResultsToShow": "Sem resultados para mostrar",
    "onboardingVideoTutorials": "Tutoriais em vídeo de integração",
    "onlyAgencyAdminsCanSeeWarning": "Apenas os Administradores da Agência podem ver este aviso. Para mais informações",
    "onlyVisibleToUsers": "Apenas visível para os utilizadores",
    "perMonthPerIp": "/mês/IP",
    "phone": {
      "call": "Ligar para {name}",
      "callingOptions": "{count} opções de chamada",
      "phoneNumbers": "Números de telefone",
      "callOptions": "{count} opções de chamadas",
      "dndActive": "O DND está ativo para chamadas",
      "primary": "Primário"
    },
    "pleaseDisableSaasMode": "Desative o modo SaaS para esta subconta",
    "pleaseSelectCampaign": "Selecione uma campanha",
    "premiumSupport": "Suporte Premium",
    "quickFilters": "Filtros rápidos",
    "reconnectGbpPageToEnable": "Volte a ligar a sua página GBP para a ativar.",
    "replyAsDMTooltip": "Responda a este comentário como uma DM privada.",
    "replyingTo": "A responder a",
    "resetMountCounts": "Repor contagem de montagens",
    "review": {
      "errors": {
        "generalError": "Ocorreu um erro. Mensagem de erro:",
        "googleIntegrationError": "Não é possível responder a essa revisão. Parece haver um erro com a sua integração com o Google. Restabeleça a ligação em Definições -> Integrações.",
        "noReviewId": "A Conversar não tem um Id de Revisão."
      },
      "reviewPostTo": "Rever publicação em {network}",
      "sharedOn": "Revisão partilhada em {network}",
      "disputeReview": "Contestar esta revisão",
      "learnHow": "(Saiba como?)",
      "seeOnGBP": "Ver esta revisão sobre o GBP",
      "alreadyShared": "Esta revisão já foi publicada em {network}. Tem a certeza de que pretende voltar a publicar?"
    },
    "reviewId": "ID da revisão",
    "schedule": {
      "sendSchedule": "Enviar agenda",
      "timezone": "Fuso horário ({heading})",
      "title": "Agende o seu {type}"
    },
    "scheduling": "A agendar...",
    "seeHow": "Veja como",
    "selectFilter": "Selecionar filtro",
    "selected": "selecionado",
    "sendEmail": {
      "recipientPlaceholder": "recipient{'@'}example.com",
      "subject": "Assunto:",
      "subjectPlaceholder": "Assunto do e-mail",
      "to": "Para:",
      "sending": "A enviar...",
      "sendButton": "Enviar e-mail"
    },
    "setupAccountWithFreeTutorials": "Configure a sua conta, com tutoriais grátis",
    "showOnlySlowQueries": "Mostrar apenas consultas lentas (>{threshold}ms)",
    "sms": {
      "confirmSending": "Confirmar o envio da mensagem",
      "editModal": {
        "compose": "Compor SMS"
      },
      "errors": {
        "customVariablesIssue": "Existem problemas nas suas variáveis personalizadas: por favor, corrija-as antes de enviar.",
        "messageOrTemplateRequired": "Certifique-se de que introduziu uma mensagem ou um modelo selecionado.",
        "noPhoneNumber": "O contacto não possui um número de telefone."
      },
      "scheduledSuccessfully": "SMS agendado com sucesso",
      "sendAnyway": "Enviar de qualquer forma",
      "spamWarning": "O conteúdo da sua SMS pode incluir referências a canábis, SHAFT, Vape ou outros tópicos proibidos. O envio de tais conteúdo por SMS é estritamente proibido e pode resultar em restrições da conta. Reveja cuidadosamente o seu conteúdo antes de prosseguir.",
      "send": "Enviar"
    },
    "startNewConversation": "Iniciar nova conversa",
    "subAccountAndDeleteAllPhoneNumbers": "subconta e eliminar todos os números de telefone",
    "subAccountScheduledForDeletion": "Esta subconta está agendada para eliminação",
    "subAccountScheduledForDeletionItWillBeDeleted": "Esta subconta foi agendada para eliminação. Será eliminada até",
    "teamInbox": "Caixa de entrada da equipa",
    "threshold": "Limite",
    "understandActionIrreversible": "Compreendo que esta ação é irreversível e todos os dados dentro desta subconta serão perdidos",
    "unstarred": "Sem estrela",
    "use_a_template": "Utilizar um modelo",
    "userAvailability": "Disponibilidade do utilizador",
    "userCalendarConfiguration": "Configuração do Calendário do Utilizador",
    "userInfo": "Informações do Utilizador",
    "userRoles": "Funções de Utilizador",
    "viewSupportTickets": "Consulte os seus tickets de suporte, os nossos artigos de suporte e FAQs úteis!",
    "visitOurHelpCenter": "Visite o nosso Centro de Ajuda",
    "welcomeCourse": "Curso de boas-vindas",
    "whatsapp_logo": "WhatsApp Logo",
    "youCanChangeYourMindBeforeThisTime": "Pode mudar de ideias antes desta hora.",
    "zoomAccount": "Zoom Account",
    "deleteEmails": "Eliminar {count} e-mail(s)",
    "fileAttachment": {
      "urlNotFound": "Não é possível encontrar o URL",
      "unsupportedAttachment": "Estes anexos podem já não ser suportados.",
      "downloadFile": "Descarregar ficheiro"
    },
    "composer": {
      "internalComment": "Comentário interno"
    },
    "dropdown": {
      "openOptions": "Opções abertas",
      "messageDetails": "Detalhes da mensagem"
    },
    "respond": "Responder",
    "selectTemplate": "Selecionar modelo",
    "settings": {
      "aiEmployeePromo": {
        "popupBlockedMessage": "Desativou o pop-up. Permita que os pop-ups deste site sejam automaticamente redirecionados para a chamada Zoom. Clique em \"registar-se agora\" para ser redirecionado diretamente para a chamada Zoom.",
        "helpAndSupport": "Ajuda e Suporte técnico",
        "summerOfAI": "Summer Of AI"
      }
    },
    "celebration": {
      "dismiss": "Dispensar",
      "body": "As coisas estão apenas a começar, vamos explorar como a GHL pode ajudar a sua empresa a crescer.\nEntretanto, pode continuar a enviar mensagens à sua vontade",
      "title": "Uau! As conversas agora estão a fluir"
    }
  },
  "cookies": {
    "thirdPartyWarning": {
      "helpArticle": "artigo de ajuda aqui",
      "message": "Ative os cookies de terceiros para ver esta página corretamente. Pode consultar o nosso",
      "ok": "OK",
      "title": "Os cookies de terceiros não estão a funcionar"
    }
  },
  "crash": {
    "message": "Lamentamos, mas aconteceu um imprevisto. Tente atualizar a página.",
    "refresh": "Atualizar página",
    "title": "Ups! Algo correu mal"
  },
  "deleteLocation": {
    "abortModal": {
      "abortingDeletion": "A cancelar a eliminação de {name}",
      "confirmAbort": "Sim, cancelar",
      "keepDeleting": "Não, continuar a eliminar",
      "message": "Tem a certeza de que pretende cancelar?",
      "scheduledForDeletion": "Esta localização está agendada para ser eliminada em {date}",
      "title": "Cancelar a eliminação",
      "warning": "Nota: a Localização será eliminada na data agendada, a menos que cancele a eliminação."
    }
  },
  "fileUpload": {
    "dropzone": {
      "defaultMessage": "Largue os ficheiros aqui para carregar",
      "uploadError": "Erro de rede: não foi possível enviar o pedido para a AWS. (Possivelmente um erro de CORS)"
    }
  },
  "funnel": {
    "acceptShare": {
      "add": "Adicionar {entityName}",
      "clonedMessage": "{entityName} clonada! Mude para uma conta onde foi clonada e encontre-a no separador de {entityName}.",
      "errorGettingDetails": "Parece haver um erro ao obter os detalhes de {entityName}. Verifique o URL ou tente novamente!",
      "permissionError": "Erro de permissão: este funil está protegido e não pode ser criado aqui."
    }
  },
  "integrations": {
    "googleCalendar": {
      "logo": "Logótipo GoogleCalendar"
    },
    "printful": {
      "logo": "Logótipo Printful",
      "title": "Printful: Impressões a pedido"
    },
    "printify": {
      "logo": "Logótipo Printify",
      "title": "Printify: POD"
    },
    "shipStation": {
      "logo": "Logótipo ShipStation",
      "title": "ShipStation"
    },
    "shippo": {
      "logo": "Logótipo Shippo",
      "title": "Shippo: integração de envio"
    },
    "tikTok": {
      "accountNotConnected": "Conta não ligada",
      "accountNotConnectedMessage": "A sua conta não está ligada à conta de anúncios do TikTok. Complete a integração para ver formulários e mapear campos.",
      "advertiserId": "ID do Anunciante",
      "companyFields": "{companyName} – campos",
      "editFields": "Editar campos",
      "errorSubscribing": "Erro ao subscrever à página.",
      "formsNotAvailable": "Formulários não disponíveis",
      "mandatoryFieldsNote": "Nota: mapeie qualquer um dos seguintes campos obrigatórios para receber oportunidades potenciais na sua conta com sucesso. Campos: Nome próprio, Apelido, E-mail, Número de telefone",
      "noFormsMessage": "De momento, não tem nenhum formulário de oportunidades potenciais criado na sua conta de anúncios do TikTok. Visite a sua conta de anúncios do TikTok e crie uma para começar.",
      "pageId": "ID da Página",
      "selectAdvertiserAccount": "Selecionar conta do anunciante"
    }
  },
  "launchpad": {
    "duda": "Duda",
    "joomla": "Joomla",
    "otherOrIDontKnow": "Outro / Não sei",
    "shopify": "Shopify",
    "squarespace": "SquareSpace",
    "weebly": "Weebly",
    "wordpress": "WordPress"
  },
  "location": {
    "suspend": {
      "instructionText": "Tem de realizar alguns passos simples para pausar esta subconta"
    },
    "transfer": {
      "chooseDescription": "Selecione o seu método de transferência",
      "chooseMethod": "Transferir esta subconta",
      "eject": {
        "description": "Ganhe 40% de comissão recorrente na assinatura da nova conta.",
        "title": "Ejetar como uma nova conta"
      },
      "modal": {
        "confirmDetails": "Confirme os detalhes antes de transferir",
        "confirmNomineePrefix": "Nomeie o proprietário para",
        "confirmTransfer": "Confirmar transferência",
        "consentText": "Li e compreendi o guia acima e dou o meu consentimento a todas as limitações",
        "ejectErrorTitle": "Não é possível ejetar a subconta.",
        "ejectGenericError": "A subconta que está a tentar ejetar não pode ser ejetada. Contacte o Suporte.",
        "ejectGuidelines": "Diretrizes sobre ejeções de subcontas",
        "ejectSubject": "A ejeção da subconta está sujeita à aceitação do pedido para criar uma nova agência.",
        "ejectSuccessTitle": "Pedido de ejeção da subconta enviado ao utilizador selecionado",
        "enterPassword": "Introduza a sua password para confirmar",
        "genericError": "A subconta que está a tentar transferir não pode ser transferida. Contacte o Suporte.",
        "guidelines": "Diretrizes sobre transferências de subcontas",
        "guidelinesConsent": "Leia e dê o seu consentimento",
        "hipaaDisclaimer": "Isenção de responsabilidade",
        "hipaaText": "Poderá querer informar esta subconta de que está atualmente a receber cobertura HIPAA, mas que poderá não obter a mesma cobertura na agência para a qual está a ser transferida.",
        "noUsersDescription": "Não existem utilizadores associados a esta subconta. Adicione um utilizador de subconta e depois continue.",
        "noUsersSearch": "Nenhum utilizador encontrado.",
        "noUsersTitle": "Nenhum utilizador encontrado",
        "nomineeInstructions": "O nomeado receberá uma ligação para se inscrever na HighLevel",
        "passwordError": "Password inválida",
        "passwordErrorDescription": "A password que introduziu está incorreta. Tente novamente.",
        "relationshipError": "Introduza o número de relação correto",
        "relationshipNumber": "Número de relação da agência recetora",
        "relationshipPlaceholder": "0-123-456",
        "requestTransfer": "Pedir transferência",
        "seeAllRequests": "Ver todos os pedidos",
        "successMessage": "A subconta será transferida assim que a agência recetora aceitar o seu pedido de transferência.",
        "successTitle": "Pedido para transferir subconta enviado para a agência recetora",
        "title": "Transferir subconta",
        "transferSubject": "A transferência de subconta está sujeita à aceitação pela agência recetora da sua conta.",
        "confirmNomineeSuffix": " para "
      },
      "transferExisting": {
        "description": "Transferir esta subconta completa para outra conta.",
        "title": "Transferir para uma conta existente"
      }
    }
  },
  "marketing": {
    "bulkRequests": {
      "nextExecution": "Próxima execução",
      "title": "Pedidos em massa"
    },
    "campaign": {
      "account": "Conta",
      "accountBuffer": "Buffer de Conta",
      "accountBufferDescription": "Não há limite para o número de destinatários adicionados a esta campanha todos os dias (de uma lista).",
      "accounts": "Contas",
      "activity": "Atividade",
      "acquire": "Adquirir",
      "acquisitionDescription": "As campanhas de aquisição de clientes ajudam a gerar mais oportunidades potenciais de vendas \"quentes\" que estão prontos para se envolver.",
      "addEvent": "Adicionar evento",
      "addUser": "Adicionar utilizador",
      "allMarket": "Todos os mercados",
      "allowMultiple": "Permitir múltiplos",
      "assignedToTooltip": "Quando esta campanha começou, este contacto foi atribuído a este utilizador. As alterações no campo \"Atribuído a\" do Contacto serão refletidas nos eventos, mas não vão alterar este valor inicial.",
      "atLeastOneEvent": "É necessário pelo menos um evento.",
      "automations": "Automatizações",
      "automationsPlaceholder": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quas quaerat pariatur consequatur rerum neque a, id, nam nostrum iure accusantium magnam nemo perferendis eveniet quos perspiciatis molestiae explicabo reprehenderit nesciunt recusandae, quod distinctio vero et quia omnis? Corporis omnis, ipsa in, quae iste libero minus, voluptatem perferendis molestiae consectetur nam odio eligendi enim consequuntur! Quis ratione iure modi eos quaerat facere molestiae. Quaerat voluptatibus distinctio sed nisi aliquam, laboriosam laudantium fugiat dolores. Corporis suscipit modi corrupti. Delectus assumenda perspiciatis asperiores porro ipsam quaerat nesciunt provident sit non distinctio veritatis tempora omnis fugit dicta minima nisi aliquam ducimus rem, nobis cum.",
      "bounced": "Rejeitado",
      "buffering": "Buffering",
      "campaignActivity": "Atividade de Campanha",
      "campaignConfiguration": "Configuração da campanha",
      "campaignConfigurationWarning": "A configuração da campanha afeta todos os mercados. Certifique-se de que tem de fazer alterações a estas configurações.",
      "campaignCreation": "Criação de campanha",
      "campaignId": "ID da campanha",
      "campaignStatusByRecipients": "Estado da campanha por destinatários",
      "clickThroughRate": "Taxa de cliques",
      "clickedThrough": "Clicado através de",
      "conditionIfExplanation": "Execute esta campanha ou evento se a hora atual estiver dentro desta janela; se a hora atual estiver fora desta janela, ignore a campanha ou evento e avance para a seguinte.",
      "conditionWhenExplanation": "Execute os eventos desta campanha quando a hora atual estiver dentro desta janela, caso contrário, aguarde até à próxima janela para executar os eventos.",
      "createCampaign": " Criar campanha",
      "ctr": "CTR",
      "customerAcquisition": "Aquisição de clientes",
      "dateAdded": "Data adicionada",
      "dateAddedTooltip": "A data e hora exatas em que o contacto foi adicionado a esta campanha. A hora de início do primeiro evento pode variar dependendo das definições.",
      "deletedRestorePrompt": "Esta campanha foi eliminada! Pretende restaurá-la?",
      "delivered": "Entregue",
      "deliveryRate": "Taxa de entrega",
      "draftMode": "Modo de rascunho",
      "draftModeDescription": "Esta campanha é um rascunho. Não pode ser utilizada até ser publicada.",
      "dropped": "Descontinuado",
      "emailActivity": "Atividade de Email",
      "emailActivityFilterExample": "Atividade de E-mail: clicado através de",
      "event": "Evento",
      "eventFilterExample": "Evento: 10X E-mail 4 (Distribuição de listagens)",
      "filters": "Filtros",
      "emailPerformanceByAccount": "Desempenho de e-mail por conta",
      "emailsNotSentOnDays": "Não serão enviados e-mails ao sábado e domingo.",
      "emailsSentOnDays": "Os e-mails serão enviados na segunda-feira, terça-feira, quarta-feira, quinta-feira e sexta-feira.",
      "eventStartDate": "Data de início do evento",
      "exampleAddress": "801 7th Avenue North, Saskatoon, SK",
      "exampleCompanyName": "City Perks Coffehouse",
      "exampleDate": "8 de maio de 2017 13h27",
      "exampleEmail": "dstumph{'@'}vendasta.com",
      "exampleEmailDescription": "Certifique-se de que os dados não têm mais de 30 dias",
      "exampleEventName": "10X E-mail 4 (Distribuição de listagens)",
      "getMoreCustomers": "Tenha mais clientes",
      "inProgress": "Em curso",
      "includedDays": "Dias Incluídos",
      "internalSource": "Fonte interna",
      "lastUpdate": "Última atualização",
      "leadValuePlaceholder": "$ valor de oportunidade potencial",
      "loopDetected": "Esta campanha foi bloqueada no estado de rascunho porque está a causar um ciclo. Para ativar esta campanha, contacte o Suporte.",
      "market": "Mercado",
      "moreDetails": "Mais detalhes",
      "myCampaigns": "As minhas campanhas",
      "na": "Não aplicável",
      "newFolder": " Nova pasta",
      "nextCampaign": "Próxima campanha",
      "nextExecutionTime": "Próxima hora de execução",
      "opened": "Aberto",
      "openRate": "Taxa de abertura",
      "option2": "Opção 2",
      "option3": "Opção 3",
      "pageNavigation": "Exemplo de navegação de página",
      "processed": "Processado",
      "published": "Publicado",
      "recipient": "Destinatário",
      "recipients": "Destinatários",
      "sampleCampaign": "Campanha de amostra ",
      "scheduling": "Agendamento",
      "seeHotLeads": "Ver oportunidades potenciais quentes",
      "selectDateRange": "Selecionar intervalo de datas",
      "selectTimeZone": "Selecionar fuso horário",
      "separator": " / ",
      "showingCount": "A mostrar {current} de {total}",
      "spamReport": "Relatório de Spam",
      "startByAddingEvent": "Comece por adicionar um evento a esta campanha.",
      "stopOnResponse": "Parar de acordo com resposta",
      "stopped": "Em pausa",
      "time": "Tempo",
      "timeConditionNote": "Nota: se o primeiro passo na campanha estiver definido como \"Imediatamente\", então a condição da hora não será aplicável ao primeiro passo.",
      "timeZoneDescription": "Esta definição vai afetar a hora em que o seu conteúdo será enviado.",
      "totalLeads": "Total de oportunidades potenciais",
      "undeliverable": "Não entregável",
      "unsubscribe": "Anular subscrição",
      "upNext": "A seguir",
      "utc": "UTC",
      "window": "Janela"
    },
    "embed": {
      "copyLinkInstructions": "Copie a ligação abaixo e partilhe-a facilmente onde quiser.",
      "embed": "Incorporar",
      "iframeEmbed": "Incorporação de iframe",
      "integrateInstructions": "Utilize as seguintes opções para integrar o seu formulário personalizado no seu site",
      "integrateYourForm": "Integre o Seu Formulário",
      "link": "Ligar",
      "saveAndExit": "Guardar e sair"
    },
    "jotbox": {
      "deleteSubmission": "Eliminação de Envio",
      "downloadPdf": "Descarregar PDF",
      "ofSubmissions": " de {total} envios",
      "pages": "páginas",
      "records": "registos",
      "searchPlaceholder": "Pesquisar por nome, e-mail, telefone e ID do contacto",
      "selectYourForm": "Selecione o seu formulário",
      "timeSigned": "Hora da assinatura:",
      "totals": "Totais:"
    },
    "survey": {
      "createNewSurvey": "Criar novo inquérito",
      "integrateYourSurvey": "Integre o seu inquérito",
      "noSurveysForAnalyze": "Ainda não tem nenhum inquérito. Crie primeiro um inquérito para ver a análise aqui.",
      "noSurveysForSubmission": "Ainda não tem nenhum inquérito. Crie primeiro um inquérito para ver o envio aqui.",
      "noSurveysYet": "Ainda não tem nenhum inquérito.",
      "refreshData": "Atualizar dados",
      "searchSurveys": "Pesquisar Inquéritos",
      "surveyBuilder": "Construtor de inquéritos",
      "toCreateFirstSurvey": "para criar o seu primeiro inquérito."
    }
  },
  "membership": {
    "acceptShare": {
      "clonedMessage": "Produto clonado! Mude para uma conta onde foi clonado e descubra-o no separador Assinatura > Produtos.",
      "errorGettingDetails": "Parece haver um erro ao obter os detalhes do produto. Verifique o URL ou tente novamente!"
    },
    "resetPassword": {
      "title": "Repor password",
      "button": "Repor password",
      "newPassword": "Nova palavra-passe",
      "generateStrongPassword": "Crie uma password forte",
      "sendEmailNotification": "Envie também uma notificação por e-mail.",
      "errorMessage": "Ocorreu um erro ao redefinir a palavra-passe. Tente novamente.",
      "updating": "A atualizar..."
    }
  },
  "notifications": {
    "psBubble": {
      "byText": "⚡ por",
      "combo": {
        "signedUp": "inscreveram-se no ProveSource nas últimas 24 horas",
        "verifiedBy": "verificado por "
      },
      "conversions": {
        "recentlyBought": "recentemente comprou isto",
        "timeAgo": "nos últimos 16 minutos ",
        "visitorsCount": "50 visitantes"
      },
      "pageVisits": {
        "description": "parecem também estar com fome.",
        "timeAgo": "nos últimos 21 minutos                        ",
        "title": "50 gourmets"
      },
      "proveSource": "ProveSource",
      "review": {
        "proofMessage": " Mensagem de Prova",
        "rating": "Classificação de 5 estrelas",
        "recently": "Recentemente",
        "reviewerName": "Varun Vairavan",
        "starIcon": "⚡"
      },
      "stream": {
        "action": "inscreveu-se no ProveSource",
        "location": "(Londres, Reino Unido)",
        "name": "Mike ",
        "timeAgo": "há 40 minutos                        "
      },
      "visitors": {
        "description": "amantes de música online"
      }
    },
    "step1": {
      "combo": {
        "description": "Mostrar a contagem total de pessoas que realizaram uma ação específica ao longo de 24 horas, 7 ou 30 dias.",
        "title": "Combo"
      },
      "conversions": {
        "description": "Crie validação social com a apresentação de quantos clientes realizaram uma ação específica."
      },
      "liveReviews": {
        "description": "Mostre aos seus visitantes avaliações de 4 estrelas ou mais em tempo real dos últimos 6 meses."
      },
      "liveVisitors": {
        "beta": "Beta",
        "description": "Mostre quantos visitantes estão agora a ver o seu site completo em direto."
      },
      "pageVisits": {
        "description": "Mostre aos seus visitantes que não são os únicos na festa, destacando as visitas recentes à página."
      },
      "stream": {
        "description": "O que é melhor do que colocar um rosto nesse testemunho das redes sociais? Mostre os seus clientes novos e as respetivas atividades."
      }
    },
    "step2": {
      "captureDescription2": "Cada URL da página deve ter um formulário de email",
      "captureDescription3": " e ProveSource instalado. ",
      "comboType": "Tipo de Combo",
      "connectAccounts": "Certifique-se de conectar as contas das quer retirar avaliações",
      "connectGoogleAccount": "Ligue a conta Google da sua localização",
      "formSubmissions": "Envios de formulário",
      "googleAccount": "Conta Google",
      "howToTrack": "Como monitorizar",
      "howToTrackDescription": "Como devemos monitorizar as suas conversões?",
      "pageUrl": "URL da página",
      "productPurchase": "Comprar Produto",
      "trackAllUrls": "Rastreie todos os URLs de páginas que contenham a seguinte expressão. ",
      "trackVisitors": "Rastrear Visitantes",
      "trackVisits": "Rastrear Visitas",
      "urlTip": " Tratamos http://, https://, www e não-www como versões separadas de URL e página. ",
      "urlValidationError": "Deve adicionar pelo menos uma URL. O URL é inválido. Certifique-se de incluir http:// ou https://",
      "userSignup": "Inscrição de Utilizador",
      "visits": " Visitas",
      "webhookDescription": "Chame o seguinte endpoint para nos informar acerca de um evento ou conversão que ocorreu do seu lado e que está relacionado com esta notificação push; nós trataremos do resto.",
      "webhookRequest": "Pedido de Webhook",
      "whatToTrack": "O que gostaria de monitorizar?",
      "whereToCapture": "Onde Capturar",
      "whereToCaptureDescription": "Onde está a capturar a taxa de conversão?",
      "whichPagesToTrack": "Que páginas gostaria que o utilizador monitorizasse?",
      "yourWebhookUrl": "O seu URL de Webhook"
    },
    "step3": {
      "allPages": " Todas as páginas",
      "displayOnAllPages": "Apresentação em todas as URLs da página que contenham a seguinte expressão: ",
      "whereToDisplay": "Onde apresentar",
      "whereToDisplayActivity": "Onde gostaria que apresentássemos esta atividade?"
    },
    "step4": {
      "icons8": "Icons8.com",
      "icons8Instructions": "para ícones com bom aspeto (clique com o botão direito num ícone -> Copiar endereço da imagem)",
      "messageSettings": "Definições de mensagens",
      "messageText": "Texto da mensagem",
      "referToVisitorsAs": "Refira os visitantes como",
      "visitIcons8": "Visitar"
    },
    "step5": {
      "allowUsersToClose": " Permitir que os utilizadores fechem a notificação ",
      "behavior": "Comportamento",
      "bottomLeft": "Canto inferior esquerdo",
      "bottomRight": "Parte inferior direito",
      "clickableNotification": " Notificação clicável ",
      "customizeDescription": "Altere as seguintes definições para controlar o comportamento e a aparência da sua notificação",
      "design": "Design",
      "displayNotificationFor": "Mostrar notificação para",
      "displayRules": "Regras de visualização",
      "hideOnMobileScreens": " Ocultar em ecrãs de dispositivos móveis ",
      "linkRelativeNote": " Se http:// for omitido, o link vai abrir relativamente à página exibida ",
      "minimumEventsToDisplay": "Mínimo de ocorrências de apresentação",
      "notificationLink": "Ligação de notificação",
      "notificationPosition": "Posição de notificação",
      "openLinkInNewTab": "Abrir link em novo separador",
      "selectPosition": "Selecionar posição",
      "showOnlyOncePerSession": " Mostrar apenas uma vez por sessão ",
      "titleBackground": "Fundo do título",
      "titleColor": "Cor do Título",
      "topLeft": "Canto superior esquerdo",
      "topRight": "Canto superior direito",
      "typeUrlHere": "Digite o URL aqui"
    },
    "step6": {
      "identifyNotification": "Identifique a sua notificação",
      "launchMessage": "Estamos prestes a arrancar, sente-se e aperte o cinto de segurança.",
      "notificationName": "Nome da Notificação",
      "notificationNamePrompt": "Qual é o nome da sua notificação?",
      "wellDone": "Muito bem."
    },
    "wordpress": {
      "subscriptionCreatedSuccessfully": "Assinatura Criada com Sucesso",
      "youCanNowSetupWordPress": "Pode agora configurar o seu site WordPress",
      "subscriptionFailed": "Falha na Subscrição",
      "resubscriptionSuccessful": "Resubscrição bem-sucedida",
      "successfullyReactivated": "A sua subscrição do WordPress foi reativada com sucesso",
      "reactiveSub": "Não foi possível reativar a subscrição",
      "resubscriptionFailed": "Falha na Re-subscrição"
    },
    "v2": {
      "viewDetails": "Ver detalhes",
      "chatConversationAssigned": "Conversa de chat atribuída",
      "internalChat": "Chat interno",
      "newTask": "Nova tarefa",
      "appointmentReminder": "Lembrete de compromisso",
      "facebookReview": "Revisão do Facebook",
      "googleReview": "Avaliação do Google",
      "internalChatMessage": "Mensagem de chat interna",
      "newAppointmentAssigned": "Novo compromisso atribuído",
      "newAppointmentBooked": "Novo compromisso marcado",
      "newCall": "Nova chamada",
      "newEmail": "Novo e-mail",
      "newMention": "Nova menção",
      "newReviewReceived": "Nova avaliação recebida de {contactName}",
      "taskReminder": "Lembrete de tarefa",
      "completed": "concluído",
      "failed": "falhou",
      "subAccount": "Subconta",
      "newMessage": "Nova mensagem",
      "newAppointmentBookedWith": "Novo compromisso marcado com {contactName}",
      "newAppointmentAssignedTo": "Novo compromisso atribuído a {contactName}",
      "appointmentDueIn": "Marcação prevista em {minutes} minutos com {contactName}",
      "newTypeReceived": "Novo {type} recebido de {contactName}",
      "newChatAssigned": "Nova conversa atribuída a partir de {contactName}",
      "taskDueDate": "Tarefa \"{title}\" para concluir até {date} às {time} para {contactName}",
      "tasksDueToday": "{count} tarefas a vencer hoje",
      "tasksOverdue": "{count} tarefas vencidas",
      "taskDueIn": "Tarefa \"{title}\" para concluir até {dueTime} {unitOfTime} para {contactName}",
      "mentionedInConversation": "{userName} mencionou-o numa conversa com {contactName}",
      "now": "agora"
    }
  },
  "onboarding": {
    "landscapeMode": {
      "altTexts": {
        "logo": "Logótipo da empresa"
      },
      "bestExperience": "a melhor experiência.",
      "optimizedFor": "Esta página está otimizada para",
      "portraitMode": "modo vertical",
      "toGiveYou": "para lhe proporcionar"
    }
  },
  "pagination": {
    "goToFirstPage": "Ir para a primeira página",
    "goToLastPage": "Vá para a última página",
    "goToNextPage": "Vá para a página seguinte",
    "goToPreviousPage": "Ir para a página anterior",
    "itemsSelected": "{count} itens selecionados",
    "showingEntries": "A mostrar {from} a {to} de {total} entradas"
  },
  "pmd": {
    "0": "0",
    "10": "10",
    "_min": "/ min",
    "_please_add_a_payment_method_for": "! Por favor, adicione um método de pagamento para",
    "_segment": "/ segmento",
    "ad_manager": "Ad Manager",
    "add": "[ADICIONAR:",
    "ai_employee": "Funcionário AI",
    "billing": {
      "incompleteBillingInfo": "Tem informações de faturação incompletas nesta conta. Atualize-as imediatamente.",
      "updateNow": "Atualizar agora"
    },
    "charge": "Custo",
    "contactLimit": {
      "message": "Atingiu o limite do seu plano atual para adicionar {contact}. Para continuar, faça upgrade do seu plano e desbloqueie capacidade adicional.",
      "upgradeNow": "Fazer upgrade agora",
      "warningMessage": "Tem {current} contacto(s), enquanto o seu plano apenas permite até {limit}.",
      "warningTitle": "A utilização da conta está acima do limite. Por favor, faça upgrade para continuar a trabalhar sem interrupções."
    },
    "cost_borne_by_you": "custo suportado por si",
    "dedicated_ip": "IP dedicado",
    "electeditem": "electedItem",
    "feedback": "Comentários:",
    "hello": "Olá",
    "helpDrawer": {
      "aiSupportAssistant": "Assistente de suporte AI",
      "clickToCopy": "Clique para copiar o número da relação",
      "clickToCopyToClipboard": "Clique para copiar o número da relação para a área de transferência",
      "companyRelationshipNumber": "Número da relação da empresa",
      "hiImHighly": "Olá, sou o Highly!",
      "implementation": "Implementação",
      "joinImplementationVideo": "Participe na chamada de vídeo de implementação",
      "joinTrialZoom": "Participar em chamada Zoom de avaliação",
      "kickoff": "lançamento",
      "needHelpChatVideo": "Precisa de ajuda? Comece uma conversa ou chamada de vídeo connosco agora!",
      "openAIAssistant": "Assistente de suporte Open AI",
      "premium": "Premium",
      "priority": "Prioridade",
      "raiseSupportTicket": "Criar um ticket de suporte",
      "raiseTicket": "Criar ticket",
      "relationshipNumber": "Número da relação",
      "startAISupportChat": "Começar conversa de suporte por AI",
      "startAgentChatWait": "Iniciar conversa com agente com um tempo de espera de 2 a 5 minutos",
      "startChatChoose": "Iniciar conversa - selecione entre suporte por AI ou conversa com agente",
      "startImplementationVideo": "Começar chamada de vídeo de implementação",
      "startZoom": "Iniciar Zoom",
      "startZoomCall": "Iniciar chamada Zoom",
      "subtitle": "Quer pretenda falar connosco, com a comunidade ou aprender por sua conta, estamos aqui para ajudar!",
      "title": "Ajuda e Suporte técnico",
      "trialExperience": "Experiência de avaliação",
      "useButtonsBelow": "Utilize qualquer um dos botões abaixo para obter ajuda!",
      "videoCallReward": "Participe numa chamada de vídeo para configurar a sua conta — e receba {amount} creditados na sua carteira quando participar.",
      "videoCallType": "Participe numa chamada de vídeo comigo para a sua chamada {type}.",
      "yourPremiumSupportSpecialist": "O seu especialista em suporte {type}",
      "yourSpecialist": "O seu especialista {type}",
      "yourSupportSpecialist": "O seu especialista em suporte",
      "videoCall": "Chamada de vídeo",
      "active": "Ativa",
      "announcementsAria": "Anúncios - clique para abrir num novo separador",
      "chat": "Conversa",
      "accessWelcomeCourseAria": "Clique para aceder ao curso de boas-vindas HighLevel",
      "clickToUpgrade": "Clique para fazer upgrade",
      "connectCertifiedAdminAria": "Fale com um Administrador Certificado – clique para abrir num novo separador",
      "connectWithUsAria": "Contacte-nos – inicie uma conversa em direto",
      "contactUsAria": "Contacte-nos – ligue para a HighLevel através do número +1(888)732-4197",
      "copied": "Copiado",
      "highlevelEventsAria": "Eventos HighLevel – clique para abrir num novo separador",
      "joinFacebookGroupAria": "Junte-se ao nosso grupo no Facebook - clique para abrir num novo separador",
      "onboardingVideoTutorialsAria": "Tutoriais em vídeo sobre integração – clique para abrir num novo separador",
      "recommended": "Recomendado",
      "visitHelpCenterAria": "Visite o nosso Centro de Ajuda – clique para abrir num novo separador",
      "contactUs": "Contacte-nos",
      "agentChatWaitTime": "Conversa com agente (aproximadamente 2 a 5 minutos de tempo de espera)",
      "aiSupportChat": "Conversa por suporte AI",
      "startChat": "Iniciar conversa",
      "announcements": "Anúncios",
      "fastestGrowingCommunity": "Faça parte da comunidade que está a crescer mais rapidamente.",
      "callHighlevelPhone": "Ligue para a HighLevel através do número +1(888)732-4197",
      "connectCertifiedAdmin": "Fale com um Administrador Certificado",
      "connectTeamVideoCall": "Contacte a nossa equipa para obter ajuda através de uma chamada de vídeo em direto!",
      "connectWithUs": "Contacte-nos",
      "dailyBrainstormingSessions": "Sessões de brainstorming diárias com a HighLevel",
      "certifiedAdminDescription": "Descubra especialistas da HighLevel que podem ajudar a configurar o seu sistema, automatizar fluxos de trabalho ou personalizar o seu projeto.",
      "getAccessWelcomeCourse": "Obtenha acesso ao curso de boas-vindas HighLevel",
      "premiumSupportDescription": "Obtenha resolução de problemas prioritária, orientação especializada e acesso direto à nossa equipa técnica através do Slack.",
      "highlevelEvents": "Eventos HighLevel",
      "joinFacebookGroup": "Junte-se ao nosso grupo do Facebook",
      "onboardingVideoTutorials": "Tutoriais em vídeo sobre a integração",
      "premiumSupport": "Suporte Premium",
      "setupAccountFreeTutorials": "Configure a sua conta, com tutoriais grátis",
      "viewSupportTicketsArticles": "Consulte os seus tickets de suporte, os nossos artigos de suporte e FAQs úteis!",
      "visitHelpCenter": "Visite o nosso Centro de Ajuda",
      "welcomeCourse": "Curso de boas-vindas",
      "beta": "Beta",
      "closeHelpSupportDrawer": "Fechar a gaveta de Ajuda e Suporte",
      "upgradePlanToEnable": "Precisa de fazer upgrade do seu plano, para ativar esta funcionalidade",
      "premiumSupportActive": "O seu Suporte premium está ativo",
      "premiumSupportClickUpgrade": "Suporte Premium - Clique para atualizar o seu plano",
      "premiumSupportActiveAria": "Suporte Premium - O seu suporte premium está ativo",
      "keepUpToDateNews": "Mantenha-se a par das mais recentes notícias e lançamentos!"
    },
    "hi": "Olá",
    "is_scheduled_for_deletion_on": "está programado para eliminação em",
    "k": "K",
    "limit_updated_from": "limite atualizado de",
    "minimum_must_be": "O mínimo deve ser",
    "more_emails_in_thread": "mais e-mails no tópico",
    "multipleUsers": {
      "chooseAccount": "Selecionar uma conta para continuar"
    },
    "must_be_in_range_of_0": "Deve estar no intervalo de 0-",
    "numbers_and": "número(s) e",
    "premiumSupport": {
      "assigningManager": "Atribuir Gestor de conta técnica...",
      "bookCall": "Agendar uma chamada",
      "hiIm": "Olá, sou {name}",
      "joinZoomNow": "Registar-se na chamada Zoom agora",
      "quickActions": "Ações de suporte rápido",
      "quickLinks": "Ligações rápidas",
      "raiseFeatureRequest": "Fazer pedido de funcionalidade",
      "slackChannelCreating": "Aguente firme — o seu canal Premium Slack está a ser configurado! 🚀",
      "technicalAccountManager": "Gestor de conta técnico",
      "viewRoadmap": "Ver Roadmap de produto"
    },
    "prospecting": "Prospeção",
    "reloadPopup": {
      "message": "Reparámos que não atualiza a página há algum tempo. Atualize para obter a melhor experiência da aplicação.",
      "refreshNow": "Atualize agora"
    },
    "resell_settings": "Definições de revenda",
    "row": "fila",
    "select_upto": "Selecionar até",
    "seo": "SEO",
    "supportCalendar": {
      "description": "Obtenha suporte dedicado num horário conveniente para si.",
      "title": "Agende uma chamada com o suporte da Highlevel"
    },
    "these_are_margins_that_are_billed_to_your_clients_": "Estas são as margens que são faturadas aos seus clientes além do",
    "twilioSetup": {
      "autoSetup": {
        "benefit1": "Permita-nos gerir o Twilio por si sem complicações",
        "benefit2": "A nossa equipa de suporte resolve os seus problemas com o Twilio",
        "button": "Faça isso por mim",
        "drawback": "Pague {price} extra em VAS do que se o fizer por si",
        "title": "Nós fazemos isso por si"
      },
      "lowCreditsMessage": "Precisa de ligar uma conta Twilio para gerir chamadas e mensagens que são enviados/recebidos no HighLevel.",
      "lowCreditsTitle": "Tem poucos créditos grátis da Twilio, mas não se preocupe, estamos aqui para ajudar!",
      "selfSetup": {
        "benefit1": "Faça a gestão das suas despesas",
        "benefit2": "Tenha mais controlo sobre o seu serviço Twilio",
        "button": "Vou gerir",
        "drawback1": "Contrate alguém para gerir o serviço Twilio",
        "drawback2": "Entre em contacto com o suporte da Twilio quando algo não estiver a funcionar.",
        "title": "Faça você mesmo"
      },
      "wip": {
        "button": "Configurar o Twilio agora",
        "fallback": "Por agora, terá de gerir a sua própria conta Twilio.",
        "message": "Obrigado por nos escolher, mas ainda estamos a trabalhar para desenvolver esta funcionalidade. Entraremos em contacto consigo assim que pudermos lançar isto na sua conta.",
        "title": "Ainda estamos a trabalhar nisso!"
      }
    },
    "uiComponents": {
      "loadingMoreOptions": "A carregar mais opções...",
      "noElementsFound": "Ups! Nenhum elemento encontrado. Considere alterar a questão de pesquisa.",
      "noLocationsFound": "Não foram encontradas localizações. Experimente uma pesquisa diferente.",
      "typeToSearch": "Escreva para pesquisar",
      "enterUserEmail": "Introduza o e-mail do utilizador"
    },
    "updating": "A atualizar",
    "usd": "USD",
    "useTemplate": {
      "useTemplate": "Utilizar modelo"
    },
    "validEmail": {
      "andYouCan": "E o utilizador pode",
      "as": "como",
      "canReverify": "Pode verificar novamente o seu e-mail",
      "emailIs": "Este e-mail é",
      "emailMarkedAs": "Este e-mail foi marcado como",
      "markedAsInvalid": "Este e-mail está marcado como",
      "notVerified": "Não verificado",
      "reverifyHere": "Volte a verificar aqui",
      "verifyHere": "Verifique aqui"
    },
    "will_give_you_about": "dá para cerca de",
    "checkout": {
      "confirm": "Confirmar",
      "cardInformation": "Informações do cartão",
      "cardNumberInvalid": "O número do seu cartão é inválido.",
      "commitment": "compromisso",
      "paymentConsent": "Ao confirmar, permite que o LeadConnector cobre este pagamento no seu cartão.",
      "subscriptionConsent": "Ao confirmar a sua subscrição, permite que a LeadConnector cobre no seu cartão este pagamento e futuros pagamentos relativos a esta subscrição",
      "endingIn": "termina em",
      "month": "mês",
      "pay": "Pagar",
      "payWithCard": "pagar com cartão",
      "paymentBeingProcessed": "O pagamento está a ser processado. Não recarregue nem clique no botão Voltar",
      "proceedWithExistingCard": "Continuar com o cartão existente",
      "proceedWithNewCard": "Continuar com um novo cartão",
      "purchase": "comprar",
      "subscribe": "Subscrever",
      "subscribeTo": "Subscrever para",
      "pleaseUpdateCardDetails": "Atualize os detalhes do cartão",
      "zip": "zip",
      "retry": "tentar novamente",
      "initialChargesProrated": "Os encargos iniciais são proporcionais e a faturação regular começará a partir de",
      "youWillBeChargedFor": "Ser-lhe-á cobrado por",
      "days": "dias",
      "rightNowForPeriodTill": "neste momento para o período até",
      "startGettingChargedFullAmount": "e começará a ser-lhe cobrado o valor total de",
      "perMonthStartingFrom": "/mês a partir de",
      "nameOnCard": "Nome no cartão",
      "somethingWentWrong": "Algo correu mal",
      "errorImg": "imagem de erro",
      "networkError": "Erro de rede. Tente novamente mais tarde",
      "paymentCouldNotBeProcessed": "O pagamento não pôde ser processado. Tente adicionar novamente um cartão."
    },
    "deleteLocation": {
      "back": "Voltar",
      "delete": "Eliminar",
      "completeStepsToDelete": "Tem de completar alguns passos simples para eliminar esta localização",
      "alsoCloseAssociated": "Fechar também associados",
      "scheduling": "A agendar...",
      "subAccountAndDeletePhoneNumbers": "subconta e eliminar todos os números de telefone",
      "somethingWentWrongTryAgain": "Algo correu mal... Tente novamente daqui a algum tempo.",
      "deleteSubAccount": "Eliminar subconta",
      "scheduleForDeletion": "Agendar para eliminação"
    },
    "productRebilling": {
      "enableRebilling": "Ativar faturação recorrente",
      "ratesMayDifferUK": "As taxas podem variar de acordo com a região. Os cálculos apresentados referem-se às taxas do Reino Unido,",
      "examplePricingGpt4oMini": "Exemplo de preços – GPT-4o Mini",
      "input": "Entrada",
      "output": "Saída",
      "supportDoc": "documento de suporte",
      "unsavedChanges": "Alterações não guardadas",
      "to": "para",
      "chargedToCustomerLower": "Cobrado ao cliente",
      "model": "Modelo",
      "profit": "Lucro",
      "saving": "A guardar...",
      "type": "Tipo",
      "updating": "A atualizar...",
      "clickHere": "Clique aqui",
      "chargedToCustomer": "Cobrado ao cliente",
      "enabling": "A ativar...",
      "forMoreDetails": "para obter mais detalhes.",
      "tenDollarsWillGive": "10 dólares dá para cerca de",
      "yourCost": "O seu custo",
      "seeHow": "Veja como",
      "clientCompanyBillingPage": "página de faturação da empresa do cliente",
      "connectStripeToEnable": "Para ativar a faturação recorrente, precisa de ligar o seu Stripe",
      "companyStripeIntegrationPage": "página de integração com Stripe da empresa",
      "enterClientCardInfo": "Para ativar a faturação recorrente, tem de introduzir as informações do cartão do seu cliente na",
      "gpt4oMini": "GPT-4o-mini",
      "for750kWords": "(para 750 000 palavras)",
      "words": "palavras",
      "yourCostLower": "O seu custo",
      "and": "e",
      "or": "ou",
      "minimumMustBeBetween": "O mínimo tem de se situar entre",
      "upgradeToAgencyPro": "atualizar para o plano Agência Pro",
      "planToSetMargins": "para definir margens"
    },
    "m": "m",
    "label": "Etiqueta",
    "company_email_": "E-mail da empresa (",
    "me_": "Eu (",
    "automation_type": "Tipo de automatização",
    "calendar_groups": "Grupos de calendário",
    "length_": ".length }}"
  },
  "products": {
    "noProducts": "Nenhum produto disponível",
    "selectProduct": "Selecione um produto"
  },
  "reselling": {
    "common": {
      "additionalMessagesInfo": ". Mensagens adicionais do {product} não serão cobradas às localizações. Para voltar a faturar o cliente, ative o modo SaaS e a faturação recorrente.",
      "agreementPrefix": "Concordo com a ativação de",
      "agreementSuffix": "para este cliente sem revenda e reconheço que será feita uma cobrança",
      "buildResellerOffer": "Construa a sua oferta de revenda",
      "deployDirectlyDescription": "Utilize esta opção se estiver a oferecer {product} como parte da sua oferta ou se pretender faturar o seu cliente externamente",
      "deployPrefix": "Implementar",
      "directlySuffix": "Diretamente",
      "learnMore": "Saiba mais.",
      "offerPrefix": "Oferta",
      "resellPrefix": "Revenda",
      "resellingPrefix": "Revender",
      "subscriptionRestriction": "Não é possível alterar a configuração porque a localização já está subscrita",
      "zero": "0",
      "highlevelPrice": "Preço HighLevel",
      "howDoesItWork": "Como é que funciona?",
      "payNowButton": "Pague agora",
      "priceValidationError": "O preço tem de ser maior ou superior ao preço HighLevel",
      "saving": "A guardar",
      "yourPrice": "O seu preço",
      "yourProfit": "O seu lucro"
    },
    "whatsapp": {
      "inboundMessagesInfo": "Receber mensagens de entrada e responder-lhes utilizando um texto livre na janela de conversação são gratuitos. Se forem enviadas mensagens de modelo de saída, serão cobradas taxas adicionais de passagem.",
      "whatsappLocation": "Localização do WhatsApp"
    },
    "agencyResellingPage": {
      "seo": {
        "subscriptionRestriction": "Não é possível alterar a configuração porque a localização já está subscrita",
        "offerPrefix": "Oferta ",
        "poweredByPrefix": " (Com tecnologia Search Atlas)",
        "toggleTooltipDisable": "Esta ação irá desativar a ferramenta SEO para todas as subcontas.",
        "toggleTooltipEnable": "Esta ação irá ativar a ferramenta SEO para todas as subcontas.",
        "resellPrefix": "Revender ",
        "howDoesItWork": "Como é que funciona?",
        "buildResellerOffer": "Construa a sua Oferta de Revenda",
        "yourPrice": "O seu preço",
        "highlevelPrice": "Preço HighLevel",
        "yourProfit": "O seu lucro",
        "priceValidationError": "O preço tem de ser igual ou superior ao preço HighLevel",
        "saving": "A guardar",
        "save": "Guardar",
        "deployPrefix": "Implementar ",
        "directlySuffix": "Diretamente",
        "deployDirectlyDescription": "Utilize esta opção se estiver a oferecer a SEO como parte da sua oferta ou se pretender faturar o seu cliente externamente",
        "agreementPrefix": "Concordo com a ativação de ",
        "agreementSuffix": " para este cliente sem revenda e reconheço que será feita uma cobrança",
        "payNowButton": "Pagar agora",
        "subscriptionCreating": "A assinatura está a ser criada.<br/>Não recarregue nem clique no botão Voltar",
        "subscriptionCreated": "Assinatura criada com sucesso. Aguarde...",
        "subscriptionError": "Não foi possível criar a assinatura. Contacte o suporte"
      },
      "adManager": {
        "subscriptionRestriction": "Não é possível alterar a configuração porque a localização já está subscrita",
        "offerPrefix": "Oferta ",
        "resellingPrefix": "Revender",
        "resellPrefix": "Revenda ",
        "howDoesItWork": "Como é que funciona?",
        "bookACall": "Marcar uma chamada",
        "bookCallTooltip": "Marque uma chamada com a nossa equipa para saber mais sobre o Ad Manager",
        "buildResellerOffer": "Elabore a sua oferta de revenda",
        "yourPrice": "O seu preço",
        "highlevelPrice": "Preço HighLevel",
        "yourProfit": "O seu lucro",
        "priceValidationError": "O preço tem de ser igual ou superior ao preço HighLevel",
        "loading": "A carregar...",
        "save": "Guardar",
        "deployPrefix": "Implementar ",
        "directlySuffix": "Diretamente",
        "deployDirectlyDescription": "Utilize esta opção se estiver a oferecer o Ad Manager como parte da sua oferta ou se pretender faturar o seu cliente externamente",
        "agreementPrefix": "Concordo com a ativação de ",
        "agreementMiddle": " para este cliente sem revenda e reconheço que será feita uma cobrança",
        "agreementSuffix": " por mês",
        "stripeNotConnectedLocationWarning": "O Stripe não está ligado para esta localização. Ligue a sua conta Stripe para ativar esta caraterística.",
        "stripeNotConnectedAgencyWarning": "O Stripe não está ligado para esta agência. Ligue a sua conta Stripe para ativar esta caraterística.",
        "underSubAccountReselling": "por mês em revenda de subcontas"
      },
      "dedicatedIp": {
        "description": "Isto permite-lhe faturar recorrentemente o IP dedicado (utilizado para o envio de e-mails) aos seus clientes e incluir uma marcação",
        "numberOfIps": "N.º de IPs:",
        "yourCost": "O seu custo:",
        "chargedToCustomer": "Cobrado ao cliente:",
        "profit": "Lucro:",
        "monthlyProfit": "Lucro mensal:",
        "loading": "A carregar...",
        "save": "Guardar",
        "revokeDedication": "Revogar dedicação",
        "revokeDescription": "Utilize esta opção para descontinuar a oferta de novo IP dedicado ao seu cliente sem cobrar",
        "existingSubscriptionsNote": "As assinaturas de IP atuais não serão afetadas",
        "revoke": "Revogar",
        "provideDirectlyTitle": "Fornecer IP dedicado para e-mail diretamente",
        "provideDirectlyDescription": "Utilize esta opção para fornecer um IP dedicado ao seu cliente sem cobrar",
        "agreeToProvideText": "Aceito oferecer um IP a este cliente sem realizar uma venda superior",
        "acknowledgeChargeText": "Compreendo que serei cobrado 59 $/mês/IP",
        "agree": "Concordar",
        "yourMonthlyCost": "O seu custo mensal de IP:",
        "monthlyChargeToCustomer": "Cobrança mensal ao cliente:",
        "resellingSettingsSuffix": " Definições de revenda",
        "ipRebillingAmount": "Montante da faturação recorrente do IP"
      }
    }
  },
  "saas": {
    "disable": {
      "complianceModal": {
        "clientApproval": "Confirmo que discuti este assunto com o meu cliente e que tenho a sua aprovação",
        "confirmQuestion": "Tem a certeza de que pretende desativar o modo SaaS para esta conta?",
        "dataLossAck": "Compreendo que todos os dados de faturação recorrente, dados de assinatura SaaS e registo de transação serão perdidos",
        "disableSaas": "Desativar SaaS",
        "irreversibleAck": "Compreendo que esta ação é irreversível"
      },
      "confirmationModal": {
        "cancelSubscription": "Cancele também a assinatura SaaS associada",
        "confirmDisable": "Confirmar Desativar",
        "confirmQuestion": "Tem a certeza de que pretende desativar o modo SaaS?",
        "somethingWentWrong": "Algo correu mal... Tente novamente daqui a algum tempo."
      },
      "processingModal": {
        "closeNow": "Fechar agora",
        "closeWindowInstructions": "Pode fechar esta janela; vamos informá-lo por e-mail assim que o processo estiver concluído",
        "title": "O SaaS será desativado para esta localização em breve.",
        "typicalTime": "Normalmente, isto demora 10 minutos ou menos."
      }
    }
  },
  "settings": {
    "customFields": {
      "addCustomField": "Adicionar campo personalizado",
      "fieldKey": "Token de campo",
      "fieldName": "Nome do campo",
      "idWillBeAdded": "O ID será adicionado depois de o motivo de perda ser criado",
      "lostReasonID": "ID do motivo da perda",
      "placeholder": "Marcador de posição"
    },
    "locationMailGun": {
      "bccAddress": "Endereço BCC",
      "clearError": "Limpar erro",
      "deleteConfirmationMessage": "Esta ação vai remover a ligação Mailgun.",
      "deleteConnection": "Eliminar ligação",
      "domain": "Domínio",
      "domainsAvailable": "{count} disponível(eis)",
      "invalidApiKey": "API Key inválida",
      "selectDomain": "Selecionar domínio"
    },
    "locationWallet": {
      "fetchTransactionDetailsError": "Erro ao obter os detalhes da transação",
      "transactions": "Transações"
    },
    "noShowSMS": {
      "smsWithImage": "SMS de não comparência com imagem",
      "title": "Personalizar SMS de revisão"
    },
    "optOut": {
      "addKeywords": "Adicione uma das seguintes palavras-chave de exclusão: PARAR, PARAR TUDO, ANULAR SUBSCRIÇÃO, CANCELAR, TERMINAR ou SAIR.",
      "customizeTitle": "Personalizar mensagem de exclusão",
      "disableConfirm": "Tem a certeza de que pretende desativar a mensagem de exclusão?",
      "disableOptOut": "Desativar a opção de exclusão",
      "disableTitle": "Desativar a mensagem de exclusão?",
      "optInConfirmClient": "Confirmo que irei certificar-me de que os SMS são enviados apenas para os contactos que optaram por aceitá-los.",
      "quickTipMessage": "A mensagem inicial que enviar a um indivíduo tem de incluir uma das seguintes palavras-chave de exclusão padrão: PARAR, PARAR TUDO, ANULAR SUBSCRIÇÃO, CANCELAR, TERMINAR ou SAIR.",
      "reallyDisableConfirm": "Tem mesmo a certeza de que pretende desativar a mensagem de exclusão?"
    },
    "payments": {
      "logViewer": {
        "requestPostBody": "Corpo do pedido POST",
        "requestQueryParameters": "Parâmetros de consulta do pedido",
        "responseBody": "Corpo da resposta"
      },
      "logs": "Registos",
      "logsPage": {
        "clearAll": "Limpar tudo",
        "loadMore": "Carregar mais",
        "price": "Preço",
        "product": "Produto",
        "tabsAriaLabel": "Separadores dos registos de pagamento"
      }
    },
    "senderInfo": {
      "addGeneralTextAt": "Adicionar texto geral na",
      "beginning": "Início",
      "complianceConfirm": "Confirmo que irei certificar-me de que todas as mensagens SMS enviadas desta conta estão em conformidade com a política atual",
      "customizeTitle": "Personalizar texto geral",
      "disableConfirm": "Tem a certeza de que pretende desativar o ID do remetente?",
      "disableSenderID": "Desativar ID do remetente",
      "disableTitle": "Desativar o ID do remetente?",
      "end": "Fim",
      "pleaseAdd": "Adicione {text} conforme mencionado na dica rápida.",
      "quickTipMessage": "A mensagem inicial que enviar a um indivíduo tem de incluir a informação de identificação do remetente. Adicione {text} na caixa de texto geral.",
      "reallyDisableConfirm": "Tem mesmo a certeza de que pretende desativar o ID do remetente?",
      "senderID": "ID do remetente"
    },
    "shopify": {
      "adminApiAccessToken": "Token de acesso da API de administrador",
      "apiTokenRequired": "O token de acesso da API é obrigatório",
      "checkDocumentation": "Consulte esta documentação para obter mais informações",
      "checkmark": "✓",
      "cross": "✗",
      "customAppApiAccessToken": "Token de acesso da API de aplicação personalizada",
      "deleteWarning": "Eliminar isto irá remover a ligação existente.",
      "existStoreAlertTitle": "A integração com a loja Shopify já existe",
      "integration": "Integração Shopify",
      "integrationHealth": "Saúde da integração",
      "orders": "Encomendas",
      "scopePermissionsWarning": "Certifique-se de que a sua aplicação tem as permissões marcadas com uma cruz vermelha",
      "scopes": "Âmbitos",
      "scopesDescription": "São obrigatórios âmbitos de autorização para aceder às informações do Shopify. Devido a alterações recentes no Shopify, o read_customers é agora obrigatório para obter as informações completas dos clientes, devido aos dados do cliente protegidos pelo Shopify.",
      "storeConnectedMessage": "Loja Shopify já ligada à subconta {locationName}",
      "storeNameHelp": "O nome da sua loja está localizado no URL da sua conta Shopify - após https:// e antes de .myshopify.",
      "storeNameLabel": "Nome da sua loja Shopify",
      "storeNamePlaceholder": "nome da loja",
      "storeNameRequired": "O nome da loja é obrigatório",
      "typeRemoveConfirm": "Escreva \"REMOVE\" para confirmar",
      "webhooks": "Webhooks",
      "webhooksDescription": "Para receber todos os eventos do Shopify, temos de registar estes webhooks do Shopify durante o processo de integração. Estes webhooks são essenciais para garantir o funcionamento adequado das caraterísticas do Shopify."
    },
    "slack": {
      "accountConnected": "conta ligada",
      "accountsConnected": "contas ligadas",
      "accountsList": "Lista de todas as contas Slack",
      "added": "Adicionado {date}",
      "connectChannel": "Conecte o seu canal do Slack",
      "description": "Receba notificações instantâneas no seu canal do Slack. Clique em \"Conectar\" para adicionar um canal do Slack.",
      "manage": "Gerir",
      "manageAccounts": "Gerir contas Slack",
      "noIntegrations": "Nenhuma integração do Slack encontrada."
    },
    "smtpService": {
      "addFirstService": "Adicione o seu primeiro serviço SMTP.",
      "addService": "Adicionar serviço",
      "bccEmails": "E-mails BCC",
      "cannotDeleteDefaultProvider": "Não pode eliminar o fornecedor predefinido.",
      "contactDeveloper": "Contacte o programador desta aplicação.",
      "customProvider": "Fornecedor personalizado",
      "defaultProvider": "Fornecedor predefinido",
      "defaultProviderUpdated": "Fornecedor predefinido atualizado com sucesso!",
      "emailDomain": "E-mail/domínio",
      "emailService": "EMAIL Service",
      "enableReplyTracking": "Ativar rastreio de respostas",
      "forwardToAssignedUser": "Reencaminhar para o utilizador atribuído",
      "providerType": "Tipo de fornecedor",
      "smtpConnectionIssue": "Há um problema com esta ligação SMTP. Restabeleça a ligação a esta integração.",
      "useLcEmailMessage": "Utilize o LC Email para enviar e-mails para a sua agência e para os seus clientes."
    },
    "socialPosting": {
      "automaticPostingEnabled": "Publicação automática ativada",
      "dailyPostLimit": "Limite diário de publicações",
      "directoriesDescription": "Quando receber uma nova revisão, iremos publicá-la automaticamente em mais de 80 diretórios online que ajudam automaticamente a aumentar a sua marca e SEO.",
      "directoriesTitle": "Mais de 80 diretórios e sítios Web",
      "fivePosts": "5 publicações",
      "fiveStars": "5 estrelas",
      "fourPosts": "4 publicações",
      "fourStars": "4 estrelas",
      "googlePlus": "Google +",
      "manageSettingsDescription": "Personalize como e quando as suas revisões são publicadas automaticamente em cada uma das suas redes sociais.",
      "manageSettingsTitle": "Gerir as Suas Configurações de Publicação nas Redes Sociais",
      "postReviewsForRating": "Publique revisões com esta classificação de estrelas ou superior.",
      "searchEngines": "Motores de pesquisa",
      "threePosts": "3 publicações",
      "threeStars": "3 Estrelas",
      "title": "Publicação em redes sociais"
    },
    "tags": {
      "addNewTag": "Adicionar nova etiqueta",
      "allTags": "Todas as etiquetas",
      "deletedTags": "Etiquetas eliminadas",
      "here": "aqui.",
      "newTag": "Nova etiqueta",
      "noTagsYet": "Ainda não há etiquetas para mostrar",
      "searchTags": "Pesquisar etiquetas",
      "viewDeletedTags": "Pode ver e repor etiquetas eliminadas na página de registos de auditoria"
    },
    "templateMessage": {
      "addEmailTemplate": "Adicionar modelo de e-mail (fragmento)",
      "addTemplate": "Adicionar modelo (fragmento)",
      "addTextTemplate": "Adicionar modelo de texto (fragmento)",
      "body": "Corpo",
      "deleteTemplateConfirmation": "Tem a certeza de que pretende eliminar este modelo?",
      "templatesCount": "{count} modelos",
      "title": "Modelos de mensagem (fragmentos)"
    },
    "unsubscribe": {
      "content": "Conteúdo",
      "contentTooltip": "O conteúdo desta mensagem será adicionado automaticamente a todos os e-mails.",
      "customizeTitle": "Personalizar conteúdo de anulação de subscrição",
      "disableConfirm": "Tem a certeza de que pretende desativar a ligação para anular subscrição do e-mail?",
      "disableTitle": "Desativar ligação de anulação de subscrição?",
      "disableUnsubscribe": "Desativar anulação da subscrição",
      "pleaseAddTag": "Adicione a etiqueta /*anular subscrição*/",
      "reallyDisableConfirm": "Tem mesmo a certeza de que pretende desativar a ligação para anular subscrição do e-mail?",
      "subscribedConfirm": "Confirmo que o e-mail será enviado apenas para contactos que subscreveram para receber e-mails.",
      "subscribedConfirmClient": "Confirmo que irei certificar-me de que o e-mail só será enviado para contactos que subscreveram a aceitação de e-mails.",
      "suspensionWarning": "A atividade que não estiver em conformidade pode levar à suspensão das funcionalidades relacionadas com o e-mail da sua conta.",
      "tagRequirement": "O e-mail inicial que enviar a um indivíduo tem de incluir a etiqueta /*anular subscrição*/"
    },
    "callAndVoicemailSettings": {
      "defaultVoicemailMessage": "Esta é a mensagem de correio de voz predefinida para todos os números Twilio na localização, a menos que seja personalizada em",
      "forwardCallsToWebApp": "Reencaminhe chamadas para a aplicação web",
      "forwardCallsToMobileApp": "Reencaminhar chamadas para a aplicação móvel",
      "dedicatedNumberRequiredInfo": "Isto só é necessário se os utilizadores precisarem de um número dedicado. Não é necessário para o correio de voz ou para encaminhar a chamada para o utilizador atribuído.",
      "voicemailMessageInfo": "Esta mensagem de correio de voz será reproduzida em vez da mensagem da operadora. Recomendamos um tempo limite de 20 segundos ou menos.",
      "noTimeout": "Sem tempo limite",
      "10Secs": "10 segundos",
      "20Secs": "20 segundos",
      "voicemailMessageDuration": " Gravamos uma mensagem de correio de voz se a chamada não for atendida antes deste período",
      "saveCallSettings": "Guardar definições de chamadas"
    },
    "elizaFAQSetting": {
      "bypassElizaNote": "Quando esta etiqueta estiver presente no contacto, essas mensagens NÃO serão entregues a Eliza",
      "sendToElizaNote": "Por predefinição, todas as conversas serão entregues a Eliza. Se esta etiqueta estiver configurada, <br />as novas conversas serão enviadas para Eliza apenas quando esta etiqueta estiver presente num contacto.<br /> Se a etiqueta de contorno Eliza e a etiqueta Enviar para Eliza estiverem configuradas, apenas a etiqueta Enviar para Eliza será respeitada",
      "permissionNote": "As suas permissões de utilizador não estão ativadas para esta página. <br />Por favor, fale com o seu administrador.",
      "addFAQ": "Adicionar FAQ"
    },
    "locationSettings": {
      "ownCardWarning": "Não adicione o seu próprio cartão às subcontas!!",
      "addClientCardWarning": "Adicione o cartão do seu cliente (da subconta) e não o seu, pois este cartão será utilizado para faturar o seu cliente em seu nome.",
      "stripeConnectMissing": "Falta a ligação do Stripe",
      "pleaseContactAgencyToAddPaymentMethods": "Por favor, contacte a agência ({email}) para adicionar métodos de pagamento"
    },
    "integrations": {
      "connectWaveAccount": "Ligue a conta Wave da sua localização",
      "connectXeroAccount": "Ligue a conta Xero da sua localização"
    },
    "gmbSettings": {
      "gbpCallTrackingEnabledOnAnotherSubAccount": "O rastreamento de chamadas do GBP está ativado noutra subconta. O rastreamento de chamadas pode ser ativado numa única subconta de cada vez.",
      "gbpCallTrackingEnabledOnAnotherPage": "O rastreamento de chamadas GBP está ativado noutra página ({pageName}). O rastreamento de chamadas pode ser ativado numa única subconta e numa única página por localização de cada vez.",
      "gbpCallsProperlySetup": "As chamadas GBP estão devidamente configuradas e estão a chegar de",
      "tooManyEditsToPrimaryPhone": "Fez demasiadas edições ao número de telefone principal desta empresa. Tente novamente mais tarde.",
      "setupTwilioToStartCallTracking": "Configure o Twilio para começar a monitorizar chamadas",
      "twoSecondaryNumbersSetupAlready": "Já tem 2 números secundários configurados, não pode trocar o número",
      "yourAgentIDIs": "O seu ID de agente é"
    },
    "numberPool": {
      "title": "O que rastrear",
      "tracking": {
        "percentComplete": "34% concluído",
        "searchLower": "pesquisar"
      },
      "create": {
        "title": "Criar número de rastreio"
      }
    },
    "phoneNumbers": {
      "title": "O que rastrear",
      "tracking": {
        "percentComplete": "34% concluído",
        "heading": "Criar número de rastreio"
      }
    }
  },
  "smartList": {
    "filterMultiInput": {
      "enterValue": "* Introduzir um valor",
      "selectOption": "* Selecionar uma opção"
    },
    "filterMultiSelections": {
      "atLeastOneRequired": "* É obrigatório pelo menos um {filterName}",
      "select": "Selecionar {filterName}"
    },
    "newEmailStats": {
      "timeStamp": "Carimbo de data/hora"
    },
    "recordsNav": {
      "clickToReloadList": "Clique para recarregar a lista"
    },
    "reviewRequestActions": {
      "emailReviewReq": "Pedido de revisão por e-mail",
      "smsReviewReq": "Pedido de revisão por SMS",
      "whatsappReviewReq": "Pedido de revisão do WhatsApp"
    },
    "smartListFilters": {
      "clearAllFilters": "Limpar todos os filtros",
      "noneFound": "nenhum encontrado",
      "saveChangesToList": "Guardar alterações ao filtro nesta lista inteligente",
      "saveCombinationAsNew": "Guardar combinação de filtros, colunas e ordenação como nova lista inteligente",
      "saveCurrentAsNew": "Guardar os filtros atuais como uma nova lista inteligente",
      "searchAndAddFilter": "Pesquisar e adicionar um filtro",
      "searching": "a pesquisar...",
      "undoUnsavedChanges": "Anular alterações não guardadas"
    },
    "smsStatsPanel": {
      "smsStats": "Estatísticas de SMS"
    },
    "manageDuplicates": "Gerir Duplicados",
    "emailAction": {
      "attachFiles": "Anexar ficheiros",
      "customValues": "Valores personalizados",
      "triggerLinks": "Ligações de acionadores"
    },
    "atLeastOneRequired": "* É obrigatório pelo menos um {filterName}",
    "arrayInput": {
      "searchPlaceholder": "Pesquisar {filterName}",
      "searching": "A pesquisar..."
    }
  },
  "snapshots": {
    "common": {
      "errorWhileFetchingSnapshotContents": "Erro ao obter conteúdo do instantâneo",
      "overwriteAll": "Substituir tudo",
      "skipAll": "Ignorar tudo",
      "somethingWentWrongWhileFindingConflicts": "Algo correu mal ao encontrar conflitos",
      "step": "Passo"
    },
    "confirmOverwrite": {
      "confirmButton": "Confirmar a substituição",
      "description": "Esta ação é irreversível e pode alterar as configurações de campanhas, oportunidades, funis, etc. Confirme a sua ação escrevendo o seguinte nos comentários.",
      "title": "Tem a certeza de que pretende substituir os dados selecionados?"
    },
    "conflicts": {
      "noConflictsDetected": "Nenhum conflito detetado",
      "overwrite": "Substituir"
    },
    "pushCloneAccount": {
      "assetsFoundLinked": "Ativos encontrados ligados",
      "checkingConflicts": "A verificar se existem conflitos",
      "chooseSnapshot": "Selecionar um Instantâneo",
      "copyingDataNotification": "A copiar dados para as localizações selecionadas. Aguarde…",
      "linkedLocations": "Localizações ligadas",
      "noConflictsFound": "Nenhum conflito encontrado",
      "notAuthorizedMessage": "Apenas os administradores da agência podem realizar esta ação",
      "overwriteConflicts": "Conflitos de Substituição",
      "pickSnapshot": "Selecionar um instantâneo",
      "response": "Responder",
      "selectAssetsToPush": "Selecionar ativos para enviar",
      "selectLocationsToUpdate": "Selecionar localizações para atualizar",
      "snapshotNotAuthorized": "Este instantâneo não está autorizado para esta localização",
      "snapshotNotSelected": "Instantâneo não selecionado"
    },
    "share": {
      "agencyRestrictedLink": "Ligação restrita à agência",
      "deleteShareLink": "Eliminar ligação de partilha",
      "editShareLink": "Editar ligação de partilha",
      "permanentLink": "Ligação permanente",
      "subaccountRestrictedLink": "Ligação restrita à subconta"
    },
    "shareSnapshot": {
      "addCommaAfterEach": "(Adicione uma vírgula (<span class='text-base font-bold'> , </span>) após cada número da relação)",
      "addCommaAfterEachSubAccount": "(Adicionar vírgula (<span class='text-base font-bold'> , </span>) após cada ID de subconta)",
      "atLeast1EmailRequired": "Pelo menos 1 e-mail é necessário.",
      "emailShareLink": "Enviar ligação de partilha por e-mail",
      "enterOnePerLine": "(Introduza um por linha)",
      "errorGettingLink": "Algo correu mal ao obter a ligação. Tente novamente mais tarde!",
      "getAgencyRestrictedLink": "Obter ligação restrita à agência",
      "getLink": "Obter ligação",
      "getOneTimeLink": "Obtenha uma ligação de partilha única",
      "getPermanentLink": "Obter ligação permanente",
      "getSubAccountRestrictedLink": "Obter ligação restrita à subconta",
      "shareType": "Tipo de partilha",
      "title": "Partilhar instantâneo"
    },
    "snapshot": {
      "copySnapshotID": "Copiar ID do instantâneo",
      "deleteSnapshot": "Eliminar instantâneo",
      "editSnapshot": "Editar instantâneo",
      "pushUpdate": "Enviar atualização para contas ligadas",
      "refreshSnapshot": "Atualizar instantâneo"
    },
    "updateShareLink": {
      "addCommaAfterEach": "(Adicione uma vírgula depois de cada número da relação)",
      "addCommaAfterEachSubAccount": "(Adicione uma vírgula depois de cada ID de subconta)",
      "title": "Atualizar ligação de partilha"
    }
  },
  "socialMedia": {
    "engagement": "Interação",
    "potentialReach": "Alcance Potencial",
    "storiesCreated": "Histórias criadas",
    "recentPosts": "Publicações recentes",
    "notConnected": "Não ligado (ligue-se agora!)",
    "totalAudience": "Audiência Total",
    "activeAudience": "Público Ativo",
    "socialMediaOverview": "Visão Geral das Redes Sociais"
  },
  "suspendModal": {
    "currentStatus": "Estado Atual da Assinatura: Em pausa",
    "instructions": "Tem de completar alguns passos simples para {action} esta subconta",
    "nextBillingDate": "Data da próxima faturação:",
    "noKeepCharging": "Não, continuar a cobrar o cliente.",
    "pauseSubscriptionQuestion": "Também quer pausar a assinatura com a subconta?",
    "resumeSubAccount": "Retomar subconta",
    "resuming": "A retomar...",
    "saasSubscriptionActive": "Esta subconta tem uma assinatura SaaS ativa.",
    "saasSubscriptionResumed": "A Assinatura SaaS desta conta será retomada.",
    "yesPause": "Sim, pausar a assinatura"
  },
  "table": {
    "perPageOptions": {
      "5": "5 por página",
      "10": "10 por página",
      "15": "15 por página",
      "20": "20 por página",
      "25": "25 por página",
      "50": "50 por página",
      "100": "100 por página"
    },
    "filterPlaceholder": "A pesquisar...",
    "emptyText": "Não foram encontrados registos",
    "loading": "A carregar…",
    "showingEntries": "A mostrar {from} a {to} de {total} entradas",
    "noEntriesToShow": "Não existem entradas para mostrar"
  },
  "templateLibrary": {
    "public": {
      "loadingAccountData": "A carregar dados da conta…",
      "toContinueWith": "para continuar com"
    },
    "switcherModal": {
      "comingSoon": "Brevemente!",
      "multiLocationMessage": "Esta caraterística está atualmente disponível apenas para contas individuais. Estamos a trabalhar arduamente para disponibilizar isto em breve para contas com várias localizações."
    },
    "importedMessage": "{productName} importado! Navegue até à Biblioteca de modelos e encontre-a no separador {productName}s.",
    "permissionErrorMsg": "Esta opção está disponível apenas em planos superiores. Faça upgrade agora para desbloqueá-lo.",
    "errors": {
      "sourceDeleted": "Erro: O modelo de fonte foi eliminado. Já não está disponível. Verifique o estado do modelo ou contacte a fonte para obter assistência.",
      "sourceDraft": "Erro: O modelo de fonte foi movido para Rascunho. Verifique o estado do modelo ou contacte a fonte para obter assistência.",
      "linkedDeleted": "Erro: O modelo de fonte, associado ao modelo partilhado, foi eliminado. Verifique o estado do modelo ou contacte a fonte para obter assistência.",
      "fetchError": "Parece haver um erro ao obter os detalhes de {productName}. Verifique o URL ou tente novamente!",
      "sameAgency": "Não é possível partilhar o modelo dentro da mesma agência"
    }
  },
  "triggers": {
    "addContactTagRequiresTag": "A ação Adicionar etiqueta de contacto requer uma etiqueta.",
    "addNotesRequiresData": "A ação Adicionar notas requer dados de notas.",
    "addTaskRequiresFields": "A ação Adicionar tarefa requer um título e um dia de vencimento.",
    "addToCampaignRequiresCampaign": "A ação Adicionar à campanha requer uma campanha.",
    "addToCustomAudienceRequires": "A ação Adicionar ao público personalizado requer uma conta de anúncios e um público personalizado.",
    "addTrigger": "Adicionar acionador",
    "anyAction": "Qualquer Ação",
    "anyCondition": "Qualquer condição",
    "brokenCustomVariables": "Alguns campos contêm variáveis personalizadas danificadas, corrija-as antes de guardar.",
    "conditionCannotBeEmpty": "A condição \"{condition}\" não pode estar vazia",
    "confirmDeleteTrigger": "Tem a certeza de que pretende eliminar este acionador?",
    "customDateFieldRequired": "O filtro de campo de data personalizada é necessário para o acionador do lembrete de data personalizada",
    "detailPage": {
      "chooseTriggerPlaceholder": "Escolher um acionador",
      "lastUpdate": "Última atualização:",
      "loopIdentifiedWarning": "Este acionador foi bloqueado no estado de Rascunho porque está a causar um ciclo. Para ativar este acionador, contacte o suporte.",
      "ruleNotActiveWarning": "Esta regra não será executada até que a ative.",
      "triggerCreation": "Criação de acionador:",
      "triggerDeletedPrompt": "Este acionador foi eliminado! Pretende restaurá-lo?",
      "triggerRunDailyTooltip": "Execução do acionador às 8:00 todos os dias",
      "whatTriggersRule": "O que deve acionar esta regra?",
      "whichEventTriggersAutomation": "Que evento deve acionar esta automatização?"
    },
    "dndContactRequiresState": "A ação DND contacto requer que o estado DND seja definido.",
    "emptyConditionNotAllowed": "Não é permitida uma condição vazia.",
    "emptyFieldNotAllowed": "Não é permitido um campo vazio.",
    "executeWebhookRequiresUrl": "A ação Executar webhook requer o url do webhook.",
    "fieldCannotBeEmpty": "{field} não pode estar vazio",
    "fillRequiredFields": "Preencha todos os campos obrigatórios nas ações.",
    "googleAdwordsRequiresConversion": "A ação Adicionar ao Google AdWords requer uma ação de conversão.",
    "googleAnalyticsRequiresFields": "A ação Adicionar ao Google Analytics requer o ID de rastreio, o tipo de ação e a categoria de ação",
    "membershipGrantOfferRequiresOffer": "A ação Conceder oferta de associação requer uma oferta.",
    "membershipRemoveOfferRequiresOffer": "A ação Remover oferta de associação requer uma oferta.",
    "newBasicRule": "Nova regra básica",
    "opportunitiesRequirePipeline": "As ações de oportunidades requerem que selecione um pipeline.",
    "opportunityLoopWarning": "Este acionador irá causar um ciclo de criação de oportunidades. Remova a opção Permitir oportunidade duplicada ou altere a fase que está a referenciar.",
    "removeContactTagRequiresTag": "A ação Remover etiqueta de contacto requer uma etiqueta.",
    "removeFromCampaignRequiresCampaign": "A ação Remover da campanha requer uma campanha.",
    "removeFromCustomAudienceRequires": "A ação Remover do público personalizado requer uma conta de anúncios e um público personalizado.",
    "rulesBasedOn": "regras baseadas em",
    "selectUserForNotification": "Selecione o utilizador para enviar a notificação.",
    "sendEmailRequiresFields": "A ação Enviar e-mail requer de, para, assunto e mensagem.",
    "sendNotificationRequiresFields": "A ação Enviar notificação requer título, corpo e tipo de utilizador para enviar a notificação.",
    "sendSmsRequiresFields": "A ação Enviar sms requer um número e uma mensagem.",
    "stripeMinAmountUSD": "O montante deve ser maior ou igual a 50 cêntimos USD.",
    "stripeRequiresFields": "A ação Cobrança única do Stripe requer o ID do cliente, o montante e a moeda",
    "thatWillFire": "que será acionado",
    "triggerCannotBeEmpty": "O acionador não pode estar vazio",
    "updateContactFieldRequires": "O campo Atualizar contacto deve ter pelo menos 1 campo definido."
  },
  "workflow": {
    "resellPaywall": {
      "buttonText": "Pague ${amount} e subscreva",
      "commitment": "Sem compromisso, cancele em qualquer altura",
      "features": {
        "billedOnUsage": "Faturado com base no uso depois de o limite ser excedido",
        "externalAI": "Exclui ações de modelos de AI externos, que serão faturados separadamente",
        "leadingPricing": "Preços líderes no setor!",
        "monthlyPurchase": "Válido para uma compra por mês",
        "premiumActions": "Aplica-se a ações e acionadores premium"
      },
      "planDetails": "Detalhes do plano",
      "subscribeAndSave": "Subscreva e poupe hoje!",
      "title": "${amount} por {executions} execuções Mês"
    }
  },
  "appointmentWidget": {
    "movedMessage": "Esta definição foi movida para a página de calendários.",
    "toNavigate": "aqui para navegar. Esta página será removida em breve."
  },
  "attribution": {
    "description": "A primeira interação é simplesmente o primeiro ponto de contacto que um utilizador faz. Por isso, se alguém descobrir primeiro a sua empresa através de um anúncio de pesquisa paga (PPC), esse canal receberá o crédito quando se trata de uma conversão. Por outro lado, a última interação seria o último canal.",
    "firstInteraction": "Primeira interação",
    "lastInteraction": "Última interação",
    "title": "Atribuição"
  },
  "campaign": {
    "addEvent": "Adicionar evento",
    "a2p": {
      "address": {
        "chooseState": "Escolher estado...",
        "city": "Cidade*",
        "postalCode": "Código postal*",
        "streetAddress": "Rua*",
        "streetAddressHelper": "Deve ser um endereço válido vinculado à sua empresa.",
        "title": "Endereço da empresa"
      },
      "addressError": {
        "title": "Falha no envio do endereço"
      },
      "authorizedRep": {
        "jobPosition": "Função*",
        "jobTitle": "Cargo*",
        "title": "Detalhes do Representante Autorizado"
      },
      "brandDetails": {
        "solePropBrand": {
          "heading": "Marca em nome individual",
          "point1": "Apenas 1 número de telefone permitido",
          "point2": "EIN/SSN/DUNS não obrigatório"
        },
        "solePropCampaign": {
          "heading": "Campanha de empresário em nome individual",
          "point1": "Só é permitido associar 1 número a uma campanha em nome individual",
          "point2": "Uma vez aprovado, o seu número predefinido será associado automaticamente",
          "infoText": "Também pode atualizar o número após a aprovação",
          "warningText": "Só é permitido vincular 1 número a uma campanha em nome individual. Uma vez aprovado, o seu número predefinido será vinculado automaticamente. Também pode atualizar o número após a aprovação."
        },
        "solePropSubtitle": "Detalhes da marca e da campanha em nome individual",
        "standardBrand": {
          "heading": "4,41 $ - Única vez",
          "point1": "EIN/SSN/DUNS obrigatório",
          "point2": "É permitido mais do que 1 número de telefone"
        },
        "standardCampaign": {
          "heading": "16,54 $ - Única vez",
          "point1": "É permitido ligar mais de 1 número a uma campanha padrão",
          "point2": "EIN/SSN/DUNS obrigatório",
          "infoText": "Será aplicada uma taxa de campanha adicional de até 12 $ por mês, de acordo com as regras do TCR."
        },
        "standardSubtitle": "Detalhes da marca e da campanha padrão",
        "title": "Detalhes da marca e da campanha"
      },
      "businessInfo": {
        "soleProp": {
          "contactInfo": "Informações de contacto",
          "contactInfoSubtitle": "Pode ser qualquer pessoa que possa responder a perguntas sobre esta marca, se necessário. Tenha em atenção que não pode reutilizar informações de contacto entre marcas. Cada marca que criar deve ter informações de contacto únicas.",
          "emailHelper": "Não utilize o mesmo e-mail para mais de 5 marcas.",
          "phoneNumberHelper": "Não utilize o mesmo número de telefone para mais de 5 marcas.",
          "profileName": "Nome da empresa ou o seu nome próprio e apelido*",
          "profileNameHelper": "Utilize o nome legal da organização que está a enviar as mensagens, ou o seu próprio nome se esta marca não for para uma organização.",
          "nextLoading": "Seguinte...",
          "invalidPhoneNumber": "Número de telefone inválido",
          "phoneNumberWithCountryCode": "Número de telefone (com indicativo do país)*",
          "phoneNumberRequired": "O número de telefone é obrigatório.",
          "emailRequired": "O e-mail é obrigatório.",
          "profileNameRequired": "O nome do perfil é obrigatório."
        },
        "standard": {
          "businessType": "Tipo de empresa*",
          "legalBusinessName": "Nome legal da empresa*",
          "legalBusinessNameHelper": "Introduza o nome da empresa exato, tal como registado junto do Governo e mencionado nos seus documentos fiscais (CP 575). Por ex. Leadconnector LLC em vez de Leadconnector.",
          "regionsOfOperations": "Regiões de operações da empresa*",
          "registrationNumber": "Número de registo comercial*",
          "registrationNumberHelper": "O número utilizado para identificar a sua empresa. No caso de um EIN dos EUA, deve ser um número de 9 dígitos, por exemplo, 12-3456789.",
          "registrationType": "Tipo de ID de registo comercial*",
          "website": "Sítio Web da empresa*"
        }
      },
      "businessProfileRegistration": {
        "stepProgress": "Passo {currentStep} de {businessInfoSteps}"
      },
      "businessProfileSuccess": {
        "message": "O seu perfil de negócios foi submetido com sucesso.",
        "startA2P": "Iniciar registo A2P",
        "title": "Perfil Empresarial Submetido com Sucesso",
        "tooltips": {
          "agency": "Os utilizadores da agência podem iniciar o registo A2P",
          "location": "Os utilizadores da localização podem iniciar o registo A2P"
        }
      },
      "campaign": {
        "endUserConsent": {
          "closeExample": "Fechar exemplo",
          "optInKeywords": "Palavras-chave de inclusão*",
          "optInKeywordsHelper": "Comprimento máximo: 255 carateres.",
          "optInKeywordsPlaceholder": "Palavras-chave separadas por vírgula, Exemplo: SUBSCRIBE, START.",
          "optInMessage": "Mensagem de inclusão*",
          "optInMessageInfo": "Deve conter o nome da empresa e a palavra-chave de exclusão",
          "optInMessagePlaceholder": "Exemplo: Aceitou com sucesso receber notificações e SMS promocionais da company_name. Responda STOP se optar pela exclusão no futuro.",
          "placeholder": "Exemplo: Os utilizadores finais aceitam receber mensagens visitando https://www.mycompany.com/book e preenchendo os respetivos dados. Os utilizadores marcam uma caixa para receberem notificações e mensagens promocionais da nossa parte e darem o seu consentimento. Além disso, os utilizadores finais também podem enviar uma mensagem de texto START para o número +1 (213) 725-2867.",
          "question": "Como é que os utilizadores finais consentem na receção de mensagens?*",
          "seeExample": "Ver exemplo"
        },
        "messageDetails": {
          "embeddedLink": "A mensagem irá incluir uma ligação incorporada",
          "phoneNumbers": "As mensagens irão incluir números de telefone",
          "sampleMessage1Placeholder": "Exemplo: Olá, John! Fala a Jane da company_name. O nosso compromisso para o dia 20 de julho, às 11:00, está confirmado. Contacte o número +1(213) 725-2867 caso necessite de reagendar. Responda STOP para anular a assinatura.",
          "sampleMessage2Placeholder": "Exemplo: Olá, Brian! Fala a Jane da company_name. Vejo que não conseguiu comparecer ao nosso compromisso. Gostaria de reagendar? - https://www.mycompany.com/book. Responda com STOP para anular a assinatura.",
          "sampleMessageInfo": "Deve incluir o nome da oportunidade potencial, o seu nome, o nome da empresa e a linguagem de exclusão",
          "subtitle": "Adicione mensagens de amostra"
        },
        "useCaseDetails": {
          "explainInDetail": "Explique em detalhe",
          "pickUseCase": "Escolher caso de utilização da campanha",
          "solePropLabel": "Empresário em nome individual",
          "subtitle": "Introduza os detalhes e a descrição da campanha",
          "useCase": "Caso de utilização da campanha*",
          "useCaseDescription": "Descrição do caso de utilização*",
          "useCaseDescriptionPlaceholder": "Exemplo: Esta campanha envia informações sobre compromissos – confirmação e mensagens de lembrete aos nossos clientes depois de terem marcado um compromisso connosco no nosso sítio Web e terem optado por receber SMS promocionais e de notificação da nossa parte."
        }
      },
      "einModal": {
        "disableNoEINText": "Apenas as empresas com endereço válido nos EUA e no Canadá estão autorizadas a registar a marca A2P sem número de identificação fiscal.",
        "hasEIN": "Sim, a empresa que estou a registar tem um número de identificação fiscal (por exemplo, EIN, CCN etc.).",
        "infoText": "Pode encontrar o seu EIN dos EUA no seu formulário CP 575.",
        "noEIN": "Não, a empresa que estou a registar não tem um número de identificação fiscal (por exemplo, EIN, CCN etc).",
        "question": "A empresa que está a registar tem um número de identificação fiscal (por exemplo, EIN, CCN etc.)?*",
        "title": "Determine as necessidades da marca A2P"
      },
      "exampleModal": {
        "examples": "Exemplos"
      },
      "otpError": {
        "message": "Ocorreu um problema ao enviar o OTP.",
        "title": "Falha ao reenviar o OTP"
      },
      "otpSuccess": {
        "title": "O seu OTP foi enviado com sucesso."
      },
      "validation": {
        "cityRequired": "A cidade é obrigatória.",
        "countryRequired": "O país é obrigatório.",
        "invalidMobileNumber": "Número de telemóvel inválido",
        "postalCodeRequired": "O código postal é obrigatório.",
        "stateRequired": "O estado é obrigatório.",
        "streetAddressRequired": "A rua é obrigatória."
      }
    },
    "affiliates": {
      "affiliateAboutIframe": "affiliate-about-iframe",
      "agencyOwner": "Proprietário da agência",
      "agencyOwnerAndAdmins": "Proprietário e administradores da agência",
      "contactAgencyOwner": "Se precisar de assistência, contacte o seu",
      "firstPromoterAccessMessage": "Estes relatórios do FirstPromoter só podem ser acedidos pelo",
      "firstPromoterIframe": "firstpromoter-iframe",
      "noPartnerFound": "Não foi possível encontrar um parceiro que corresponda aos seus filtros. Clicar",
      "paymentDetailsAccessMessage": "Esta secção de detalhes de pagamento só é acessível e editável pelo",
      "toApplyPartner": "para se candidatar a parceiro."
    },
    "common": {
      "actions": {
        "googleDrive": "Google Drive"
      },
      "labels": {
        "doc": "Doc"
      },
      "loading": "A carregar",
      "legalBusinessNameHelper": "Introduza o nome da empresa exato, tal como registado junto do Governo e mencionado nos seus documentos fiscais (CP 575). Por ex. Leadconnector LLC em vez de Leadconnector."
    },
    "desktop": {
      "highlevel": {
        "logoAltText": "HighLevel Logo",
        "launchingDescription": "Clique em <span class='font-semibold'>Abrir HighLevel</span> para lançar a aplicação de ambiente de trabalho.<br>Não está a funcionar? Também pode <a href=\"/\" class='!text-blue-700 hover:underline'>usar a HighLevel no seu navegador</a>",
        "launchingTitle": "Lançamento do ambiente de trabalho HighLevel",
        "launchButtonText": "Abrir HighLevel"
      },
      "leadconnector": {
        "logoAltText": "LeadConnector Logo",
        "launchingDescription": "Clique em <span class='font-semibold'>Abrir LeadConnector</span> para lançar a aplicação de ambiente de trabalho.<br>Não está a funcionar? Também pode <a href=\"/\" class='!text-blue-700 hover:underline'>usar a LeadConnector no seu navegador</a>",
        "launchingTitle": "Lançamento do ambiente de trabalho LeadConnector",
        "launchButtonText": "Abrir LeadConnector"
      }
    },
    "email": {
      "actionCard": {
        "chooseAction": "Escolher uma ação",
        "destination": "Destino",
        "removeFromAllCampaigns": "Esta ação irá remover as oportunidades potenciais de todas as campanhas, exceto da campanha atual",
        "triggerLinks": "Ligações de acionadores"
      },
      "importTemplate": {
        "errorImporting": "Erro ao importar o modelo!",
        "importTemplate": "Importar modelo",
        "importing": "A importar",
        "title": "Importar modelo de {entityName}",
        "unnamedEntity": "Cópia de {entityName} sem nome"
      },
      "lcEmail": {
        "migrationModal": {
          "below": "abaixo",
          "confirmByTyping": "Confirme escrevendo",
          "confirmWord": "CONFIRMAR",
          "existingNotMoved": "Se o seu cliente já tiver o Mailgun ou a configuração SMTP, não serão transferidos",
          "notNow": "Agora não",
          "pricingInfo": "O LC Email é mais barato do que o Mailgun e custará cerca de 0,68 $ por 1000 e-mails",
          "setAsDefault": "Defina o LC Email como o fornecedor predefinido para a sua agência e clientes que ainda não possuem Mailgun ou SMTP",
          "thisWill": "Isto irá:",
          "title": "Está a migrar para o e-mail Lead Connector",
          "useLcEmail": "Utilizar LC Email"
        }
      },
      "newPostModal": {
        "dragDropMedia": "Arraste ou largue multimédia aqui",
        "editPost": "Editar publicação",
        "enterText": "Introduza texto aqui",
        "exampleComment": "Muito fixe! Estou ansioso por isto!",
        "exampleName": "Técnico de testes",
        "hashtag1": "#hashtag",
        "hashtag2": "#awesome",
        "hashtag3": "#cool",
        "imagePlaceholder": "img(02).png",
        "needReview": "Precisa de revisão?",
        "network": "Rede",
        "photo": "fotografia",
        "previewPost": "Pré-visualizar publicação",
        "selectNetwork": "Selecionar rede social",
        "sizeExample": "245 KB",
        "textExample": "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        "urlExample": "https://searchengineland.com/google-announces-new-features-for-retail-advertisers-at-smx-advanced-300001"
      },
      "numberPool": {
        "confirmation": {
          "createdMultiple": "Criou um conjunto de {count} números para rastrear os visitantes do seu sítio Web. <br />As suas chamadas serão reencaminhadas para",
          "createdSingle": "Criou {count} número para rastrear visitantes no seu sítio Web. <br />As suas chamadas serão reencaminhadas para",
          "percentComplete": "100% concluído"
        },
        "create": {
          "correctErrors": "Corrija os erros!",
          "forwardHelp": "Diga-nos qual o telefone que deve tocar quando o cliente ligar para o seu número de telefone de rastreio. Normalmente, este é o número de telefone primário da sua empresa. Exemplo: 404-555-1212",
          "heading": "Conjunto de números e reencaminhamento de chamadas",
          "nameHelp": "O \"{name}\" é a forma como nos vamos referir a este número de rastreio na sua conta. Escolha um nome breve e memorável.",
          "newTrackingNumbers": "novos números de rastreio.",
          "nextTracking": "Seguinte: Opções de rastreio",
          "percentComplete": "50% concluído",
          "pleaseConfirm": "Confirme:",
          "poolSize": "Tamanho do conjunto",
          "poolSizeError": "Introduza um tamanho do conjunto entre 4 e 30 números de rastreio.",
          "poolSizeHelp": "O tamanho do seu conjunto de números determina o número de visitantes simultâneos que podemos rastrear no seu sítio Web num determinado momento. O tamanho do seu conjunto deve ser um quarto do tráfego horário de pico registado no Google Analytics, com um mínimo de 4 números.",
          "swappingHelp": "Diga-nos qual o número de telefone que devemos trocar no sítio Web. Exemplo: 404-555-1212",
          "swappingNumber": "Trocar número",
          "validationError": "Ocorreu um erro ao validar o formulário"
        },
        "features": {
          "activateNumber": "Ativar número",
          "address": "Endereço de {type}",
          "addressHelp": "O número de compra para alguns países requer um endereço. Contacte o suporte sobre como adicionar um endereço, se precisar de ajuda.",
          "heading": "Caraterísticas do número",
          "leaveBlank": "Deixe em branco para não enviar mensagem",
          "recordingDescription": "Ative a gravação de chamadas e reproduza uma mensagem curta para o autor da chamada.",
          "recordingHelp": "Algumas jurisdições exigem que ambas as partes deem consentimento para qualquer conversa gravada. Para ajudar a agir em conformidade com estas leis, pode ativar uma saudação para informar o autor da chamada de que esta pode ser gravada.",
          "whisperDescription": "Uma mensagem curta que é reproduzida antes da chamada. O autor da chamada não ouve esta mensagem."
        },
        "tracking": {
          "heading": "Opções de rastreio",
          "nextCreatePool": "Seguinte: Criar grupo",
          "percentComplete": "34% concluído",
          "searchLower": "pesquisar"
        },
        "whatToTrack": {
          "heading": "O que pretende rastrear no seu sítio Web?",
          "trackCampaign": "Rastrear uma campanha de marketing",
          "trackCampaignDescription": "Crie um número de telefone que rastreie todos os autores de chamadas para uma única campanha de marketing.",
          "trackVisitor": "Rastrear a atividade dos visitantes",
          "trackVisitorDescription": "Crie múltiplos números que correlacionem chamadas a visitantes do sítio Web, palavras-chave PPC e muito mais."
        }
      }
    },
    "loader": {
      "clickHereToRefresh": "clique aqui para atualizar.",
      "issuesLoadingApp": "Se estiver a ter problemas a carregar a aplicação",
      "loadingFreshData": "A carregar dados recentes...",
      "loadingNewSubAccountData": "A carregar dados da nova subconta..."
    },
    "login": {
      "bySigningInYouAgree": "Ao iniciar sessão, concorda com os nossos <a class='font-semibold text-curious-blue-500 hover:text-curious-blue-800' href='{termsConditionsURL}' target='_blank'>Termos e Condições</a>",
      "newPasswordSent": "Uma nova palavra-passe é enviada para o seu e-mail."
    },
    "regulatoryBundle": {
      "a2p": {
        "activityHistory": {
          "by": "Por:"
        },
        "affiliates": {
          "partnerBadgeAlt": "Distintivo de parceiro"
        },
        "checkout": {
          "cardInformation": "Informações do cartão",
          "cardNumberInvalid": "O número do seu cartão é inválido.",
          "commitment": "compromisso",
          "consentOneTime": "Ao confirmar, permite que o LeadConnector cobre o seu cartão para este pagamento.",
          "consentSubscription": "Ao confirmar a sua assinatura, permite que a LeadConnector cobre o seu cartão para este pagamento e pagamentos futuros destas assinaturas",
          "defaultIntervalCount": "1",
          "endingIn": "termina em",
          "errorImageAlt": "Ilustração de erro",
          "intervalSuffix": "(s)",
          "month": "mês",
          "pay": "Pagar",
          "payWithCard": "pagar com cartão",
          "paymentProcessing": "O pagamento está a ser processado. Não recarregue nem clique no botão Voltar",
          "proceedWithExistingCard": "Continuar com o cartão existente",
          "proceedWithNewCard": "Continuar com um novo cartão",
          "prorationDetails": "Será cobrado por {days} dias agora para o período até {billingEnd}, e começará a ser cobrado o valor total de ${amount}/mês a partir de {billingDate}.",
          "prorationMessage": "As taxas iniciais são proporcionais e a faturação regular terá início a partir de {billingDate}",
          "purchase": "comprar",
          "subscribe": "Subscrever",
          "subscribeTo": "Subscreva",
          "updateCardDetails": "Atualize os detalhes do cartão",
          "zip": "zip"
        },
        "options": {
          "jobPosition": {
            "gm": "GM",
            "vp": "VP"
          }
        },
        "registration": {
          "stepProgress": "Passo {currentStep} de 8",
          "successDescription": "A sua marca e campanha A2P foram enviadas.",
          "successMessage": "Nota: vai receber uma mensagem OTP no número de telemóvel fornecido para verificar a partir do TCR. Responda Sim (Yes) no prazo de 24 horas após receber o SMS.",
          "successWaitDays": "7 dias",
          "successWaitPrefix": "Poderá demorar até ",
          "successWaitSuffix": " para a aprovação da sua marca e mais 4-5 semanas para a aprovação da campanha."
        },
        "reminder": {
          "noReplyYet": "Ainda sem resposta",
          "patientConfirmed": "Paciente confirmado"
        },
        "sendGrid": {
          "apiKeyRequired": "API Key obrigatória"
        },
        "update": {
          "brandNameHelper": "Use o nome legal da organização que está a enviar as mensagens.",
          "businessVerticals": "Verticais de negócio*",
          "resendOTP": "Reenviar OTP",
          "retryOTPTitle": "Repetir a verificação com OTP"
        }
      },
      "addCustomEmailModal": {
        "title": "Adicionar e-mail personalizado"
      },
      "addEditSMTPServiceModal": {
        "addProvider": "Adicionar fornecedor",
        "clickHereForInfo": "Clique aqui para obter mais informações.",
        "clickHereToFindOut": "Clique aqui para descobrir mais acerca deles.",
        "createProviderError": "Algo correu mal ao criar o fornecedor!",
        "gmailLimitations": "O Gmail tem algumas limitações.",
        "needHelp": "Precisa de ajuda para encontrar o servidor SMTP e o número da porta?",
        "port25NotSupported": "A porta 25 não é suportada! Utilize a porta 2525",
        "providerExists": "Já existe um fornecedor com este e-mail/nome de utilizador.",
        "providerName": "Nome do fornecedor",
        "selectProvider": "Selecione fornecedor",
        "smtpPortNumber": "Número da porta SMTP",
        "smtpProvider": "Fornecedor SMTP",
        "smtpServer": "Servidor SMTP",
        "username": "Nome de utilizador",
        "usernameOrEmailRequired": "O nome de utilizador ou o e-mail é obrigatório.",
        "verifySmtpAccount": "Verificar conta SMTP"
      },
      "addTagModal": {
        "addTag": "Adicionar etiqueta",
        "editTag": "Editar etiqueta",
        "tagAlreadyExists": "A etiqueta {tag} já existe"
      },
      "affiliates": {
        "firstPromoterAccessMessage": "Este relatório do FirstPromoter só pode ser acedido pelo <strong>proprietário e administradores da agência</strong>. Se precisar de assistência, contacte o seu <strong>proprietário da agência ({agencyOwnerEmail})</strong>.",
        "firstPromoterIframeTitle": "Painel de controlo do FirstPromoter",
        "noPartnersFound": "Não foi possível encontrar um parceiro que corresponda aos seus filtros. Clique <a href='javascript:void(0);'>aqui</a> para se candidatar a parceiro.",
        "paymentDetailsAccessMessage": "Esta secção de detalhes de pagamento só é acessível e editável pelo <strong>proprietário da agência</strong>. Se precisar de assistência, contacte o <strong>proprietário da agência ({agencyOwnerEmail})</strong>."
      },
      "appointmentDetails": {
        "title": "Detalhes do compromisso"
      },
      "attachSnapshotToggle": {
        "loadSnapshot": "Carregar instantâneo:",
        "loadSnapshotWarning": "Pretende carregar o instantâneo associado a este plano? <br /> <strong class='text-danger'>Os dados existentes podem perder-se</strong>"
      },
      "auth": {
        "changePassword": {
          "changeButton": "Alterar palavra-passe",
          "confirmPassword": "Confirmar nova palavra-passe",
          "expired": "A sua ligação de reposição de palavra-passe expirou.",
          "regenerateLink": "Voltar a gerar ligação",
          "success": "Palavra-passe alterada com sucesso",
          "title": "Definir nova palavra-passe",
          "passwordMismatch": "As palavras-passe não correspondem"
        },
        "forgotPassword": {
          "contactAgency": "contacte a sua agência.",
          "contactSupport": "contacte o Suporte HighLevel 24 horas por dia, 7 dias por semana, ligando para",
          "supportMessage": "Se não tiver acesso a essa caixa de e-mail,",
          "successMessage": "Foi enviada uma ligação de reposição da palavra-passe para o seu endereço de e-mail.",
          "rateLimitError": "Demasiados pedidos de reposição da palavra-passe. Tente novamente mais tarde."
        },
        "login": {
          "inactivityMsg": "Notámos que esteve inativo durante algum tempo, por isso terminámos a sessão para garantir a sua segurança.",
          "loginButton": "Iniciar sessão",
          "resetPasswordMsg": "Uma ligação de reposição de palavra-passe foi enviada para o seu e-mail.",
          "signInWithGoogle": "Iniciar sessão com o Google",
          "contactHighLevelSupport": " contacte o Suporte HighLevel 24 horas por dia, 7 dias por semana, ligando para"
        },
        "logout": {
          "loggingOut": "A terminar sessão..."
        },
        "otp": {
          "enterBackupCode": "Introduza o seu código de cópia de segurança",
          "resend": "Reenviar",
          "resendIn": "Reenviar dentro de",
          "sendToPhone": "Enviar código para o telefone",
          "sending": "A enviar",
          "useAuthenticator": "Utilize a aplicação Authenticator",
          "useBackupCode": "Utilizar código de cópia de segurança",
          "verifyButton": "Verificar com código de segurança"
        },
        "sso": {
          "agreeTerms": "Ao iniciar sessão, concorda com os nossos <a class='font-semibold text-curious-blue-500 hover:text-curious-blue-800' href='{termsConditionsURL}' target='_blank'>Termos e Condições</a>",
          "and": ", e",
          "loginDifferentMethod": "Inicie sessão utilizando um método diferente",
          "loginSuccessRedirecting": "Início de sessão bem-sucedido, a redirecionar...",
          "processing": "A processar o seu pedido...",
          "redirecting": "A redirecionar...",
          "redirectingToDashboard": "A redirecionar para o painel de controlo...",
          "signedIn": "Sessão iniciada",
          "signingIn": "A iniciar sessão...",
          "testFailedRedirecting": "Falha no teste, a redirecionar...",
          "testSuccessRedirecting": "Teste bem-sucedido, a redirecionar..."
        }
      },
      "businessDetailModal": {
        "businessAddress": "Endereço da empresa: {address}",
        "businessDetailsText": "Os seguintes detalhes da empresa serão enviados aos Anúncios de Serviços Locais da Google para integração da funcionalidade Reserve com o Google. Verifique e confirme ou {link} para atualizar o seu perfil de empresa.",
        "businessInfoRequired": "As informações da empresa listadas acima são necessárias para a integração, {link} para atualizar os detalhes da empresa em falta/inválidos.",
        "businessName": "Nome de empresa: {name}",
        "businessNiche": "Nicho de negócios: {niche}",
        "city": "Cidade: {city}",
        "confirmDetails": "Confirmo que os detalhes acima mencionados estão corretos",
        "country": "País: {country}",
        "mustConfirmDetails": "Tem de confirmar os detalhes acima mencionados.",
        "phoneNumber": "Número de telefone: {phone}",
        "state": "Estado: {state}",
        "zipCode": "Código postal: {zipCode}"
      },
      "calendarHourRow": {
        "addHours": "Adicionar horas",
        "applyAll": "Aplicar a todos"
      },
      "campaign": {
        "callerIdVerificationModal": {
          "answerCall": "Atenda a chamada e introduza este código de verificação:",
          "leadConnectorCalling": "O Lead Connector está a ligar...",
          "title": "Adicionar um identificador de chamadas por voz",
          "waitingForVerification": "A aguardar pela verificação..."
        },
        "callerIdVerificationStatus": {
          "failed": "Falha na verificação do identificador de chamadas. Tente novamente.",
          "success": "Verificou com sucesso <strong>{contact}</strong>"
        },
        "choosePhoneNumberModal": {
          "addExistingNumbers": "Adicionar número(s) existente(s)",
          "areaCode": "Indicativo:",
          "checkAvailability": "Verificar disponibilidade",
          "checkingAvailability": "Verificar disponibilidade do número.",
          "chooseAreaCode": "Escolher um indicativo",
          "choosePhoneNumbers": "Escolher número(s) de telefone",
          "goBack": "Voltar atrás",
          "localNumbers": "{type} local(ais)",
          "nextNumberFeatures": "Seguinte: Caraterísticas do número",
          "noExistingNumbers": "Nenhum número existente para adicionar",
          "noNumbersAvailable": "Nenhum número disponível",
          "notEnoughNumbers": "Não há números suficientes disponíveis",
          "numbersAvailable": "Números disponíveis",
          "numbersDifferentArea": "Números num indicativo diferente",
          "numbersLocalTo": "Números locais para <strong>{number}</strong>",
          "problemChecking": "Problema ao verificar a disponibilidade do número, verifique a ligação de rede ou contacte o suporte.",
          "somethingWentWrong": "Algo correu mal. Verifique as credenciais da sua conta Twilio e envie uma mensagem para o suporte se o problema persistir.",
          "tollFreeNumbers": "Números gratuitos (taxa adicional de 2,00 $ por número, por mês)",
          "percentageComplete": "67% concluído"
        },
        "deleteNumberPoolModal": {
          "confirmDelete": "Compreendo as consequências, eliminar o conjunto",
          "confirmText": "Por favor, escreva <b>{name}</b> para confirmar",
          "title": "Eliminar NumberPool - <strong>{name}</strong>",
          "warning": "Esta ação não pode ser anulada. Isto irá eliminar permanentemente o(s) número(s) da sua conta Twilio, juntamente com os conjuntos de números da nossa base de dados. Além disso, se estiver a eliminar conjuntos de números porque está a enfrentar um problema, entre em contacto com a nossa equipa de suporte."
        },
        "editNumberFormatModal": {
          "description": "Pode atualizar a formatação de troca de número(s) e número(s) em conjunto, de acordo com a sua conveniência. Certifique-se de que a troca do(s) número(s) é apresentada com a mesma formatação no sítio Web.",
          "title": "Atualizar a formatação de número - <strong>{name}</strong>"
        },
        "editNumberPoolModal": {
          "addEditGroupId": "Adicionar/editar ID do grupo",
          "callConnectTooltip": "Esta funcionalidade requer que o destinatário prima uma tecla para fazer a chamada, o que resultará em maior precisão nos relatórios de chamadas.",
          "createGroupIdDescription": "Crie/adicione um ID do grupo único para usar múltiplos conjuntos de números com um único fragmento de javascript.",
          "enableCallConnect": "Ativar caraterística de ligação de chamadas",
          "groupId": "ID do grupo",
          "outboundCallTimeout": "Tempo limite da chamada de saída",
          "passCallerID": "Transmitir o número da chamada como identificador de chamadas",
          "passCallerIDTooltip": "Por predefinição, o sistema transmite o número do autor da chamada, mas se pretender que o identificador de chamadas seja o número marcado pelo autor da chamada, ative esta funcionalidade",
          "selectCallerID": "Selecionar identificador de chamadas",
          "timeDuration": "Duração em segundo(s)",
          "titleNumber": "Número - <strong>{number}</strong>",
          "updateWhisperWarning": "Atualize a mensagem de apoio, pois esta caraterística requer que o destinatário prima uma tecla para fazer a chamada.",
          "useVerifiedNumber": "Utilize o seu número verificado como ID de autor de chamada para chamadas de saída",
          "useVerifiedNumberTooltip": "Apenas aplicável a números de telefone verificados. Pode verificar um número de telefone em Definições > Números de telefone > Adicionar ID de autor de chamada verificado"
        },
        "emailOTPModal": {
          "confirmCode": "Código de confirmação",
          "resendCode": "Se não recebeu o código, clique aqui para reenviar",
          "unexpectedIssue": "Ocorreu um problema inesperado"
        },
        "facebookFieldMapModal": {
          "customFieldInfo": "Informações de Campo Personalizado",
          "customFieldTooltip": "Tooltip de Campo Personalizado: {options}",
          "field": "{companyName} – Campo",
          "trackingParameters": "Parâmetros de rastreio",
          "zipCode": "Código postal"
        },
        "howToUseNumberPoolModal": {
          "addSwappingNumbers": "Adicionar números para troca",
          "addingSnippets": "Adicionar fragmentos de JavaScript",
          "groupSnippet": "Agrupar fragmento \"{id}\"",
          "normalSnippet": "Fragmento normal",
          "noswapDescription": "Se não quiser que troquemos o número num determinado local, adicione uma classe \"noswap\".",
          "notReplacing": "Não substituir em determinado local",
          "requiredSteps": "Passos necessários",
          "snippetsDescription": "Copie o fragmento abaixo e adicione-o imediatamente acima da etiqueta de fecho body de cada página onde pretende substituir os números.",
          "swappingDescription": "Utilize os números abaixo para ativar a troca de número de telefone. Selecione um formato local ou internacional ou até ambos."
        },
        "newPhoneNumberModal": {
          "areaCode": "Indicativo",
          "availableNumbers": "Números disponíveis",
          "bundle": "Pacote",
          "chooseAddress": "Escolher endereço...",
          "chooseBundle": "Escolher pacote...",
          "createRegulatory": "Crie aqui um pacote/endereço regulamentar.",
          "monthlyFee": "Taxa mensal",
          "noNumbersFound": "Não foram encontrados números, tente outro indicativo.",
          "selectAddress": "Selecione \"Endereço\" para comprar número.",
          "selectBundle": "Selecione \"Pacote\" para comprar número.",
          "title": "Adicionar número de telefone",
          "upgradeAccount": "Faça upgrade da sua conta Twilio; apenas contas com upgrade podem comprar números de telefone e fazer chamadas",
          "cardAuthenticationFailed": "A autenticação do cartão falhou!"
        },
        "reserveWithGoogleIntegration": {
          "agreeTerms": "Tem de concordar com os termos e a política de privacidade.",
          "clickingProceed": "Se clicar em Continuar, a página de ligação LSA será aberta num novo separador",
          "configureCalendar": "Configure pelo menos um calendário para continuar com a integração da funcionalidade Reserve com o Google",
          "configureCalendarBtn": "Configurar calendário",
          "linkOneAccount": "Certifique-se de que cria uma ligação apenas a uma conta. Contacte o suporte se não conseguir ver a página na captura de ecrã acima.",
          "readInstructions": "Li as instruções mencionadas acima"
        },
        "updateTrackingModal": {
          "title": "Atualizar opção de rastreio"
        },
        "usageSummary": {
          "agencyOnlyVisible": "(Visível apenas para administradores da agência)",
          "updatedEvery24Hours": "(atualizado a cada 24 horas)"
        },
        "userCalendarConfiguration": {
          "calendarNotSelected": "Calendário não selecionado para sincronização",
          "check": "Verificar {email}",
          "checkForConflicts": "Verificar se existem conflitos",
          "checkForConflictsTooltip": "Defina o(s) calendário(s) para verificar se existem conflitos e evitar marcações duplas.",
          "contactCreationAllowed": "Criação de contacto permitida",
          "googleCalendar": "Logótipo do Calendário Google",
          "noGoogleAccounts": "Ainda não foram adicionadas contas Google/Outlook nas definições de integração",
          "noGoogleAccountsTeamMember": "Não foram adicionadas contas Google/Outlook para este membro da equipa na localização atual. Peça ao membro da sua equipa para iniciar sessão através da respetiva conta e adicionar a ligação ao Google a partir das respetivas definições de Integração.",
          "outlookCalendar": "Calendário de utilizador do Outlook",
          "primaryCalendarTooltip": "Defina o calendário no qual gostaria de adicionar novos eventos à medida que são agendados.",
          "runTriggerAllowed": "Execução de acionador permitida"
        },
        "warningModal": {
          "contactAgency": "Contacte a sua agência para alterar as definições de e-mail.",
          "title": "Aviso"
        }
      },
      "checkout": {
        "prioritySupport": {
          "features": {
            "faster247Chat": "Suporte por chat 24 horas por dia, 7 dias por semana mais rápido",
            "faster247Ticket": "Suporte de tickets 24 horas por dia, 7 dias por semana mais rápido e tempos de resposta mais rápidos"
          },
          "highlight": {
            "description": "Já percebemos, precisa de ir mais depressa. Quando tem uma pergunta ou preocupação, quer que esta seja respondida o mais rapidamente possível! Com o upgrade do suporte prioritário, pode evitar a fila e acelerar automaticamente os seus pedidos para a frente da fila.",
            "heading": "A postos para o tratamento VIP?"
          },
          "name": "Suporte prioritário",
          "success": {
            "description": "O suporte prioritário foi ativado na sua conta. Já não precisa de esperar mais na fila.",
            "heading": "Agora é um cliente prioritário!"
          }
        }
      },
      "cloneFunnel": {
        "cloneButton": "Clonar {entityName}",
        "cloning": "A clonar...",
        "cloningLimit": "A clonagem está limitada a 3 localizações de cada vez",
        "error": "Erro ao clonar o funil!",
        "locationsLabel": "Selecionar localizações",
        "nameLabel": "Nome para a {entityName} clonada",
        "namePlaceholder": "Introduza o nome para a clonagem de {entityName}",
        "selectUpTo": "Selecione até {maxSelectableLocations} localizações",
        "title": "Clonar {entityName}"
      },
      "cnam": {
        "learnMore": {
          "description": "Com o CNAM, o nome da sua empresa aparece no identificador de chamadas, tornando as suas chamadas instantaneamente reconhecíveis e aumentando a confiança. Indique aos seus clientes que as chamadas estão a ser feitas por si.",
          "title": "Faça com que as suas chamadas se destaquem!"
        },
        "registration": {
          "characterLimit": "{count}/15",
          "confirm": "Confirmar e registar-se",
          "description": "Mostre o nome da sua empresa aos destinatários das chamadas para aumentar a confiança e as taxas de atendimento de chamadas.",
          "title": "Aumente a confiança nas chamadas com o CNAM",
          "warning": "A apresentação do nome da empresa não é garantida, especialmente em dispositivos móveis."
        },
        "submitted": {
          "checkStatus": "Verificar estado do CNAM",
          "description": "O nome da sua empresa deve ser apresentado aos contactos aplicáveis dentro de cerca de 3 a 5 dias.",
          "subtitle": "O seu pedido de CNAM foi agora enviado.",
          "title": "Parabéns!"
        }
      },
      "confirmMerchantDeleteModal": {
        "confirmDelete": "Confirmar eliminação",
        "confirmation": "Confirmação"
      },
      "createAddress": {
        "successTitle": "Endereço enviado com sucesso",
        "underReview": "O endereço enviado está a ser revisto"
      },
      "createEndUser": {
        "dateFormat": "O formato da data deve ser AAAA-MM-DD.",
        "phoneExample": " Exemplo: +14155552671",
        "title": "Detalhes da empresa:"
      },
      "customValueModal": {
        "changingNameWarning": "Alterar o nome não afetará a chave do campo.",
        "editCustomValue": "Editar valor personalizado",
        "fieldKeyCreatedWarning": "A chave do campo será criada de acordo com o nome e não poderá ser alterada posteriormente.",
        "nameRequired": "O campo Nome é obrigatório",
        "nameValidation": "O nome deve ser alfanumérico e conter pelo menos um caráter",
        "valueRequired": "O campo Valor é obrigatório"
      },
      "details": {
        "addressName": "Nome do endereço",
        "addressTitle": "Detalhes do endereço",
        "bundleName": "Nome do pacote",
        "bundleTitle": "Detalhes do pacote regulatório",
        "countryFlag": "Bandeira de {country}",
        "id": "ID",
        "organisation": "Organização",
        "rejectionReason": "Motivo da rejeição",
        "status": {
          "approved": "Aprovado",
          "notValidated": "Não validado",
          "rejected": "Rejeitado",
          "validated": "Validado"
        },
        "typeOfNumber": "Tipo de número"
      },
      "drChronoOfficeSelect": {
        "selectOffice": "Selecionar escritório",
        "whichOffice": "Que escritório pretende vincular a esta conta?"
      },
      "editAddToCalendarModal": {
        "allowContactCreation": "Permitir a criação de contactos:",
        "allowTrigger": "Permitir acionador:",
        "doNotSync": "Não sincronizar novos eventos com o calendário primário",
        "primaryCalendarTooltip": "Só pode selecionar um calendário com acesso de escrita que não tenha selecionado para a verificação de conflitos.",
        "selectDefaultCalendar": "Selecionar calendário predefinido",
        "whichCalendar": "Que calendário devemos utilizar para sincronizar (ler e escrever) eventos?"
      },
      "editCheckForConflictsCalendarsModal": {
        "checkThesePlaces": "Verificar se existem conflitos nestes locais",
        "howToCheckConflicts": "Como devemos verificar se existem conflitos?"
      },
      "ejectModal": {
        "agencyClosing": "A conta da agência Elite Marketing com a Highlevel está a fechar. Para manter a sua conta, contacte {userName} para a migrar diretamente para a Highlevel.",
        "cancelWarning": "Tenha em atenção que a sua conta será oficialmente cancelada a 30 de junho de 2025 e que não será possível recuperar os seus dados após esta data se a transferência não for concluída.",
        "contactEmail": "transfers{'@'}gohighlevel.com",
        "contactUs": "Se tiver alguma dúvida, contacte-nos através de",
        "faqsUrl": "gohighlevel.com/getstartedtoday-em",
        "freeTransition": "Para lhe prestarmos apoio durante esta transição gratuita, estamos a aplicar {months} de acesso gratuito à sua nova assinatura.",
        "intro": "Devido a repetidas violações dos Termos de Serviço da HighLevel, a Elite Marketing Authority (EMA) foi removida permanentemente da plataforma HighLevel.",
        "platformCommitment": "Como plataforma que alimenta os serviços da EMA, a HighLevel está empenhada em manter um ambiente seguro, compatível e fiável para todos os utilizadores. Para evitar perturbações na sua conta, estamos aqui para ajudar a fazer uma transição sem problemas, seja para outro fornecedor de etiqueta branca ou diretamente para a HighLevel.",
        "questions": "Se tiver alguma dúvida,",
        "retainAccess": "Para manter o acesso aos seus dados e ferramentas existentes, clique no botão abaixo e siga as instruções para iniciar a transferência.",
        "speakWithTeam": "para falar com a nossa equipa.",
        "startTransfer": "Iniciar a Sua Transferência Gratuita",
        "title": "Atenção, clientes da Elite Marketing",
        "viewFaqs": "Consulte as FAQs aqui:",
        "whiteLabel": "Se preferir aceder à HighLevel através de outro fornecedor de etiqueta branca, teremos todo o prazer em acomodar essa alteração através do nosso sistema de tickets de suporte depois de ter transferido a sua conta diretamente para a HighLevel."
      },
      "emailTemplate": {
        "createdOn": "Criado a",
        "updatedOn": "Atualizado a"
      },
      "error": {
        "title": "Falha no envio do pacote regulatório"
      },
      "errors": {
        "funnel": {
          "multiplePages": "Mais do que uma página tem este URL; altere o caminho desta página para que funcione.",
          "urlNotFound": "Lamentamos, mas não conseguimos encontrar o URL que procurava"
        },
        "productRebilling": {
          "requestFailed": "Falha no pedido"
        },
        "template": {
          "categoryNotFound": "Lamentamos, mas não conseguimos encontrar a categoria que procurava.",
          "internalError": "Ocorreu um erro interno!"
        },
        "transfer": {
          "hipaaEnabled": {
            "message": "A subconta que está a tentar transferir está ativada para HIPAA e não pode ser transferida para uma agência que não seja compatível com HIPAA."
          },
          "limitExceeded": {
            "message": "A agência para a qual está a tentar transferir a subconta esgotou o respetivo limite de utilização e não pode obter mais subcontas.  Peça-lhes que eliminem uma subconta que não esteja a ser utilizada ou que atualizem para um plano de agência superior para obterem essa subconta."
          },
          "pendingRequest": {
            "heading": "Já existe um pedido de transferência pendente para esta subconta.",
            "message": "Cancele o pedido de transferência já existente para esta subconta antes de prosseguir com a criação de um novo."
          }
        }
      },
      "facebookPageSelect": {
        "cannotFind": "Não consegue encontrar a página que procura? Consulte as definições do Facebook e certifique-se de que todas as páginas estão selecionadas.",
        "instagramAvailable": "O Instagram está disponível para esta conta!",
        "noPages": "Não tem nenhuma página nesta conta.",
        "title": "Selecione a página do Facebook que pretende vincular a esta localização"
      },
      "googleLocationSelect": {
        "closeButton": "Fechar!",
        "enableCallTracking": "Ativar o rastreio de chamadas do GBP",
        "noBusinesses": "Não tem nenhuma empresa ligada nesta conta."
      },
      "importCustomers": {
        "newExperience": {
          "efficient": "Mais eficiente",
          "faster": "Mais rápido",
          "itsText": "É",
          "smoother": "Mais suave",
          "title": "Chegou uma nova experiência de importação!",
          "warningMessage": "A ativação da experiência Nova importação ativa os Labs para esta subconta e ativa a funcionalidade Beta."
        },
        "validateEmails": "Validar e-mails?"
      },
      "initBundle": {
        "numberType": "Tipo de números que planeou usar",
        "numberTypes": {
          "local": "Números locais",
          "mobile": "Móvel",
          "tollfree": "Número gratuito"
        },
        "selectCountry": "Selecione o seu país",
        "selectUserType": "Selecione o tipo de utilizador",
        "userTypes": {
          "business": "Empresa",
          "individual": "Individual"
        }
      },
      "manageLocationCredits": {
        "creditLastAddedOn": "Crédito adicionado pela última vez a:",
        "currentBalance": "Saldo atual",
        "debitBalance": "- Saldo do débito",
        "depositComplimentaryCreditsOf": "Depósito de créditos gratuitos de",
        "manageBalance": "Gerir saldo",
        "mustBeValidInteger": "Deve ser um número inteiro válido",
        "nextDate": "Próxima data:",
        "perMonth": "por mês",
        "remainingWalletBalance": "Saldo remanescente na carteira desta subconta",
        "rolloverCredits": "Transferir créditos para o mês seguinte",
        "toManageMonthlyCredits": "Para gerir os créditos mensais,"
      },
      "manageLocationSubscriptionModal": {
        "addNewSubscription": "Adicionar nova assinatura"
      },
      "manualActions": {
        "confirmDelete": "Tem a certeza de que pretende eliminar esta ação?",
        "confirmDeleteAll": "Tem a certeza de que pretende eliminar todas as ações manuais nesta página?"
      },
      "membership": {
        "resetPassword": {
          "generateStrongPassword": "Gerar uma palavra-passe forte",
          "sendEmailNotification": "Além disso, envie uma notificação por e-mail."
        }
      },
      "modal": {
        "description": "Para utilizar os sistemas telefónicos, tem de seguir alguns passos simples de conformidade",
        "submit": "Enviar",
        "title": "Serviço telefónico do LeadConnector"
      },
      "notifications": {
        "list": {
          "homePageVisitors": "Visitantes da página inicial",
          "launched": "Lançado",
          "newNotification": "Nova notificação",
          "startMessage": "Comece a aumentar as suas conversões criando a sua primeira notificação",
          "types": {
            "combination": "Combinação"
          }
        },
        "page": {
          "createTitle": "Criar nova notificação",
          "steps": {
            "display": "Apresentar",
            "track": "Rastrear"
          }
        }
      },
      "opportunities": {
        "columns": {
          "additionalInfo": "Informações adicionais",
          "calendarEvent": "Evento de calendário",
          "hideAssignedTo": "Ocultar atribuição a",
          "hideTags": "Ocultar etiquetas"
        },
        "filters": {
          "dateAddedAsc": "↑ Data de adição (ASC)",
          "dateAddedDesc": "↓ Data de adição (DESC)",
          "orderBy": "OrderBy"
        },
        "getStarted": "para começar!",
        "noPipelines": "Ups! Parece que não há pipelines. Crie um novo pipeline para"
      },
      "pages": {
        "pageMoved": {
          "title": "As listagens online foram movidas"
        }
      },
      "recentlyVisited": {
        "prices": "{count} preços"
      },
      "reminders": {
        "appointmentReminders": "Lembretes de compromisso",
        "apptTime": "Hora do compromisso",
        "defaultDateRange": "Dom, 1 de abril de 2018 - Seg, 30 de abril de 2018"
      },
      "saasAccountDetailsActiveSubscription": {
        "onHold": "Em espera",
        "rebillingOnHoldWarning": "Esta conta já tem definições de faturação recorrente em espera. O plano SaaS só pode ser anexado depois de o cliente adicionar um método de pagamento.",
        "subscriptionId": "ID da assinatura:"
      },
      "saasPricingTable": {
        "confirmAndProceed": "Confirmar e continuar",
        "documents": {
          "acceptedDocuments": "Documentos aceites",
          "acceptedDocumentsLabel": "Documentos aceites:",
          "additionalInfo": "Informações adicionais:",
          "createAddressLink": "Criar endereço.",
          "createAddressPrompt": "Crie primeiro um endereço e depois prossiga com a criação do pacote.",
          "documentInfo": "PNG, JPG, PDF até 5 MB",
          "documentType": "Tipo de documento",
          "option": "Opção {number}",
          "selectAddress": "Selecionar endereço:",
          "selectDocumentType": "Selecionar tipo de documento:",
          "selectFile": "Selecionar ficheiro",
          "title": "Documentos obrigatórios:",
          "updateDocuments": "Atualizar documentos"
        },
        "everythingIn": "Tudo em <b>{plan}+</b>",
        "noPaymentMethod": {
          "linkText": "adicionar cartão de crédito aqui",
          "message": "Peça ao seu cliente para",
          "title": "A localização precisa de adicionar um método de pagamento primeiro."
        },
        "noSaasPlan": {
          "linkText": "crie os seus planos SaaS aqui.",
          "message": "Por favor",
          "title": "Não tem nenhum plano SaaS configurado."
        },
        "saasModeSetupPendingWarning": "O plano SaaS será ativado depois de o cliente adicionar um método de pagamento. Até lá, o acesso à conta do mesmo será restrito.",
        "skipForNow": "Ignorar por agora",
        "skipPlan": "Ignorar plano",
        "success": {
          "title": "Pacote regulatório enviado com sucesso",
          "underReview": "Pacote enviado em revisão"
        }
      },
      "selectBundle": {
        "addressBundle": {
          "description": "Esta opção adicionará um novo endereço à sua conta",
          "label": "Pacote de endereços"
        },
        "regulatoryBundle": {
          "description": "Esta opção vai ajudar a criar um novo pacote regulatório",
          "label": "Pacote regulatório"
        },
        "title": "Escolha o pacote que quer adicionar"
      },
      "settings": {
        "billing": "Faturação",
        "calendars": "Calendários",
        "customEmails": "E-mails personalizados",
        "domains": "Domínios",
        "domainsAndUrlRedirects": "Domínios e redirecionamentos de URL",
        "facebookFormFieldsMapping": "Mapeamento de campos do formulário do Facebook",
        "groups": "Grupos",
        "integrations": "Integrações",
        "labs": "Laboratórios",
        "media": "Multimédia",
        "noShowSMS": "SMS de não comparência",
        "pipelines": "Pipelines",
        "profile": "Perfil",
        "smtpAndMailGunService": "Serviço SMTP e MailGun",
        "templates": "Modelos",
        "urlRedirects": "Redirecionamentos de URL"
      },
      "shakenStir": {
        "confirmation": {
          "title": "As suas chamadas estão agora verificadas!"
        },
        "modal": {
          "andThe": " e o ",
          "certification": "Certifico que o Perfil de empresa associado é o autor das chamadas telefónicas e certifico que participarei nos esforços de localização, incluindo os iniciados",
          "failedTitle": "Falha no envio",
          "friendlyNamePlaceholder": "Ex: SHST 2022-11-24 às 19:47:14",
          "linkInfo": {
            "description": "Todos os números atualmente disponíveis e os números comprados no futuro serão registados automaticamente no SHAKEN/STIR.",
            "title": "Todos os números serão vinculados automaticamente"
          },
          "stiPa": "Secure Telephony Identity Policy Administrator (STI-PA)",
          "subtitle": "Introduza os detalhes e a descrição",
          "successMessage": "O seu pedido de registo no SHAKEN/STIR foi enviado. Poderá demorar até <b>3-4 dias</b> a ser aprovado. O estado será atualizado em breve.",
          "successTitle": "Chamadas fidedignas SHAKEN/STIR ativadas.",
          "title": "Ativar a chamada de confiança SHAKEN/STIR",
          "tracebackGroup": "pelo Traceback Group da US Telecom"
        },
        "withCnam": {
          "cnamPromo": "Quer dar um passo adiante? Mostre o nome da sua empresa nas chamadas com o CNAM.",
          "registerCnam": "Registe-se no CNAM",
          "title": "Crie confiança com os clientes e aumente as taxas de atendimento de chamadas"
        },
        "successMessage": "Pedido de registo no SHAKEN/STIR enviado. Poderá demorar até <b>3-4 dias</b> a ser aprovado. O estado será atualizado em breve."
      },
      "shopify": {
        "selectLocation": "Selecione a localização que pretende vincular a esta loja Shopify"
      },
      "signup": {
        "accountType": "Tipo de conta",
        "agencyProAccount": "Conta de Agência Pro (497 $/mês)",
        "agencyTestAccount": "Conta de teste da agência",
        "freeTrialMessage": "Obtenha uma avaliação <strong>gratuita</strong> de 14 dias inscrevendo-se agora.",
        "freelancerAccount": "Conta de Trabalhador independente (297 $/mês)",
        "getStartedForFree": "Comece já gratuitamente!",
        "pickPassword": "Selecionar uma palavra-passe",
        "signUp": "Inscrever-se",
        "starterAccount": "Conta Inicial (97 €/mês)",
        "termsAndConditions": "Ao inscrever-se, concorda com os nossos <a href='https://www.gohighlevel.com/privacy' target='_blank'>Termos e Condições</a>",
        "yourCompanyName": "O nome da sua empresa",
        "yourFullName": "O seu nome completo"
      },
      "standardPlan": {
        "description": "Temos os seguintes planos para registos de marcas padrão.",
        "plans": {
          "common": {
            "einRequiredForRegistration": "EIN obrigatório para o registo",
            "moreThan1Phone": "É permitido mais do que 1 número de telefone"
          },
          "highVolume": {
            "heading": "Padrão de alto volume",
            "point3": "Até 600 000 segmentos por dia",
            "infoText": "O registo da marca e da campanha terá uma cobrança única de 20,95 dólares. Será aplicada uma taxa de campanha adicional de até 2,25 dólares por mês, de acordo com as regras do TCR.",
            "point2": "Envie até 3000 segmentos por dia",
            "point1": "EIN obrigatório para o registo"
          },
          "lowVolume": {
            "heading": "Padrão de baixo volume",
            "recommended": "Recomendado",
            "point3": "Até 6000 segmentos por dia",
            "infoText": "O registo da marca e da campanha terá uma cobrança única de 20,95 dólares. Será aplicada uma taxa de campanha adicional de até 2,25 dólares por mês, de acordo com as regras do TCR.",
            "point2": "Envie até 3000 segmentos por dia",
            "point1": "EIN obrigatório para o registo"
          }
        },
        "title": "Selecione o seu plano de marca padrão"
      },
      "submissionDetail": {
        "titles": {
          "bookingDetails": "Detalhes da reserva",
          "form": "Formulário",
          "quiz": "Questionário",
          "submissionDetail": "Detalhe do envio",
          "survey": "Inquérito"
        }
      },
      "suspension": {
        "suspended": {
          "description": "Apenas os administradores/utilizadores da agência têm acesso a esta subconta. Atualmente, não tem acesso a esta subconta nem os outros administradores/utilizadores da conta.",
          "heading": "Esta subconta foi colocada em pausa."
        },
        "temporarily": {
          "description": "Todos os seus dados estão seguros e todos os acionadores/campanhas, etc. retomarão o funcionamento após a ativação.",
          "heading": " A sua conta foi suspensa temporariamente."
        }
      },
      "triggers": {
        "assignUser": {
          "onlyUnassignedContacts": "Aplicar apenas a contactos não atribuídos",
          "splitTraffic": "Dividir tráfego",
          "trafficWeightage": "Ponderação de Tráfego",
          "userRequired": "O utilizador deve ser selecionado",
          "weightage": "Ponderação"
        },
        "birthdayFilters": {
          "afterDays": "N.º de dias depois",
          "beforeDays": "N.º de dias antes",
          "dayIs": "O dia é",
          "daysInNumber": "Dias em número",
          "hasTag": "Tem etiqueta",
          "monthIs": "O mês é",
          "selectDay": "Selecionar dia",
          "selectMonth": "Selecionar mês"
        },
        "botConversation": {
          "enterTimeout": "Introduzir um tempo limite (horas)",
          "selectEliza": "Selecionar Eliza",
          "selectThankyouTemplate": "Selecionar modelo de agradecimento",
          "selectWelcomeTemplate": "Selecionar modelo de boas-vindas"
        },
        "contactField": {
          "addField": "Adicionar campo",
          "defineFilters": "Definir filtros"
        },
        "copyModal": {
          "title": "Acionador de cópia"
        },
        "detailModal": {
          "actionsPerform": "Que ações devemos realizar?",
          "campaignNameRequired": "O campo Nome da campanha é obrigatório",
          "campaignsDeprecation": "As campanhas já não são mantidas. Para garantir uma transição suave, converta as suas campanhas existentes em fluxos de trabalho.",
          "folderName": "Nome da pasta",
          "mustSelectFolder": "Deve selecionar uma pasta.",
          "newFolderName": "Novo nome da pasta",
          "selectFolder": "Selecionar pasta",
          "triggerNameRequired": "O campo Nome do acionador é obrigatório",
          "triggersDeprecation": "Os acionadores já não são mantidos. Para garantir uma transição suave, converta os seus acionadores existentes em fluxos de trabalho.",
          "triggerName": "Nome do acionador"
        },
        "dnd": {
          "disableAll": "Desativar DND para todos os canais",
          "disableSpecific": "Desativar DND para canais específicos",
          "enableAll": "Ativar DND para todos os canais",
          "enableSpecific": "Ativar DND para canais específicos",
          "selectAction": "Selecionar ação"
        },
        "email": {
          "sendTestEmail": "Enviar e-mail de teste",
          "smtpWarning": "Os fornecedores SMTP têm algumas limitações. Clique aqui para saber mais."
        },
        "facebook": {
          "avatarAlt": "Avatar do Facebook",
          "selectCustomAudience": "Selecionar público personalizado"
        },
        "googleAds": {
          "conversionName": "Nome da conversão",
          "conversionTooltip": "A fonte de conversão deve ser Importar de cliques e a categoria deve ser Oportunidade potencial importada ou Oportunidade potencial",
          "noConversions": "Nenhuma conversão encontrada",
          "selectConversion": "Selecionar conversão"
        },
        "googleAnalytics": {
          "eventAction": "Ação de evento",
          "eventActionRequired": "A ação de evento é obrigatória.",
          "eventCategory": "Categoria do evento",
          "eventCategoryRequired": "A categoria do evento é obrigatória.",
          "eventLabel": "Etiqueta do evento",
          "eventValue": "Valor do evento",
          "hitType": "Tipo de resultado",
          "hitTypeRequired": "O tipo de resultado é obrigatório.",
          "trackingId": "ID de rastreio",
          "trackingIdRequired": "O ID de rastreio é obrigatório."
        },
        "membershipOffer": {
          "selectOffer": "Selecionar oferta"
        },
        "notification": {
          "selectRedirectPage": "Selecionar página de redirecionamento",
          "selectUser": "Selecionar utilizador",
          "selectUserType": "Selecionar tipo de utilizador"
        },
        "sms": {
          "sendTestSMS": "Enviar SMS de teste"
        },
        "stripeCharge": {
          "customerId": "ID do cliente Stripe",
          "enterAmount": "Introduzir montante",
          "selectCurrency": "Selecionar moeda"
        },
        "webhook": {
          "webhookUrl": "URL de Webhook"
        }
      },
      "twilioReselling": {
        "transactions": {
          "fields": {
            "activityDate": "Data da atividade",
            "balance": "Saldo",
            "id": "id"
          }
        },
        "upgradeBanner": {
          "subtitle": "As agências no plano Pro ganham cerca de 363 $ por mês com uma faturação recorrente dos custos telefónicos aos respetivos clientes",
          "title": "Pretende efetuar a refaturação recorrente destes custos aos seus clientes?"
        }
      },
      "updateModals": {
        "error": {
          "title": "Falha ao enviar o seu perfil."
        },
        "success": {
          "message": "A sua marca e campanha A2P foram enviadas.<br/><br/><b>Nota:</b> vai <b>receber uma mensagem OTP no número de telemóvel fornecido para verificação</b> no TCR. <b>Responda Yes no prazo de 24 horas</b> após receber o SMS."
        }
      },
      "usageLimit": {
        "contactLimit": "Limite de contactos",
        "maxContactsAllowed": "Máximo de contactos permitidos na subconta",
        "maxUsersAllowed": "Máximo de utilizadores permitidos na subconta",
        "unlimited": "Ilimitado",
        "usageLimits": "Limites de utilização",
        "userLimit": "Limite de utilizadores",
        "userLimitHelpMessage": "Apenas os utilizadores do nível de subconta contam para este limite. Ainda pode adicionar os utilizadores de agência que precisar às subcontas"
      },
      "yext": {
        "reselling": {
          "agreeToEnable": "Concordo em ativar as listagens para este cliente sem realizar venda superior e reconheço que será feita uma cobrança de",
          "deployDirectly": "Implementar listagens diretamente",
          "deployDirectlyDesc": "Utilize esta opção se estiver a oferecer listagens como parte da sua oferta ou se pretender faturar o seu cliente externamente",
          "minimumCommitment": "com um período mínimo de permanência de 1 mês.",
          "offerListings": "Listagens de ofertas",
          "resellListings": "Listagens de revendas",
          "subscribedInfo": "{withoutUpsell} sem realizar venda superior, {withUpsell} com realização de venda superior e {withSaas} com pacote Saas",
          "subscriptionCreated": "Assinatura criada com sucesso. Aguarde...",
          "subscriptionCreating": "A assinatura está a ser criada.<br/>Não recarregue nem clique no botão Voltar",
          "unableToCreate": "Não foi possível criar a assinatura, contacte o suporte",
          "unavailabilityForAgencyAdmin": "Yext não está disponível neste país. Se considera que se trata de um erro, solicite-o no nosso roadmap em",
          "yourResellOffer": "A sua oferta de revenda"
        }
      },
      "selectCountry": "Selecione o seu país",
      "documents": {
        "additionalInfo": "Informações adicionais",
        "createAddressLink": "Crie o endereço.",
        "createAddressPrompt": "Crie primeiro um endereço e depois prossiga com a criação do pacote.",
        "selectAddress": "Selecione o endereço:"
      }
    },
    "triggers": {
      "emptyTrigger": "Acionador vazio"
    },
    "util": {
      "addFiles": "+ Adicionar ficheiros",
      "fillValues": "Preencher valores",
      "image": "img",
      "ok": "Ok",
      "pleaseTypeOrCancel": "Escreva {consentString} acima ou cancele esta ação.",
      "pressEnterToAddCustomOption": "Prima Enter para adicionar uma opção personalizada",
      "required": "* obrigatório",
      "unsaved": "Não guardado"
    },
    "workflow": {
      "announcement": {
        "enableMessage": "Para ativar o fluxo de trabalho para uma localização, aceda ao separador Contas, clique no ícone de três pontos à direita de uma subconta e selecione <strong>Ativar construtor de fluxos de trabalho</strong>. Este processo é temporário, pois os fluxos de trabalho ficarão ativos em todas as localizações na próxima semana."
      },
      "faq": "FAQ",
      "gotIt": "Compreendi",
      "workflowIsLive": "O fluxo de trabalho está ativo na sua conta!"
    },
    "action": {
      "stats": {
        "bounced": "Rejeitado",
        "clicked": "Clicado",
        "delivered": "Entregue",
        "opened": "Aberto",
        "replied": "Respondido",
        "unsubscribed": "Com subscrição anulada",
        "total": "Total",
        "failed": "Falhou"
      },
      "actions": {
        "edit": "Editar",
        "send": "Enviar",
        "remove": "Remover"
      },
      "timing": {
        "days": "Dias",
        "immediately": "Imediatamente",
        "before": "Antes de",
        "after": "Depois de",
        "minutes": "Minutos",
        "hours": "Horas"
      },
      "labels": {
        "template": "Modelo",
        "manual": "Manual"
      },
      "details": {
        "hideDetail": "Ocultar Detalhes",
        "showDetail": "Mostrar detalhe"
      },
      "queue": {
        "people": "pessoas",
        "person": "pessoa",
        "queued": "em fila"
      },
      "tooltips": {
        "clickedHelp": "A precisão do rastreamento de cliques pode variar com base no cliente de e-mail e nas configurações do utilizador.",
        "statsAccuracy": "A precisão das estatísticas pode variar dependendo do cliente de e-mail e das configurações do utilizador."
      }
    },
    "bulkRequest": {
      "list": {
        "confirmDelete": "Tem a certeza de que o pretende eliminar este pedido em massa?",
        "startImmediately": "Comece Imediatamente"
      },
      "modal": {
        "contactTypes": {
          "all": "Todos",
          "leads": "Oportunidades potenciais",
          "customers": "Clientes"
        },
        "buttons": {
          "cancel": "Cancelar",
          "update": "Atualizar",
          "add": "Adicionar"
        },
        "labels": {
          "name": "Nome",
          "contactType": "Tipo de contacto",
          "campaign": "Campanha",
          "scheduledDate": "Data agendada",
          "tag": "Etiqueta"
        },
        "placeholders": {
          "tags": "Etiquetas",
          "selectCampaign": "Selecionar campanha",
          "pickType": "Selecionar tipo"
        },
        "sections": {
          "bulkRequest": "Pedido em massa",
          "whoShouldRun": "Para quem deve ser executado?"
        },
        "titleAdd": "Adicionar pedido em massa",
        "titleEdit": "Editar pedido em massa",
        "validation": {
          "scheduledDateRequired": "A data de agendamento é obrigatória"
        }
      }
    },
    "listFolder": {
      "expandIcon": "Expandir"
    },
    "list": {
      "confirmDeleteFolder": "Confirmar eliminação da pasta",
      "delete": "Eliminar",
      "confirmDelete": "Tem a certeza de que pretende eliminar esta campanha?",
      "moveToFolder": "Mover para pasta",
      "pleaseRename": "mude o nome",
      "removeFromFolder": "Remover da pasta"
    },
    "copy": {
      "title": "Copiar campanha",
      "newCampaignName": "Nome da nova campanha",
      "locations": "Localizações"
    }
  },
  "compliance": {
    "findOutMore": "Descobrir mais",
    "gdprDescription": "Levamos muito a sério a proteção dos seus dados pessoais e dos seus clientes e tratamos os dados pessoais de forma confidencial e de acordo com os regulamentos legais de proteção de dados e com a presente declaração de proteção de dados",
    "gdprTitle": "Conformidade com o RGPD",
    "hipaaDescription": "Ative as atualizações de segurança para garantir que os dados na sua conta HighLevel estão seguros e cumprem os requisitos da HIPAA",
    "hipaaTitle": "Conformidade com a HIPAA"
  },
  "customValues": {
    "key": "Chave",
    "selectedItemsCountSingular": "{count} linha selecionada",
    "selectedItemsCountPlural": "{count} linhas selecionadas"
  },
  "facebookAdFields": {
    "checkIcon": "Formulário mapeado com sucesso",
    "errorMessage": "O token de acesso à página expirou ou não tem permissões suficientes. Certifique-se de que tem acesso de administrador às páginas."
  },
  "fbLeadSync": {
    "confirmTitle": "Confirmar sincronização de oportunidades potenciais do Facebook?",
    "impactMessage": "Compreenda o impacto da sincronização de oportunidades potenciais do Facebook antes de prosseguir:",
    "observations": "1. Esta ação irá sincronizar as oportunidades potenciais do Facebook e criar novos contactos para todas as oportunidades potenciais geradas nos últimos {days} dias que não existam na sua lista de contactos. <br>2. Se importou manualmente as oportunidades potenciais em falta utilizando CSVs exportados do Gestor de anúncios do Facebook, desative a opção &quot;Permitir contactos duplicados&quot; para evitar que a sincronização crie contactos duplicados. <br>3. Se tiver fluxos de trabalho que são acionados na <b>criação de um contacto</b> ou no <b>envio de um formulário de oportunidades potenciais do Facebook</b>, eles serão acionados para cada novo contacto criado. <br>4. Os contactos existentes criados através das oportunidades potenciais do Facebook não serão afetados. <br>5. A hora de criação do contacto no registo será a hora atual. <br>6. A sincronização pode demorar até uma hora para ser concluída, dependendo do número de oportunidades potenciais que ainda têm de ser sincronizadas. <br>",
    "proceedQuestion": "Gostaria de prosseguir com a sincronização de oportunidades potenciais do Facebook?"
  },
  "integrationAI": {
    "accountDisconnected": "Conta desligada!",
    "appNotFound": "Configuração da aplicação não encontrada. A utilizar dados de recurso.",
    "checkingConnection": "A verificar o estado da ligação...",
    "connecting": "A ligar...",
    "disconnectApp": "Desligar aplicação",
    "disconnecting": "A desligar...",
    "loadingAppInfo": "A carregar informações da aplicação...",
    "refreshConnection": "Atualizar ligação",
    "refreshing": "A atualizar...",
    "svgNotAvailable": "SVG não disponível"
  },
  "phoneSystem": {
    "additionalSettings": "Definições adicionais",
    "messaging": "Mensagens",
    "messagingAnalytics": "Análise de mensagens",
    "regulatoryBundles": "Pacotes regulatórios",
    "title": "Sistema telefónico",
    "trustCenter": "Centro de Confiança",
    "voice": "Voz"
  },
  "demo": {
    "draggable": {
      "title": "Teste de componente arrastável",
      "usingVue3": "Utilizar elemento arrastável compatível com Vue 3",
      "description": "Este componente está agora a utilizar o componente arrastável compatível com o Vue 3 revisto.",
      "buttons": {
        "resetAllLists": "Repor todas as listas",
        "clearLog": "Limpar Registo",
        "stopLoading": "Parar de carregar",
        "simulateLoading": "Simular carregamento",
        "refreshData": "Atualizar dados"
      },
      "examples": {
        "basicDraggable": "Arrastável básico",
        "draggableWithElement": "Arrastável com elemento",
        "draggableWithTransitionGroup": "Arrastável com grupo de transição",
        "draggableWithMoveFunction": "Arrastável com função de mover"
      },
      "eventLog": "Registo de Eventos",
      "handle": "Identificador",
      "name": "Nome",
      "cannotMove": "(não é possível mover)"
    },
    "tableDemo": {
      "title": "Demonstração do UIBTable Vue 3",
      "basicControls": "Controlos básicos",
      "labels": {
        "filter": "Filtrar:",
        "sortBy": "Ordenar por:",
        "sortDirection": "Direção de ordenação:",
        "perPage": "Por página:",
        "tableStyling": "Estilo de tabela:"
      },
      "placeholders": {
        "typeToSearch": "Escreva para pesquisar..."
      },
      "checkboxLabels": {
        "striped": "Listrado",
        "bordered": "Com limite",
        "hover": "Pairar",
        "small": "Pequeno",
        "responsive": "Responsivo"
      },
      "fields": {
        "id": "ID",
        "name": "Nome",
        "email": "E-mail",
        "status": "Estado",
        "created": "Criado",
        "actions": "Ações"
      },
      "statuses": {
        "active": "Ativo",
        "inactive": "Inativo",
        "pending": "Pendente",
        "banned": "Banido"
      },
      "modal": {
        "title": "Detalhes do item",
        "close": "Fechar"
      },
      "messages": {
        "confirmDelete": "Tem a certeza de que pretende eliminar {name}?",
        "editItem": "Editar item {id}",
        "showingItems": "A apresentar {count} de {total} itens"
      }
    },
    "saasPricingTable": {
      "confirmAndProceed": "Confirmar e continuar",
      "everythingIn": "Tudo em <b>{plan}+</b>",
      "noPaymentMethod": {
        "linkText": "adicionar cartão de crédito aqui",
        "message": "Por favor, peça ao seu cliente para",
        "title": "A localização precisa de adicionar um método de pagamento primeiro."
      },
      "noSaasPlan": {
        "linkText": "crie os seus planos SaaS aqui.",
        "message": "Por favor",
        "title": "Não tem nenhum plano SaaS configurado."
      },
      "saasModeSetupPendingWarning": "O plano SaaS será ativado depois de o cliente adicionar um método de pagamento. Antes disso, o acesso à conta do mesmo será restrito.",
      "skipForNow": "Ignorar por agora",
      "skipPlan": "Ignorar plano"
    }
  },
  "isv": {
    "business_registration_id_type": "Tipo de ID de registo comercial",
    "business_registration_number": "Número de registo comercial",
    "business_website": "Sítio Web da empresa",
    "enter_your_business_registration_id_type": "Introduza o tipo de ID de registo comercial",
    "name_of_other_registration_id_type": "Nome de outro tipo de ID de registo",
    "pick_business_industry": "Escolha a indústria da empresa",
    "pick_business_registration_id_type": "Escolha o tipo de ID de registo comercial",
    "emailWithStar": "E-mail*",
    "businessIndustry": "Indústria da empresa*",
    "businessType": "Tipo de empresa*",
    "regionsOfOperations": "Regiões de operações da empresa*",
    "registrationNumber": "Número de registo comercial*",
    "registrationNumberHelper": "O número utilizado para identificar a sua empresa. No caso de um EIN dos EUA, deve ser um número de 9 dígitos, por exemplo: 12-3456789.",
    "businessWebsiteWithStar": "Sítio Web da empresa*",
    "businessTypeWithStar": "Tipo de empresa",
    "businessWebsite": "Sítio Web da empresa"
  },
  "aiProductRebilling": {
    "enableRebilling": "Ativar faturação recorrente",
    "ratesMayDiffer": "As taxas podem variar de acordo com a região. Os cálculos apresentados referem-se às taxas do Reino Unido,",
    "supportDoc": "documento de suporte",
    "cancel": "Cancelar",
    "profit": "Lucro",
    "chargedToCustomer": "Cobrado ao cliente",
    "enabling": "A ativar...",
    "forMore": "para obter mais detalhes.",
    "rebillAmount": "Montante da faturação recorrente",
    "tenDollarsWillGive": "10 dólares dá para cerca de",
    "yourCost": "O seu custo",
    "clientBillingPage": "página de faturação da empresa do cliente",
    "needStripeConnection": "Para ativar a faturação recorrente, tem de ligar a sua Conta Stripe em",
    "per1000Words": "por 1000 palavras",
    "perImage": "por imagem",
    "perReviewResponse": "segundo a Resposta à avaliação",
    "perFunnel": "por funil",
    "minimumBetween": "O mínimo deve estar entre {min} e {max}",
    "images": "imagens",
    "reviewResponse": "resposta à avaliação",
    "funnel": "funil",
    "pleaseCheckSupport": "por favor, verifique"
  },
  "a2p": {
    "otpSuccess": {
      "title": "Sucesso do OTP",
      "message": "Mensagem de sucesso OTP"
    },
    "otpError": {
      "title": "Erro de OTP",
      "message": "Mensagem de Erro OTP"
    },
    "businessProfileError": {
      "title": "Erro no Perfil de empresa",
      "message": "Mensagem de Erro no Perfil de empresa"
    },
    "addressError": {
      "title": "Erro de Endereço",
      "status": "Estado de Erro de Endereço"
    },
    "profileError": {
      "title": "Erro de Perfil A2P",
      "message": "Mensagem de Erro do Perfil A2P"
    },
    "address": {
      "country": "País",
      "state": "Distrito",
      "chooseCountry": "Selecionar país...",
      "statePlaceholder": "Introduzir distrito",
      "chooseState": "Selecionar estado...",
      "city": "Cidade*",
      "postalCode": "Código Postal*",
      "streetAddress": "Endereço da rua*",
      "streetAddressHelper": "Deve ser um endereço válido vinculado à sua empresa.",
      "title": "Endereço da empresa"
    },
    "validation": {
      "brandNameRequired": "O nome da marca é obrigatório.",
      "businessVerticalRequired": "O vertical da empresa é obrigatório.",
      "cityRequired": "A cidade é obrigatória.",
      "countryRequired": "O país é obrigatório.",
      "invalidMobileNumber": "Número de telemóvel inválido.",
      "mobileNumberRequired": "O número de telemóvel é obrigatório.",
      "postalCodeRequired": "O código postal é obrigatório.",
      "stateRequired": "O estado é obrigatório.",
      "streetAddressRequired": "O endereço da rua é obrigatório."
    },
    "authorizedRep": {
      "email": "E-mail*",
      "firstName": "Nome próprio*",
      "jobPosition": "Função*",
      "jobTitle": "Cargo*",
      "jobTitlePlaceholder": "Introduza o título do cargo",
      "lastName": "Apelido*",
      "phoneNumber": "Número de telefone*",
      "phoneNumberPlaceholder": "Introduzir número de telefone",
      "pickJobPosition": "Escolher função",
      "title": "Detalhes do representante autorizado"
    },
    "registration": {
      "stepProgress": "Passo {currentStep} de 8",
      "successTitle": "A sua marca e campanha A2P foram enviadas.",
      "successWaitDays": "7 dias",
      "successWaitPrefix": "Poderá demorar até ",
      "successWaitSuffix": " para a aprovação da sua marca e mais 4-5 semanas para a aprovação da campanha.",
      "otpNote": "Nota: vai receber uma mensagem OTP no número de telemóvel fornecido para verificar a partir do TCR. Responda Sim (Yes) no prazo de 24 horas após receber o SMS."
    },
    "update": {
      "brandDetailsTitle": "Atualizar Detalhes da Marca",
      "brandName": "Nome da marca*",
      "brandNameHelper": "Utilize o nome legal da organização que está a enviar as mensagens, ou o seu próprio nome se esta marca não for para uma organização.",
      "businessVerticals": "Indústria da empresa*",
      "chooseVertical": "Selecionar a vertical...",
      "mobileNumber": "Número de telemóvel para verificação com OTP (com indicativo)*",
      "mobileNumberHelper": "Indique um número de telemóvel ao qual tenha acesso, para poder confirmar a verificação com OTP. Apenas serão aceites números de telefone dos EUA/Canadá. Não pode utilizar um número de telefone CPaaS, como um obtido do LeadConnector. Não pode usar o mesmo número de telemóvel para registar mais de 3 marcas em nome individual. Este limite é gerido pelo TCR.",
      "updateButton": "Atualizar",
      "retryOTPTitle": "Repetir OTP",
      "retryOTPMessage": "Clique no botão abaixo para reenviar a mensagem de verificação com OTP.",
      "sending": "A enviar...",
      "resendOTP": "Reenviar OTP"
    },
    "einModal": {
      "title": "Tem um EIN?",
      "question": "Tem um Número de Identificação de Empregador (EIN)?",
      "hasEIN": "Sim, tenho um EIN",
      "noEIN": "Não, não tenho um EIN",
      "disableNoEINText": "O EIN é obrigatório para locais fora dos EUA/CA",
      "infoText": "É necessário um EIN para empresas nos Estados Unidos e no Canadá."
    },
    "brandDetails": {
      "brandHeading": "Detalhes da marca",
      "brandName": "Nome da marca*",
      "brandNameHelper": "Utilize o nome legal da organização que está a enviar as mensagens, ou o seu próprio nome se esta marca não for para uma organização.",
      "businessIndustry": "Indústria da empresa*",
      "chooseVertical": "Selecionar Vertical...",
      "mobileNumber": "Número de telemóvel para verificação com OTP (com indicativo do país)*",
      "mobileNumberHelper": "Indique um número de telemóvel ao qual tenha acesso, para poder confirmar a verificação com OTP. Apenas serão aceites números de telefone dos EUA/Canadá. Não pode utilizar um número de telefone CPaaS, como um obtido do LeadConnector. Não pode usar o mesmo número de telemóvel para registar mais de 3 marcas em nome individual. Este limite é gerido pelo TCR.",
      "solePropBrand": {
        "heading": "Marca em nome individual",
        "point1": "Apenas 1 número de telefone é permitido",
        "point2": "EIN/SSN/DUNS não obrigatório",
        "subheading": "Registo de marca em nome individual"
      },
      "solePropCampaign": {
        "heading": "Campanha em nome individual",
        "point1": "Só é permitido associar 1 número a uma campanha em nome individual",
        "point2": "Uma vez aprovado, o seu número predefinido será associado automaticamente",
        "infoText": "Também pode atualizar o número após a aprovação",
        "warningText": "Só é permitido associar 1 número a uma campanha em nome individual. Uma vez aprovado, o seu número predefinido será vinculado automaticamente. Também pode atualizar o número após a aprovação.",
        "subheading": "Registo de Campanha Sole Prop"
      },
      "solePropSubtitle": "Detalhes da marca e da campanha em nome individual",
      "standardBrand": {
        "heading": "4,41 $ - Único",
        "point1": "EIN/SSN/DUNS obrigatório",
        "point2": "É permitido mais do que 1 número de telefone",
        "subheading": "Registo de marca padrão"
      },
      "standardCampaign": {
        "heading": "16,54 $ - Única vez",
        "point1": "É permitido ligar mais de 1 número a uma campanha padrão",
        "point2": "EIN/SSN/DUNS obrigatório",
        "infoText": "Será aplicada uma taxa de campanha adicional de até 12 $ por mês, de acordo com as regras do TCR.",
        "subheading": "Registo de campanha padrão"
      },
      "standardSubtitle": "Detalhes da marca e da campanha padrão",
      "title": "Detalhes da marca e da campanha"
    },
    "campaign": {
      "useCaseDetails": {
        "title": "Detalhes do Caso de Uso da Campanha",
        "subtitle": "Introduza os detalhes e a descrição da campanha",
        "useCase": "Caso de Uso da Campanha*",
        "pickUseCase": "Escolher caso de utilização da campanha",
        "useCaseDescription": "Descrição do caso de utilização*",
        "explainInDetail": "Explique em detalhe",
        "useCaseDescriptionPlaceholder": "Exemplo: Esta campanha envia informações sobre compromissos - confirmação e mensagens de lembrete aos nossos clientes depois de terem marcado uma marcação connosco no nosso sítio Web e terem optado por receber SMS promocionais e de notificação da nossa parte.",
        "useCaseDescriptionHelper": "Por favor, forneça uma descrição detalhada de como irá utilizar esta campanha.",
        "solePropLabel": "Empresário em nome individual",
        "seeExamples": "Ver Exemplos",
        "closeExamples": "Fechar Exemplos"
      }
    }
  },
  "opportunities": {
    "email": "E-mail",
    "phone": "Telefone",
    "status": "Estado",
    "contactType": "Tipo de contacto",
    "bulkOperation": "Operação em massa",
    "contactName": "Nome do contacto",
    "unassigned": "Não atribuído",
    "abandoned": "Abandonado",
    "addOpportunityName": "Adicionar nome da oportunidade",
    "companyName": "Nome da empresa",
    "contactInfo": "Informações de contato",
    "enterValue": "Introduzir valor",
    "lost": "Perdido",
    "open": "Aberto",
    "opportunityInfo": "Informações da oportunidade",
    "opportunityName": "Nome da oportunidade",
    "opportunitySource": "Fonte da oportunidade",
    "owner": "Proprietário",
    "pipeline": "Pipeline",
    "selectPipeline": "Selecionar pipeline",
    "selectStage": "Selecionar fase",
    "stage": "Fase",
    "won": "Ganho",
    "createdOn": "Criado a",
    "goToContactDetail": "Vá para a página de detalhes do contacto",
    "leadValue": "Valor de oportunidade potencial",
    "removeOwner": "Remover proprietário",
    "createdBy": "Criado por",
    "notAllowedToChange": "Não lhe é permitido alterar este contacto",
    "opportunityAlreadyExists": "Já existe uma oportunidade para este contacto no pipeline selecionado",
    "filters": {
      "all": "Tudo",
      "statuses": {
        "all": "Tudo",
        "open": "Aberta",
        "won": "Ganha",
        "lost": "Perdida",
        "abandoned": "Abandonada"
      },
      "search": "Pesquisar",
      "status": "Estado",
      "campaign": "Campanha",
      "owner": "Proprietário",
      "pipeline": "Pipeline",
      "dateAddedAsc": "↑ Data adicionada (ASC)",
      "dateAddedDesc": "↓ Data adicionada (DESC)",
      "orderBy": "OrderBy"
    },
    "columns": {
      "note": "Nota",
      "task": "Tarefa",
      "companyName": "Nome da empresa",
      "additionalInfo": "Informações adicionais",
      "calendarEvent": "Evento de calendário",
      "hideAssignedTo": "Ocultar atribuição a",
      "hideTags": "Ocultar etiquetas"
    },
    "buttons": {
      "new": "Nova"
    },
    "dragActions": {
      "abandoned": "Abandonada",
      "lost": "Perdida",
      "won": "Ganha"
    },
    "getStarted": "para começar!",
    "noPipelines": "Ups! Parece que não há pipelines. Crie um novo pipeline",
    "addTask": "Adicionar tarefa",
    "tasksCount": "{count} atividades"
  },
  "appointmentDetails": "Detalhes do compromisso",
  "cloneFunnel": {
    "cloneButton": "Clonar {entityName}",
    "cloning": "A clonar...",
    "cloningLimit": "A clonagem está limitada a 3 localizações de cada vez",
    "error": "Erro ao clonar o funil!",
    "locationsLabel": "Selecionar localizações",
    "nameLabel": "Nome para a {entityName} clonada",
    "namePlaceholder": "Introduza o nome para a clonagem de {entityName}",
    "selectUpTo": "Selecione até {maxSelectableLocations} localizações",
    "title": "Clonar {entityName}"
  },
  "errors": "Erros",
  "renderEmailAddress": "Renderizar endereço de e-mail",
  "noPaymentMethodWarning": "Aviso de ausência de método de pagamento",
  "pageDetail": "Detalhes da página",
  "activityHistory": "Histórico de Atividade",
  "uiAlert": "Alerta UI",
  "eventModals": {
    "wait": {
      "save": "Guardar",
      "days": "Dias",
      "fri": "Sex",
      "mon": "Seg",
      "sat": "Sáb",
      "sun": "Dom",
      "thu": "Qui",
      "tue": "Ter",
      "wed": "Qua",
      "wait": "Esperar",
      "minutes": "Minutos",
      "hours": "Horas",
      "title": "Editar Evento de Espera",
      "whichDaysResume": "Em que dias devemos retomar?",
      "pickDayError": "Selecione pelo menos um dia",
      "whatTimeResume": "A que horas devemos retomar?"
    },
    "sms": {
      "send": "Enviar",
      "name": "Nome",
      "attachFile": "Anexar ficheiro",
      "learnMore": "Saiba mais",
      "sendTest": "Enviar Teste",
      "title": "Editar evento {eventType}",
      "titleTemplate": "Editar o modelo {eventType}",
      "nameRequired": "O nome é obrigatório",
      "pickTemplate": "Escolher Modelo",
      "appCharacters": "Caracteres da aplicação",
      "numSegments": "Número de segmentos",
      "approximateCost": "Custo aproximado",
      "costEstimateNote": "Nota de estimativa de custo",
      "urlAttachmentAutocompleteToken": "Anexo de URL",
      "addFileUrl": "Adicionar URL de ficheiro",
      "urlImageAlt": "URL da Imagem",
      "fileImageAlt": "Imagem do ficheiro",
      "enterMessage": "Introduza mensagem",
      "mobilePhonePlaceholder": "Telemóvel",
      "unsupportedContentType": "Tipo de conteúdo não suportado: {fileType}",
      "urlAttachmentWarning": "O anexo de URL {count} {plural} falhou ao carregar. Pretende continuar?",
      "provideMobileNumber": "Indique o número de telemóvel"
    },
    "email": {
      "text": "Texto",
      "checkLinks": "Verifique as ligações onde tem um valor personalizado. Há um '%20' extra entre {{ e custom_values.",
      "errorOccurred": "Ocorreu um erro; tente novamente.",
      "insertToAddress": "Introduza um endereço de destinatário."
    },
    "voicemail": {
      "save": "Guardar",
      "dropFile": "Arraste o ficheiro aqui ou clique para carregar",
      "faq": "FAQ",
      "title": "Editar Evento de Correio de Voz",
      "voicemailFile": "Ficheiro de correio de voz",
      "warning": "Aviso: os ficheiros de correio de voz têm de estar no formato MP3, WAV ou GSM.",
      "unsupportedFormat": "Formato de ficheiro não suportado. Utilize MP3, WAV ou GSM."
    },
    "call": {
      "title": "Editar Evento de Chamada",
      "save": "Guardar",
      "name": "Nome",
      "nameRequired": "O nome é obrigatório",
      "callWhisper": "Sussurro de chamada",
      "whisperMessage": "Mensagem sussurrada",
      "thisIsTheMessage": "Esta é a mensagem que será reproduzida para o agente antes de conectar a chamada.",
      "callTimeoutS": "Tempo limite de chamada (s)",
      "timeoutSeconds": "Tempo limite (segundos)",
      "disableVoicemailDetect": "Desativar a deteção de correio de voz",
      "callWillPatchInstantly": "A chamada será conectada instantaneamente sem detetar o correio de voz."
    }
  },
  "emailTemplate": {
    "createdOn": "Criado em",
    "updatedOn": "Atualizado em"
  },
  "cnam": {
    "learnMore": {
      "title": "CNAM Saiba Mais",
      "description": "Descrição CNAM"
    },
    "submitted": {
      "checkStatus": "Verificar estado do CNAM",
      "description": "O nome da sua empresa deve ser apresentado aos contactos aplicáveis dentro de cerca de 3 a 5 dias.",
      "subtitle": "O seu pedido de CNAM foi agora enviado.",
      "title": "Parabéns!"
    },
    "registration": {
      "confirm": "Confirmar",
      "learnMore": "Saiba mais",
      "characterLimit": "{count}/15",
      "title": "Registo de CNAM",
      "description": "Introduza o nome da sua empresa (máximo 15 caracteres)",
      "warning": "Aviso: o nome da sua empresa será exibido no ID de chamadas. "
    }
  },
  "updateModals": {
    "error": {
      "title": "Erro de Atualização",
      "message": "Mensagem de Erro de Atualização"
    },
    "success": {
      "message": "A sua marca e campanha A2P foram enviadas.<br/><br/><b>Nota:</b> vai <b>receber uma mensagem OTP no número de telemóvel fornecido para verificação</b> no TCR. <b>Responda Yes no prazo de 24 horas</b> após receber o SMS.",
      "title": "A sua marca e campanha A2P foram enviadas. Pode demorar até <b>7 dias</b> para a aprovação da sua marca e mais 4-5 semanas para a aprovação da campanha."
    }
  },
  "regulatoryBundle": {
    "error": {
      "title": "Erro do pacote regulatório",
      "status": "Estado de Erro do Pacote Regulatório"
    },
    "createAddress": {
      "successMessage": "A sua marca e campanha A2P foram enviadas.",
      "successTitle": "Endereço enviado com sucesso",
      "underReview": "O endereço enviado está a ser revisto"
    },
    "createEndUser": {
      "dateFormat": "O formato da data deve ser AAAA-MM-DD.",
      "phoneExample": " Exemplo: +14155552671",
      "title": "Detalhes da empresa:"
    },
    "success": {
      "title": "Pacote regulatório enviado com sucesso",
      "underReview": "Pacote enviado em revisão",
      "message": "Pedido de registo no SHAKEN/STIR enviado. Poderá demorar até <b>3-4 dias</b> a ser aprovado. O estado será atualizado em breve."
    },
    "documents": {
      "additionalInfo": "Informações adicionais",
      "createAddressLink": "Criar endereço.",
      "createAddressPrompt": "Crie primeiro um endereço e depois prossiga com a criação do pacote.",
      "selectAddress": "Selecione o Endereço:"
    },
    "selectBundle": {
      "addressBundle": {
        "description": "Esta opção adicionará um novo endereço à sua conta",
        "label": "Pacote de Endereços"
      },
      "regulatoryBundle": {
        "description": "Esta opção vai ajudá-lo a criar um novo pacote regulamentar",
        "label": "Pacote Regulatório"
      },
      "title": "Selecione que pacote quer adicionar"
    },
    "modal": {
      "back": "Voltar",
      "next": "Seguinte",
      "submit": "Enviar",
      "title": "Novo Pacote Regulatório",
      "description": "Crie um novo pacote regulatório para a sua localização"
    }
  },
  "reminder": {
    "phone": "Telefone",
    "noReplyYet": "Ainda sem resposta"
  },
  "sendGrid": {
    "apiKey": "Chave API SendGrid",
    "save": "Guardar SendGrid",
    "apiKeyRequired": "API Key SendGrid obrigatória"
  },
  "twilioReselling": {
    "upgradeBanner": {
      "upgradeButton": "Fazer upgrade",
      "subtitle": "As agências no plano Pro ganham cerca de 363 $ por mês com uma faturação recorrente dos custos telefónicos aos respetivos clientes",
      "title": "Pretende refaturar isto aos seus clientes?"
    }
  },
  "emailField": {
    "label": "E-mail",
    "placeholder": "E-mail",
    "tooltip": {
      "primary": "Primário",
      "emails": "E-mails"
    }
  },
  "attachSnapshotToggle": {
    "loadSnapshot": "Carregar instantâneo:",
    "loadSnapshotWarning": "Deseja carregar o instantâneo associado a este plano? <br /> <strong class='text-danger'>Os dados existentes podem perder-se</strong>"
  },
  "suspension": {
    "suspended": {
      "description": "Apenas os administradores/utilizadores da agência têm acesso a esta subconta. Atualmente, não tem acesso a esta subconta, assim como outros administradores/utilizadores da conta.",
      "heading": "Esta subconta foi colocada em pausa."
    },
    "temporarily": {
      "description": "Todos os seus dados estão seguros e todos os acionadores/campanhas, etc. retomarão o funcionamento após a ativação.",
      "heading": " A sua conta está temporariamente suspensa."
    }
  },
  "callerIdUpdateModal": {
    "friendlyName": "Nome amigável da empresa",
    "title": "Atualizar ID de chamadas"
  },
  "drChronoOfficeSelect": {
    "selectOffice": "Selecionar escritório",
    "whichOffice": "Que escritório pretende ligar a esta conta?",
    "connect": "Ligar!"
  },
  "phoneField": {
    "label": "Telefone",
    "placeholder": "Número de telefone",
    "tooltip": {
      "invalidNumber": "Número de telefone inválido",
      "notSmsCapable": "Este número {type} não é capaz de enviar SMS"
    }
  },
  "submissionDetail": {
    "titles": {
      "bookingDetails": "Detalhes da reserva",
      "form": "Formulário",
      "quiz": "Questionário",
      "submissionDetail": "Detalhes do envio",
      "survey": "Inquérito"
    }
  },
  "shakenStir": {
    "confirmation": {
      "description": "Pedido de registo no SHAKEN/STIR enviado. Poderá demorar até <b>3-4 dias</b> a ser aprovado. O estado será atualizado em breve.",
      "title": "Chamadas fidedignas SHAKEN/STIR ativadas."
    },
    "modal": {
      "andThe": " e o ",
      "businessProfile": "Perfil de empresa",
      "certification": "Certifico que o Perfil de empresa associado é o autor das chamadas telefónicas e certifico que participarei nos esforços de localização, incluindo os iniciados",
      "failedTitle": "Falha no envio",
      "friendlyName": "Nome amigável",
      "friendlyNamePlaceholder": "Ex: SHST 2022-11-24 às 19:47:14",
      "linkInfo": {
        "description": "Todos os números atualmente disponíveis e os números comprados no futuro serão registados automaticamente no SHAKEN/STIR.",
        "title": "Todos os números serão vinculados automaticamente"
      },
      "stiPa": "pela entidade Secure Telephony Identity Policy Administrator (STI-PA)",
      "subtitle": "Introduza os detalhes e a descrição",
      "successMessage": "Pedido de registo no SHAKEN/STIR enviado. Poderá demorar até <b>3-4 dias</b> a ser aprovado. O estado será atualizado em breve.",
      "successTitle": "Chamadas fidedignas SHAKEN/STIR ativadas.",
      "title": "Ativar a chamada de confiança SHAKEN/STIR",
      "tracebackGroup": "pelo Traceback Group da US Telecom"
    },
    "withCnam": {
      "cnamPromo": "Registe-se no CNAM para exibir o nome da sua empresa no identificador de chamadas",
      "registerCnam": "Registar CNAM"
    }
  },
  "task": {
    "2day": "2 dias",
    "3day": "3 dias",
    "4day": "4 dias",
    "5day": "5 dias",
    "addTask": "Adicionar tarefa",
    "countTasks": "{count} atividades"
  },
  "updatedProductsModal": {
    "title": "Produtos atualizados",
    "copyDirectSaleLink": "Copiar ligação de venda direta",
    "setupFeeInstruction": "A taxa de configuração pode ser configurada no painel de controlo do Stripe. ",
    "doNotDeleteWarning": "Não elimine produtos ou preços do painel de controlo do Stripe. Isso quebrará a integração."
  },
  "termsOfService": {
    "privacyLink": "Política de Privacidade",
    "accept": "Aceitar",
    "termsLink": "Termos de Serviço",
    "updateMessage": "Atualizámos os nossos Termos de Serviço e a nossa Política de Privacidade. Reveja e aceite para continuar.",
    "agreementPrefix": "Ao continuar, concorda com os nossos ",
    "agreementConjunction": " e "
  },
  "callerIdVerificationModal": {
    "answerCall": "Atenda a chamada e introduza este código de verificação:",
    "leadConnectorCalling": "O Lead Connector está a ligar...",
    "title": "Adicionar um ID de chamadas por voz",
    "waitingForVerification": "A aguardar pela verificação..."
  },
  "emailOTPModal": {
    "confirmCode": "Confirmar código",
    "resendCode": "Se não recebeu o código, clique aqui para reenviar"
  },
  "survey": {
    "copy": {
      "cancel": "Cancelar",
      "location": "Localização",
      "copy": "Copiar",
      "newSurveyName": "Nome de novo inquérito",
      "title": "Copiar inquérito",
      "locationRequired": "A localização é necessária"
    }
  },
  "stripeProductDetailsModal": {
    "productName": "Nome do produto",
    "planDetails": "Detalhes do plano",
    "title": "Detalhes do produto",
    "planId": "ID do Plano",
    "copiedToClipboard": "Copiado para a área de transferência"
  },
  "importCustomers": {
    "newExperience": {
      "efficient": "Mais eficiente",
      "faster": "Mais rápido",
      "itsText": "É",
      "smoother": "Mais suave",
      "title": "Chegou uma nova experiência de importação!",
      "warningMessage": "A ativação da experiência nova importação ativa os Labs para esta subconta e ativa a funcionalidade beta.",
      "tryNow": "Experimente agora"
    },
    "validateEmails": "Validar e-mails?"
  },
  "yext": {
    "reselling": {
      "zero": "0",
      "highlevelPrice": "Preço HighLevel",
      "howDoesItWork": "Como é que funciona?",
      "payNow": "Pague agora",
      "priceError": "O preço tem de ser igual ou superior ao preço HighLevel",
      "saving": "A guardar",
      "yourPrice": "O seu preço",
      "yourProfit": "O seu lucro",
      "subscriptionCreating": "A assinatura está a ser criada.<br/>Não recarregue nem clique no botão Voltar",
      "subscriptionCreated": "Assinatura criada com sucesso. Aguarde…",
      "unableToCreate": "Não foi possível criar a assinatura, contacte o Suporte",
      "perMonth": "por mês",
      "agreeToEnable": "Concordo em ativar os anúncios para este cliente sem realizar venda superior e reconheço que serei cobrado",
      "deployDirectly": "Implementar listagens diretamente",
      "deployDirectlyDesc": "Utilize esta opção se estiver a oferecer anúncios como parte da sua oferta ou se pretender faturar o seu cliente externamente",
      "minimumCommitment": "com um período mínimo de permanência de 1 mês.",
      "offerListings": "Listagens de Ofertas",
      "resellListings": "Revenda de anúncios",
      "subscribedInfo": "{withoutUpsell} sem realizar venda superior, {withUpsell} com realização de venda superior e {withSaas} com pacote Saas",
      "yourResellOffer": "A Sua Oferta de Revenda"
    }
  }
}
